// src/components/property-listing-header-messages/property-listing-header-messages.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
  var f,
    y,
    t,
    g,
    _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    };
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment PlainHeaderMessageFragment on EGDSPlainText {\n    __typename\n    text\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment SponsoredContentPlacementFragment on SponsoredContentPlacement {\n    productType\n    sponsoredContentContext {\n      sponsoredContentId\n      variant\n      pageName\n      targeting {\n        adults\n        dateEnd {\n          day\n          month\n          year\n        }\n        dateStart {\n          day\n          month\n          year\n        }\n        kids\n        origin\n        locationResolver\n        destination\n      }\n    }\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment PropertyListingSoldOutFragment on PropertySearchListingsSoldOutCard {\n    cardContent: content {\n      ... on EGDSStandardMessagingCard {\n        heading\n        message\n        graphic {\n          ... on Icon {\n            description\n            id\n            iconSize: size\n            theme\n            title\n            withBackground\n          }\n        }\n      }\n    }\n    actionButton {\n      ... on EGDSButton {\n        __typename\n        primary\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n    }\n    analytics {\n      event\n      referrerId\n      linkName\n    }\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment PropertyListingFlexibleDateSearchButtonFragment on FlexibleDateSearchButton {\n    button {\n      ... on UISecondaryButton {\n        primary\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n    }\n    datePeriods {\n      ... on DatePeriod {\n        length\n        unit\n        bound\n      }\n    }\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment PropertyListingFlexibleDateSearchCardFragment on FlexibleDateSearchCard {\n    cardContent: content {\n      ... on EGDSStandardMessagingCard {\n        background\n        heading\n        message\n        graphic {\n          ...UIGraphicFragment\n        }\n        impressionTracking {\n          ...ImpressionTrackingFragment\n        }\n      }\n    }\n    changeDatesButton {\n      ... on UISecondaryButton {\n        primary\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n    }\n    flexibleDateSearchButtons {\n      ...PropertyListingFlexibleDateSearchButtonFragment\n    }\n  }\n\n  fragment ImpressionTrackingFragment on ClientSideAnalytics {\n    referrerId\n    linkName\n  }\n  ", "\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment PropertyListingOverfilteredFragment on PropertySearchListingsOverfilteredCard {\n    cardContent: content {\n      ... on EGDSStandardMessagingCard {\n        heading\n        message\n      }\n    }\n    ...SearchFilterPillsFragment\n    action {\n      ...LodgingLinkButtonFragment\n    }\n    impressionAnalytics {\n      ... on ClientSideImpressionEventAnalytics {\n        event\n        referrerId\n        linkName\n      }\n    }\n  }\n\n  fragment LodgingLinkButtonFragment on LodgingLinkButton {\n    button {\n      ... on UISecondaryButton {\n        accessibility\n        disabled\n        primary\n        analytics {\n          ... on ClientSideAnalytics {\n            referrerId\n            linkName\n          }\n        }\n      }\n    }\n    action {\n      ... on UILinkAction {\n        resource {\n          ... on HttpURI {\n            value\n            relativePath\n          }\n        }\n        target\n        useRelativePath\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment PropertyListingStandardMessagingCardFragment on EGDSStandardMessagingCard {\n    graphic {\n      __typename\n      ...UIGraphicFragment\n    }\n    egdsElementId\n    heading\n    message\n    themes\n    links {\n      ...EGDSStandardLinkFragment\n    }\n    impressionTracking {\n      ...PropertyListingStandardMessagingCardAnalyticsFragment\n    }\n  }\n\n  fragment PropertyListingStandardMessagingCardAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n  ", "\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment PropertyListingExpandoCardFragment on PropertyListingsIconTextExpando {\n    graphic {\n      __typename\n      ... on Illustration {\n        link: url\n        description\n        id\n      }\n    }\n    expandoCard {\n      collapsedLabel\n      expandedLabel\n      expanded\n      subtitle\n      expandAnalytics {\n        linkName\n        referrerId\n      }\n      collapseAnalytics {\n        linkName\n        referrerId\n      }\n    }\n    expandedContent {\n      text\n      graphic {\n        __typename\n        ... on Icon {\n          id\n          description\n          token\n          size\n          theme\n        }\n      }\n    }\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment ResultsMessagingModuleFragment on PropertySearchResults {\n    summary {\n      messagingModule {\n        header {\n          ... on EGDSHeading {\n            text\n          }\n        }\n      }\n    }\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment SelectedBundleProductCardActionFragment on SelectedBundleProductCardAction {\n    ...ShoppingActionButtonFragment\n    ...ShoppingLinkFragment\n  }\n  ", "\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment SelectedBundleProductTextFragment on SelectedBundleProductText {\n    ...EGDSSpannableTextFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment SelectedBundleProductContentPrimarySectionFragment on SelectedBundleProductContentPrimarySection {\n    badge {\n      ...LodgingBadgeFragment\n    }\n    primary {\n      ...SelectedBundleProductTextFragment\n    }\n    secondary {\n      ...SelectedBundleProductTextFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment SelectedBundleProductContentSecondarySectionFragment on SelectedBundleProductContentSecondarySection {\n    primary {\n      ...SelectedBundleProductTextFragment\n    }\n    secondary {\n      ...SelectedBundleProductTextFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment SelectedBundleProductContentFragment on SelectedBundleProductContent {\n    graphics {\n      ...UIGraphicFragment\n    }\n    primarySection {\n      ...SelectedBundleProductContentPrimarySectionFragment\n    }\n    secondarySections {\n      ...SelectedBundleProductContentSecondarySectionFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment SelectedBundleProductCardFragment on SelectedBundleProductCard {\n    productContents {\n      ...SelectedBundleProductContentFragment\n    }\n    actions {\n      ...SelectedBundleProductCardActionFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment DisclaimerCardFragment on DisclaimerCard {\n    ...EGDSStandardMessagingCardFragment\n  }\n\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment SelectedBundleProductHeaderFragment on SelectedBundleProductHeader {\n    ...ShoppingLinkFragment\n    ...LodgingEGDSHeadingFragment\n  }\n  ", "\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment PackageProductCardFragment on PropertySearchResults {\n    packageProductCard {\n      ... on SelectedBundleProductWrapper {\n        header {\n          ...SelectedBundleProductHeaderFragment\n        }\n        disclaimer {\n          ...DisclaimerCardFragment\n        }\n        shoppingJoinListContainer {\n          ...ShoppingJoinListContainersFragment\n        }\n        params {\n          ...ProductActionParamFragment\n        }\n        contents {\n          ... on ShoppingProductCardContentContainer {\n            contentId\n            content {\n              ... on ShoppingProductCardSheetListContent {\n                title\n                subtitle\n                __typename\n              }\n              __typename\n            }\n          }\n        }\n        cards {\n          ...SelectedBundleProductCardFragment\n        }\n      }\n    }\n  }\n  fragment ShoppingJoinListContainersFragment on ShoppingJoinListContainer {\n    overlays {\n      ...ShoppingOverlayFragment\n    }\n    actions {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n        __typename\n      }\n      actionId\n      __typename\n      ... on ShoppingNavigateToOverlay {\n        overlayId\n      }\n      ... on ShoppingNavigateToURI {\n        resource {\n          value\n        }\n        target\n        useRelativePath\n      }\n      ... on ShoppingInvokeFunction {\n        paramsId\n        name\n        functionType\n      }\n    }\n  }\n\n  fragment ProductActionParamFragment on ShoppingProductCardFunctionParametersContainers {\n    keyValueParams {\n      key\n      value\n    }\n    paramsId\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment PriceDisplayChangeOnboardingContentFragment on PriceDisplayChangeOnboardingContent {\n    button {\n      ...ShoppingButtonFragment\n    }\n    disclaimer\n    image {\n      url\n      description\n    }\n    title\n  }\n  ", "\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment PriceDisplayChangeOnboardingFragment on PropertySearchResults {\n    summary {\n      priceDisplayChangeOnboardingAction {\n        actionId\n      }\n      shoppingJoinListContainer {\n        actions {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          actionId\n          ... on ShoppingNavigateToOverlay {\n            overlayId\n          }\n          ... on ShoppingNavigateToURI {\n            resource {\n              value\n              ... on HttpURI {\n                relativePath\n              }\n            }\n            target\n            useRelativePath\n          }\n          ... on ShoppingInvokeFunction {\n            name\n            paramsId\n            functionType\n          }\n        }\n        overlays {\n          ...ShoppingOverlayFragment\n        }\n      }\n      shoppingInvokeFunctionParams {\n        keyValueParams {\n          key\n          value\n        }\n        paramsId\n      }\n      contents {\n        content {\n          ...PriceDisplayChangeOnboardingContentFragment\n        }\n        contentId\n      }\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment ShoppingListingContainerAnalyticsFragment on ShoppingListingContainer {\n    clickstreamAnalytics {\n      ...ContainerClickstreamEventsFragment\n    }\n  }\n\n  fragment ContainerClickstreamEventsFragment on ShoppingListingContainerClickstreamEvents {\n    presented {\n      eventCategory\n      eventName\n    }\n    selected {\n      eventName\n      eventCategory\n    }\n    experienceTemplateId\n    searchId\n    eventContext {\n      type\n      id\n    }\n    additionalContext {\n      componentName\n      componentId\n      componentPosition\n      contentId\n    }\n    contentListAttributes {\n      ...ShoppingListingContentListAttributesFragment\n    }\n  }\n\n  fragment ShoppingListingContentListAttributesFragment on ShoppingListingContentListAttributes {\n    __typename\n    ... on ProductListContentEventAttributes {\n      productId\n      productLine\n    }\n    ... on DestinationListContentEventAttributes {\n      destinationGeoId\n    }\n  }\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment ContainerFormatFragment on ShoppingListingContainerFormat {\n    ...ShoppingCarouselFormatFragment\n  }\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  fragment ContainerHeadingDisclaimerFragment on LodgingPlainDialog {\n    ... on LodgingPlainDialog {\n      __typename\n      title\n      content\n      primaryUIButton {\n        __typename\n        primary\n      }\n      trigger {\n        __typename\n        icon {\n          __typename\n          id\n          title\n        }\n        clientSideAnalytics {\n          referrerId\n          linkName\n        }\n      }\n    }\n  }\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment ContainerHeadingFragment on ShoppingListingContainerHeading {\n    ...LodgingEGDSHeadingFragment\n    ... on ShoppingListingHeader {\n      title\n      subTitle\n      disclaimer {\n        ...ContainerHeadingDisclaimerFragment\n      }\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment ShoppingListingContainerFragment on ShoppingListingContainer {\n    containerHeading: heading {\n      ...ContainerHeadingFragment\n    }\n    items {\n      ...LodgingCardFragment\n      ...ShoppingSelectableImageCardFragment\n    }\n    format {\n      ...ContainerFormatFragment\n    }\n    ...ShoppingListingContainerAnalyticsFragment\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  fragment DynamicMapWrapperFragment on PropertySearchResults {\n    dynamicMap @include(if: $includeDynamicMap) {\n      mapToolbar {\n        ...MapToolbarFragment\n      }\n      autoSearchOnMapMove {\n        ...LodgingEGDSCheckboxFragment\n      }\n      action {\n        ...LodgingEGDSFloatingButtonFragment\n      }\n      adaptExSuccessEvents {\n        ...LodgingAdaptExAnalyticsEventFragment\n      }\n      adaptExAttemptEvents {\n        ...LodgingAdaptExAnalyticsEventFragment\n      }\n      filterPlacement\n      map {\n        ...DynamicMapFragment\n      }\n    }\n    propertySearchListings {\n      ...LodgingCardFragment\n      ...PropertyOverfilteredCardFragment\n    }\n  }\n\n  fragment MapToolbarFragment on MapToolbar {\n    title\n    subtitle\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject26() {
  var data = _tagged_template_literal(["\n  fragment MapTriggerWrapperFragment on PropertySearchResults {\n    mapTrigger {\n      ...MapTriggerFragment\n    }\n  }\n  ", "\n"]);
  _templateObject26 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject27() {
  var data = _tagged_template_literal(["\n  fragment PropertyListingsToastFragment on EGDSToast {\n    text\n  }\n"]);
  _templateObject27 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject28() {
  var data = _tagged_template_literal(["\n  fragment NestedListingExpandoCardContainerFragment on ShoppingListingExpandoCardContainer {\n    graphic {\n      ...UIGraphicFragment\n    }\n    expando {\n      collapsedLabel\n      expandedLabel\n      expanded\n      subtitle\n      expandAnalytics {\n        linkName\n        referrerId\n      }\n      collapseAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject28 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject29() {
  var data = _tagged_template_literal(["\n  fragment NestedListingContainerTabsLayoutFragment on EGDSBasicTabs {\n    __typename\n    tabs {\n      ... on EGDSTab {\n        tabId\n        label\n      }\n    }\n  }\n"]);
  _templateObject29 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject30() {
  var data = _tagged_template_literal(["\n  fragment NestedListingContainerLayoutFragment on NestedListingContainerLayout {\n    ...NestedListingContainerTabsLayoutFragment\n    ...NestedListingExpandoCardContainerFragment\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject30 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject31() {
  var data = _tagged_template_literal(["\n  fragment NestedListingContainerFragment on NestedListingContainer {\n    nestedContainerHeading: heading {\n      ...ContainerHeadingFragment\n    }\n    items {\n      ...ShoppingListingContainerFragment\n      ...RangeIndicatorCardFragment\n    }\n    layout {\n      ...NestedListingContainerLayoutFragment\n    }\n    impressionAnalytics {\n      linkName\n      referrerId\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject31 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject32() {
  var data = _tagged_template_literal(["\n  fragment PropertyListingDividerFragment on LodgingListingDivider {\n    title {\n      titleText: text\n      headingType\n    }\n    graphic {\n      ...UIGraphicFragment\n    }\n    impressionAnalytics {\n      event\n      referrerId\n    }\n    backgroundTheme\n  }\n\n  ", "\n"]);
  _templateObject32 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject33() {
  var data = _tagged_template_literal(["\n  fragment RecentlyViewedPropertiesCarouselWrapperFragment on RecentlyViewedPropertiesCarouselWrapper {\n    __typename\n  }\n"]);
  _templateObject33 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject34() {
  var data = _tagged_template_literal(["\n  fragment LodgingStaticMultiItemCrossSellFragment on StaticLodgingMultiItemCrossSell {\n    crossSellProductType\n    fallbackListing {\n      ...MessageResultFragment\n    }\n    multiItemSearchContext {\n      properties {\n        primary {\n          dateRange {\n            checkInDate {\n              day\n              month\n              year\n            }\n            checkOutDate {\n              day\n              month\n              year\n            }\n          }\n          destination {\n            coordinates {\n              latitude\n              longitude\n            }\n            mapBounds {\n              latitude\n              longitude\n            }\n            pinnedPropertyId\n            propertyIds\n            regionId\n            regionName\n          }\n          rooms {\n            adults\n            children {\n              age\n            }\n          }\n        }\n        secondary {\n          booleans {\n            id\n            value\n          }\n          counts {\n            id\n            value\n          }\n          dates {\n            id\n            value {\n              day\n              month\n              year\n            }\n          }\n          ranges {\n            id\n            max\n            min\n          }\n          selections {\n            id\n            value\n          }\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject34 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject35() {
  var data = _tagged_template_literal(["\n  fragment PropertySearchListingPlaceholderFragment on PropertySearchListingPlaceholder {\n    loadingComponent\n  }\n"]);
  _templateObject35 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject36() {
  var data = _tagged_template_literal(["\n  fragment ListingFragment on PropertySearchListing {\n    ...LodgingIntentCardFragment\n    ...LodgingCardFragment\n    ...LodgingHeadingFragment\n    ...LodgingStaticMultiItemCrossSellFragment\n    ...PropertyListingDividerFragment\n    ...MessageResultFragment\n    ...SponsoredContentPlacementFragment\n    ...PropertyListingSoldOutFragment\n    ...PropertyListingOverfilteredFragment\n    ...PropertyListingStandardMessagingCardFragment\n    ...PropertyListingExpandoCardFragment\n    ...SparkleBannerFragment\n    ...PropertySearchListingPlaceholderFragment\n    ...EGDSStandardMessagingCardFragment\n    ...PropertyListingFlexibleDateSearchCardFragment\n    ...RecentlyViewedPropertiesCarouselWrapperFragment\n    ...ShoppingListingContainerFragment\n    ...NestedListingContainerFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject36 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject37() {
  var data = _tagged_template_literal(["\n  fragment PropertyListingFragment on PropertySearchResults {\n    propertyListingAdaptexAnalyticsSuccessEvents {\n      ...LodgingAdaptExAnalyticsEventFragment\n    }\n    propertySearchListings {\n      ...ListingFragment\n    }\n    pagination {\n      ...PropertyListingPaginationFragment\n    }\n    propertyListingsToast {\n      ...PropertyListingsToastFragment\n    }\n    criteria {\n      primary {\n        dateRange {\n          checkInDate {\n            year\n            month\n            day\n          }\n          checkOutDate {\n            year\n            month\n            day\n          }\n        }\n        destination {\n          regionId\n          regionName\n        }\n        rooms {\n          adults\n          children {\n            age\n          }\n        }\n        flexSearchCriteria {\n          flexibility {\n            bound\n            unit\n            length\n          }\n          searchRange {\n            start {\n              year\n              month\n              day\n            }\n            end {\n              year\n              month\n              day\n            }\n          }\n          flexibleSearchRequirement\n        }\n      }\n      secondary {\n        booleans {\n          ...PropertyListingPaginationSecondaryCriteriaBooleansFragment\n        }\n        counts {\n          id\n          value\n        }\n        dates {\n          id\n          value {\n            year\n            month\n            day\n          }\n        }\n        ranges {\n          id\n          max\n          min\n        }\n        selections {\n          id\n          value\n        }\n      }\n    }\n    summary {\n      header {\n        ...LodgingHeaderFragment\n      }\n    }\n  }\n\n  fragment PropertyListingPaginationFragment on LodgingPagination {\n    paginationLabel\n    trigger {\n      __typename\n      ... on LodgingPaginationNavigationButtons {\n        previousButton {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          disabled\n          icon {\n            token\n          }\n          primary\n        }\n        nextButton {\n          accessibility\n          analytics {\n            referrerId\n            linkName\n          }\n          disabled\n          icon {\n            token\n          }\n          primary\n        }\n      }\n      ...PropertyListingPaginationTriggerUIPrimaryButtonFragment\n      ... on LodgingScrollTrigger {\n        triggerAfterPosition\n        analytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n    subSets {\n      ...PropertyListingPaginationSubSetsFragment\n    }\n  }\n\n  fragment PropertyListingPaginationSecondaryCriteriaBooleansFragment on BooleanValue {\n    id\n    value\n  }\n\n  fragment PropertyListingPaginationSubSetsFragment on LodgingPaginationSubSets {\n    nextSubSet {\n      ...PropertyListingPaginationSubSetFragment\n    }\n    previousSubset {\n      ...PropertyListingPaginationSubSetFragment\n    }\n  }\n\n  fragment PropertyListingPaginationSubSetFragment on LodgingPaginationSubSet {\n    size\n    startingIndex\n  }\n\n  fragment PropertyListingPaginationTriggerUIPrimaryButtonFragment on UIPrimaryButton {\n    analytics {\n      linkName\n      referrerId\n    }\n    action {\n      analytics {\n        linkName\n        referrerId\n      }\n      accessibility\n    }\n    accessibility\n    disabled\n    egdsElementId\n    icon {\n      description\n      id\n      title\n    }\n    primary\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject37 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject38() {
  var data = _tagged_template_literal(["\n  fragment ResultsHeadingFragment on PropertySearchResults {\n    summary {\n      resultsHeading\n    }\n  }\n"]);
  _templateObject38 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject39() {
  var data = _tagged_template_literal(["\n  fragment ProductResultsSummaryTextContentFragment on ProductResultsSummaryTextContent {\n    title\n    textList\n  }\n"]);
  _templateObject39 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject40() {
  var data = _tagged_template_literal(["\n  fragment ProductResultsSummaryContentFragment on ProductResultsSummaryContentContainer {\n    contentId\n    content {\n      __typename\n      ... on ProductResultsSummaryTextContent {\n        ...ProductResultsSummaryTextContentFragment\n      }\n      ... on PriceDisplayChangeOnboardingContent {\n        ...PriceDisplayChangeOnboardingContentFragment\n      }\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject40 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject41() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyRewardsToggleFragment on PropertyLoyaltyDiscount {\n    pointsToggle {\n      checked\n      checkedAccessibilityLabel\n      checkedDescription\n      checkedLabel\n      checkedAnalytics {\n        linkName\n        referrerId\n      }\n      uncheckedAccessibilityLabel\n      uncheckedLabel\n      uncheckedDescription\n      uncheckedAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"]);
  _templateObject41 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject42() {
  var data = _tagged_template_literal(["\n  fragment ResultsSubHeaderFragment on PropertySearchResults {\n    summary {\n      resultMessages {\n        ...ResultMessagesFragment\n      }\n      matchedPropertiesSize\n      resultsHeading\n      loyaltyInfo {\n        ...LoyaltyRewardsToggleFragment\n      }\n      shoppingJoinListContainer {\n        actions {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          actionId\n          ... on ShoppingNavigateToOverlay {\n            overlayId\n          }\n          ... on ShoppingNavigateToURI {\n            resource {\n              value\n              ... on HttpURI {\n                relativePath\n              }\n            }\n            target\n            useRelativePath\n          }\n          ... on ShoppingInvokeFunction {\n            name\n            paramsId\n            functionType\n          }\n        }\n        overlays {\n          ...ProductCardOverLayFragment\n        }\n      }\n      contents {\n        ...ProductResultsSummaryContentFragment\n      }\n    }\n  }\n\n  fragment ResultMessagesFragment on LodgingSearchResultHeaderMessage {\n    ...PlainHeaderMessageFragment\n    ...LodgingMoreInfoTriggerFragment\n    ...ShoppingLinkFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject42 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject43() {
  var data = _tagged_template_literal(["\n  fragment ShoppingSearchListingHeaderFragment on PropertySearchResults {\n    shoppingSearchListingHeader {\n      ...ShoppingListingContainerFragment\n    }\n  }\n  ", "\n"]);
  _templateObject43 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject44() {
  var data = _tagged_template_literal(["\n  query PropertyListingQuery(\n    $context: ContextInput!\n    $destination: DestinationInput!\n    $rooms: [RoomInput!]\n    $dateRange: PropertyDateRangeInput\n    $sort: PropertySort\n    $filters: PropertySearchFiltersInput\n    $marketing: PropertyMarketingInfoInput\n    $propertyShopOptions: PropertyShopOptionsInput\n    $searchPagination: PaginationInput\n    $searchIntent: SearchIntentInput\n    $shoppingContext: ShoppingContextInput\n    $criteria: PropertySearchCriteriaInput\n    $productShoppingCriteriaInput: ProductShoppingCriteriaInput\n    $returnPropertyType: Boolean = false\n    $includeDynamicMap: Boolean = false\n  ) {\n    propertySearch(\n      context: $context\n      destination: $destination\n      rooms: $rooms\n      dateRange: $dateRange\n      sort: $sort\n      filters: $filters\n      marketing: $marketing\n      propertyShopOptions: $propertyShopOptions\n      searchPagination: $searchPagination\n      searchIntent: $searchIntent\n      shoppingContext: $shoppingContext\n      criteria: $criteria\n      productShoppingCriteriaInput: $productShoppingCriteriaInput\n      returnPropertyType: $returnPropertyType\n    ) {\n      ...PropertySearchResultsFragment\n    }\n  }\n  fragment PropertySearchResultsFragment on PropertySearchResults {\n    ...PropertyListingFragment\n    ...DynamicMapWrapperFragment\n    ...ResultsSubHeaderFragment\n    ...PriceDisplayChangeOnboardingFragment\n    ...MapTriggerWrapperFragment\n    ...ResultsMessagingModuleFragment\n    ...PackageProductCardFragment\n    ...ShoppingSearchListingHeaderFragment\n    errorResponse {\n      button {\n        disabled\n      }\n    }\n    clickstream {\n      additionalEvents\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject44 = function _templateObject() {
    return data;
  };
  return data;
}
import React2 from "react";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { LodgingMoreInfoTrigger, ShoppingLink } from "@shared-ui/lodging-fragments";
import { ProductType, useProductType } from "@shared-ui/retail-product-type-providers";
import { useViewportMap, ViewSizes } from "@shared-ui/viewport-context";
// src/components/property-listing-header-messages/__private/__fragments/plain-header-message.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSText } from "@egds/react-core/text";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var fragment = gql(_templateObject());
var PlainHeaderMessage = function (param) {
  var data = param.data,
    _param_fontWeight = param.fontWeight,
    fontWeight = _param_fontWeight === void 0 ? "medium" : _param_fontWeight,
    _param_fontSize = param.fontSize,
    fontSize = _param_fontSize === void 0 ? 200 : _param_fontSize,
    align = param.align;
  return /* @__PURE__ */React.createElement(Viewport, null, /* @__PURE__ */React.createElement(ViewSmall, null, /* @__PURE__ */React.createElement(EGDSSpacing, {
    padding: {
      blockend: "one"
    }
  }, /* @__PURE__ */React.createElement(EGDSText, {
    align: align !== null && align !== void 0 ? align : "center",
    size: fontSize,
    weight: fontWeight,
    "data-stid": "results-header-message"
  }, data.text))), /* @__PURE__ */React.createElement(ViewLarge, null, /* @__PURE__ */React.createElement(EGDSSpacing, {
    padding: {
      blockend: "one"
    }
  }, /* @__PURE__ */React.createElement(EGDSText, {
    align: align !== null && align !== void 0 ? align : "left",
    size: fontSize,
    weight: fontWeight,
    "data-stid": "results-header-message"
  }, data.text))));
};
PlainHeaderMessage.fragment = fragment;
PlainHeaderMessage.displayName = "EGDSPlainText";
// src/components/property-listing-header-messages/property-listing-header-messages.tsx
var alignMap = {
  center: "center",
  left: "start"
};
var _obj;
var viewportLayoutPositionPropsMap = (_obj = {}, _define_property(_obj, ViewSizes.SMALL, {
  space: "one",
  direction: "column",
  alignItems: "center"
}), _define_property(_obj, ViewSizes.LARGE, {
  direction: "column"
}), _obj);
var PropertyListingHeaderMessages = function (param) {
  var messages = param.messages,
    _param_fontWeight = param.fontWeight,
    fontWeight = _param_fontWeight === void 0 ? "regular" : _param_fontWeight,
    _param_fontSize = param.fontSize,
    fontSize = _param_fontSize === void 0 ? 200 : _param_fontSize,
    overlayContent = param.overlayContent,
    title = param.title,
    subtitle = param.subtitle,
    alignment = param.alignment,
    isMultiItem = param.isMultiItem;
  var productLine = useProductType();
  var viewportBasedLayoutProps = useViewportMap(viewportLayoutPositionPropsMap);
  if (!messages) {
    return null;
  }
  var isLodgingOrPackages = productLine === ProductType.Lodging || isMultiItem;
  var updatedFontWeight = isLodgingOrPackages ? "bold" : fontWeight;
  return /* @__PURE__ */React2.createElement(React2.Fragment, null, messages.map(function (message, index) {
    switch (message.__typename) {
      case "EGDSPlainText":
        return /* @__PURE__ */React2.createElement(PlainHeaderMessage, {
          data: message,
          key: "header-message-".concat(index),
          fontWeight: updatedFontWeight,
          fontSize: fontSize,
          align: alignment
        });
      case "EGDSStandardLink":
        return /* @__PURE__ */React2.createElement(LodgingMoreInfoTrigger, {
          data: message,
          key: "header-message-".concat(index),
          fontWeight: updatedFontWeight,
          fontSize: fontSize,
          align: alignment
        });
      case "ShoppingLink":
        return /* @__PURE__ */React2.createElement(EGDSLayoutFlex, _object_spread_props(_object_spread({}, viewportBasedLayoutProps), {
          alignItems: alignment ? alignMap[alignment] : void 0
        }), /* @__PURE__ */React2.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React2.createElement("div", null, /* @__PURE__ */React2.createElement(ShoppingLink, {
          data: message,
          key: "header-message-".concat(index),
          inline: false,
          overlayContent: overlayContent,
          title: title,
          subtitle: subtitle,
          className: isLodgingOrPackages ? "uitk-text uitk-type-200 uitk-type-bold uitk-text-default-theme" : "uitk-text uitk-type-200 uitk-text-default-theme",
          useShoppingActionPackage: true
        }))));
      default:
        return null;
    }
  }));
};
PropertyListingHeaderMessages.displayName = "sharedui-PropertyListingHeaderMessages";
// src/components/sponsored-content-placement/sponsored-content-placement.tsx
import React4 from "react";
import { gql as gql2 } from "@apollo/client";
import { MultiListingAd } from "@shared-ui/retail-lodging-multi-listing-ad";
import { BrandResultListing } from "@shared-ui/sponsored-content-brand-result-listing";
import { DestinationExperience } from "@shared-ui/sponsored-content-destination-experience";
// src/components/sponsored-properties-carousel-wrapper/sponsored-properties-carousel-wrapper.tsx
import React3 from "react";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { useBexApi } from "@shared-ui/bex-api-context";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { SponsoredPropertiesCarousel } from "@shared-ui/retail-lodging-sponsored-properties-carousel";
import { RecommendationsModule } from "@shared-ui/retail-recommendation-module";
import { AdBlockerAware } from "@shared-ui/retail-sponsored-content-ad-block-detect-wrapper";
// src/components/sponsored-properties-carousel-wrapper/utils.ts
import { DiscoveryCardContentSize, DiscoveryContainerType, DiscoveryOfferingType, DiscoveryPriceStrategy, DiscoveryRecommendationInputContext, DiscoveryRecommendationStrategy, LineOfBusinessDomain } from "@shared-ui/retail-recommendation-module";
var breakpointsSizeMapping = {
  MOBILE_PHONE: "sm",
  APP_PHONE: "sm",
  MOBILE_TABLET: "md",
  APP_TABLET: "md",
  DESKTOP: "lg"
};
var getMinCarouselAdsSelection = function (device) {
  var itemsVisible = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    lg: 2,
    md: 2,
    sm: 1
  };
  return {
    id: "minCarouselAds",
    value: (itemsVisible[breakpointsSizeMapping[device]] + 1).toString()
  };
};
var getRecommendationModuleInput = function (criteria, context) {
  var primarySearchCriteria = criteria.primary;
  var secondarySearchCriteria = criteria.secondary;
  var dateRange = primarySearchCriteria.dateRange;
  var rooms = primarySearchCriteria === null || primarySearchCriteria === void 0 ? void 0 : primarySearchCriteria.rooms.map(function (room) {
    var _room_children;
    return _object_spread_props(_object_spread({}, room), {
      adults: room.adults,
      children: (_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.map(function (child) {
        return child.age;
      })
    });
  });
  var checkInDate = dateRange === null || dateRange === void 0 ? void 0 : dateRange.checkInDate;
  var checkOutDate = dateRange === null || dateRange === void 0 ? void 0 : dateRange.checkOutDate;
  var destination = criteria.primary.destination;
  var placeId = destination.regionId ? {
    id: destination.regionId
  } : null;
  var selections = _to_consumable_array((secondarySearchCriteria === null || secondarySearchCriteria === void 0 ? void 0 : secondarySearchCriteria.selections) || []).concat([getMinCarouselAdsSelection(context.device.type, {
    lg: 2,
    md: 2,
    sm: 1
  })]);
  var _destination_coordinates;
  var coordinates = (_destination_coordinates = destination.coordinates) !== null && _destination_coordinates !== void 0 ? _destination_coordinates : {
    latitude: 200,
    longitude: 200
  };
  return {
    configurationIdentifier: "lodging_srp:lodging_sponsored_properties",
    contentSize: DiscoveryCardContentSize.LONG_FORM_FEATURED,
    offeringType: DiscoveryOfferingType.PRODUCT,
    strategy: DiscoveryRecommendationStrategy.SPONSORED,
    containerType: DiscoveryContainerType.CAROUSEL,
    priceStrategy: DiscoveryPriceStrategy.LIVE,
    input: [DiscoveryRecommendationInputContext.DESTINATION],
    recommendationContext: {
      outputLineOfBusiness: LineOfBusinessDomain.LODGING,
      destination: {
        placeId: placeId,
        placeCoordinates: coordinates
      },
      pageId: "HS",
      lodging: {
        checkin: checkInDate,
        checkout: checkOutDate,
        rooms: rooms,
        searchCriteria: {
          selections: selections
        }
      }
    },
    placementId: "168"
  };
};
// src/components/sponsored-properties-carousel-wrapper/sponsored-properties-carousel-wrapper.tsx
var SponsoredPropertiesCarouselWrapper = function (param) {
  var criteria = param.criteria,
    itemsVisible = param.itemsVisible,
    onClickCallback = param.onClickCallback,
    onHoverChanged = param.onHoverChanged;
  var context = useBexApi().context;
  if (!criteria) {
    return null;
  }
  var recommendationModuleInput = getRecommendationModuleInput(criteria, context);
  return /* @__PURE__ */React3.createElement(Experiment, {
    name: "Web_migrate_TravelAds_SRP_Carousel_to_Recs_module"
  }, /* @__PURE__ */React3.createElement(ExperimentControl, null, /* @__PURE__ */React3.createElement(SponsoredPropertiesCarousel, {
    inputs: {
      criteria: criteria,
      shoppingContext: null
    },
    itemsVisible: itemsVisible,
    skipSsr: true,
    onClickCallback: onClickCallback,
    onHoverChanged: onHoverChanged
  })), /* @__PURE__ */React3.createElement(ExperimentVariant, {
    bucket: 1
  }, /* @__PURE__ */React3.createElement(AdBlockerAware, null, /* @__PURE__ */React3.createElement(EGDSSpacing2, {
    border: ["blockstart", "blockend"],
    padding: {
      block: "six",
      small: {
        block: "three"
      }
    },
    margin: {
      small: {
        inline: "three"
      },
      medium: {
        inline: "unset"
      }
    }
  }, /* @__PURE__ */React3.createElement(RecommendationsModule, {
    inputs: recommendationModuleInput,
    layoutOptions: {
      itemsVisible: itemsVisible
    }
  })))));
};
SponsoredPropertiesCarouselWrapper.displayName = "SponsoredPropertiesCarouselWrapper";
// src/components/sponsored-content-placement/sponsored-content-placement.tsx
var fragment2 = gql2(_templateObject1());
function stripGraphQlMetadata(obj) {
  return JSON.parse(JSON.stringify(obj, function (k, v) {
    return k.startsWith("__") ? void 0 : v;
  }));
}
var SponsoredContentPlacement = function (param) {
  var criteria = param.criteria,
    data = param.data,
    onClickCallback = param.onClickCallback,
    onHoverChanged = param.onHoverChanged;
  var productType = data.productType,
    sponsoredContentContext = data.sponsoredContentContext;
  var sponsoredContentContextInput = stripGraphQlMetadata(sponsoredContentContext);
  var searchCriteriaInput = criteria ? {
    properties: [criteria]
  } : {
    properties: null
  };
  var acceptableAdsTnL = "Acceptable_Ads_Component_Enablement";
  var shoppingCriteriaInput = {
    primarySearchCriteria: {
      property: criteria === null || criteria === void 0 ? void 0 : criteria.primary
    },
    secondaryCriteria: criteria === null || criteria === void 0 ? void 0 : criteria.secondary
  };
  var multiListingAdInput = React4.useMemo(function () {
    return {
      sponsoredContentContextInput: sponsoredContentContextInput,
      searchCriteriaInput: searchCriteriaInput
    };
  }, []);
  var brlAdInput = React4.useMemo(function () {
    return {
      sponsoredContentContext: sponsoredContentContextInput,
      shoppingCriteriaInput: shoppingCriteriaInput
    };
  }, []);
  if (sponsoredContentContextInput.targeting !== void 0) {
    switch (productType) {
      case "BRAND_RESULT_LISTING_LODGING" /* BRAND_RESULT_LISTING_LODGING */:
      case "BRAND_RESULT_LISTING" /* BRAND_RESULT_LISTING */:
        return /* @__PURE__ */React4.createElement(BrandResultListing, {
          inputs: brlAdInput,
          skipSsr: true,
          impressionOnly: false,
          rooms: criteria === null || criteria === void 0 ? void 0 : criteria.primary.rooms,
          adBlockCollapseExperiment: acceptableAdsTnL
        });
      case "MULTI_LISTING_AD" /* MULTI_LISTING_AD */:
        return /* @__PURE__ */React4.createElement(MultiListingAd, {
          inputs: multiListingAdInput,
          skipSsr: true,
          name: "featured-brand-carousel",
          onCardClickCallback: onClickCallback
        });
      case "DESTINATION_EXPERIENCE" /* DESTINATION_EXPERIENCE */:
        return /* @__PURE__ */React4.createElement(DestinationExperience, {
          inputs: {
            sponsoredContentContext: sponsoredContentContextInput
          },
          adBlockCollapseExperiment: acceptableAdsTnL,
          skipSsr: true
        });
      case "SPONSORED_PROPERTIES_CAROUSEL" /* SPONSORED_PROPERTIES_CAROUSEL */:
        {
          return /* @__PURE__ */React4.createElement(SponsoredPropertiesCarouselWrapper, {
            criteria: criteria,
            itemsVisible: {
              lg: 2,
              md: 2,
              sm: 1
            },
            onClickCallback: onClickCallback,
            onHoverChanged: onHoverChanged
          });
        }
      default:
        return null;
    }
  }
  return null;
};
SponsoredContentPlacement.fragment = fragment2;
SponsoredContentPlacement.displayName = "SponsoredContentPlacement";
// src/components/property-listing-sold-out/property-listing-sold-out.tsx
import React5 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSSecondaryButton } from "@egds/react-core/button";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSIcon } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { IntersectionTracker, useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { EGDSBadgeSizeMapper } from "@shared-ui/lodging-fragments";
var fragment3 = gql3(_templateObject2());
var Graphic = function (data) {
  switch (data === null || data === void 0 ? void 0 : data.__typename) {
    case "Icon":
      {
        var spotlight = data.withBackground ? "info" : void 0;
        var _data_title, _data_theme;
        return /* @__PURE__ */React5.createElement(EGDSIcon, {
          spotlight: spotlight,
          name: data.id,
          id: data.id,
          title: (_data_title = data === null || data === void 0 ? void 0 : data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
          theme: (_data_theme = data === null || data === void 0 ? void 0 : data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
          description: data === null || data === void 0 ? void 0 : data.description,
          size: (data === null || data === void 0 ? void 0 : data.iconSize) ? EGDSBadgeSizeMapper[data.iconSize] : void 0
        });
      }
    default:
      return null;
  }
};
var PropertyListingSoldOut = function (param) {
  var _param_data = param.data,
    cardContent = _param_data.cardContent,
    analytics = _param_data.analytics,
    actionButton = _param_data.actionButton,
    onClick = param.onClick;
  var clickTracker = useClickTracker();
  var clickChange = function () {
    if (actionButton === null || actionButton === void 0 ? void 0 : actionButton.analytics) {
      var _actionButton_analytics = actionButton.analytics,
        referrerId = _actionButton_analytics.referrerId,
        linkName = _actionButton_analytics.linkName;
      clickTracker(referrerId, linkName);
    }
    onClick === null || onClick === void 0 ? void 0 : onClick();
  };
  var propertyListingSoldOut = /* @__PURE__ */React5.createElement(EGDSSpacing3, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React5.createElement(EGDSCard, null, /* @__PURE__ */React5.createElement(EGDSSpacing3, {
    padding: {
      block: "twelve"
    }
  }, /* @__PURE__ */React5.createElement(EGDSLayoutFlex2, {
    direction: "column",
    justifyContent: "center",
    alignItems: "center"
  }, (cardContent === null || cardContent === void 0 ? void 0 : cardContent.graphic) && Graphic(cardContent.graphic), (cardContent === null || cardContent === void 0 ? void 0 : cardContent.heading) && /* @__PURE__ */React5.createElement(EGDSSpacing3, {
    margin: {
      blockstart: "six",
      blockend: "two"
    },
    padding: {
      inline: "three"
    }
  }, /* @__PURE__ */React5.createElement(EGDSHeading, {
    tag: "h3",
    size: 4,
    align: "center"
  }, cardContent.heading)), (cardContent === null || cardContent === void 0 ? void 0 : cardContent.message) && /* @__PURE__ */React5.createElement(EGDSText2, {
    size: 400
  }, cardContent.message), actionButton && /* @__PURE__ */React5.createElement(EGDSSecondaryButton, {
    onClick: clickChange
  }, actionButton.primary)))));
  var component = analytics ? /* @__PURE__ */React5.createElement(IntersectionTracker, {
    referrerId: analytics.referrerId,
    linkName: analytics.linkName || ""
  }, propertyListingSoldOut) : propertyListingSoldOut;
  return component;
};
PropertyListingSoldOut.fragment = fragment3;
PropertyListingSoldOut.displayName = "PropertyListingSoldOut";
// src/components/property-listing-flexible-date-search-card/property-listing-flexible-date-search-card.tsx
import React8 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSSecondaryButton as EGDSSecondaryButton3, UitkButtonSize } from "@egds/react-core/button";
import { EGDSCard as EGDSCard2, UitkCardBackgroundThemes } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText3 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UiGraphic } from "@shared-ui/lodging-fragments";
// src/components/property-listing-flexible-date-search-card/flexible-date-search-impression-tracking-wrapper.tsx
import React6 from "react";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
var ImpressionTrackingWrapper = function (param) {
  var impressionTracking = param.impressionTracking,
    children = param.children;
  return impressionTracking ? /* @__PURE__ */React6.createElement(IntersectionTracker2, {
    referrerId: impressionTracking.referrerId,
    linkName: impressionTracking.linkName || ""
  }, children) : /* @__PURE__ */React6.createElement(React6.Fragment, null, children);
};
// src/components/property-listing-flexible-date-search-card/property-listing-flexible-date-search-button.tsx
import React7 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSSecondaryButton as EGDSSecondaryButton2 } from "@egds/react-core/button";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var fragment4 = gql4(_templateObject3());
var PropertyListingFlexibleDateSearchButton = function (param) {
  var data = param.data,
    onFlexibleDateButtonClick = param.onFlexibleDateButtonClick;
  var button = data.button,
    datePeriods = data.datePeriods;
  var clickTracker = useClickTracker2();
  if (button && datePeriods && onFlexibleDateButtonClick) {
    var handleClick = function () {
      if (button.analytics) {
        var _button_analytics = button.analytics,
          referrerId = _button_analytics.referrerId,
          linkName = _button_analytics.linkName;
        clickTracker(referrerId, linkName);
      }
      var datePeriodInputArray = datePeriods.map(function (param) {
        var unit = param.unit,
          length = param.length,
          bound = param.bound;
        return {
          unit: unit,
          length: length,
          bound: bound
        };
      });
      onFlexibleDateButtonClick(datePeriodInputArray);
    };
    return /* @__PURE__ */React7.createElement(EGDSSpacing4, {
      margin: {
        inlinestart: "three",
        blockend: "three"
      }
    }, /* @__PURE__ */React7.createElement(EGDSSecondaryButton2, {
      onClick: handleClick
    }, button.primary));
  }
  return null;
};
PropertyListingFlexibleDateSearchButton.fragment = fragment4;
PropertyListingFlexibleDateSearchButton.displayName = "PropertyListingFlexibleDateSearchButton";
// src/components/property-listing-flexible-date-search-card/property-listing-flexible-date-search-card.tsx
var fragment5 = gql5(_templateObject4(), UiGraphic.fragment, PropertyListingFlexibleDateSearchButton.fragment);
var PropertyListingFlexibleDateSearchCard = function (param) {
  var data = param.data,
    onChangeDatesClick = param.onChangeDatesClick,
    onFlexibleDateButtonClick = param.onFlexibleDateButtonClick;
  var cardContent = data.cardContent,
    changeDatesButton = data.changeDatesButton,
    flexibleDateSearchButtons = data.flexibleDateSearchButtons;
  var clickTracker = useClickTracker3();
  var clickChangeDatesButton = function () {
    if (changeDatesButton === null || changeDatesButton === void 0 ? void 0 : changeDatesButton.analytics) {
      var _changeDatesButton_analytics = changeDatesButton.analytics,
        referrerId = _changeDatesButton_analytics.referrerId,
        linkName = _changeDatesButton_analytics.linkName;
      clickTracker(referrerId, linkName);
    }
    onChangeDatesClick === null || onChangeDatesClick === void 0 ? void 0 : onChangeDatesClick();
  };
  var _cardContent_background;
  return /* @__PURE__ */React8.createElement(ImpressionTrackingWrapper, {
    impressionTracking: cardContent === null || cardContent === void 0 ? void 0 : cardContent.impressionTracking
  }, /* @__PURE__ */React8.createElement(EGDSSpacing5, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React8.createElement(EGDSCard2, {
    backgroundTheme: (_cardContent_background = cardContent === null || cardContent === void 0 ? void 0 : cardContent.background) !== null && _cardContent_background !== void 0 ? _cardContent_background : UitkCardBackgroundThemes.SECONDARY
  }, /* @__PURE__ */React8.createElement(EGDSSpacing5, {
    padding: {
      block: "six",
      inline: "six"
    }
  }, /* @__PURE__ */React8.createElement(EGDSLayoutFlex3, {
    direction: "column",
    alignItems: "center"
  }, /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem2, null, (cardContent === null || cardContent === void 0 ? void 0 : cardContent.graphic) && /* @__PURE__ */React8.createElement(UiGraphic, {
    data: cardContent.graphic
  })), /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem2, null, (cardContent === null || cardContent === void 0 ? void 0 : cardContent.heading) && /* @__PURE__ */React8.createElement(EGDSSpacing5, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React8.createElement(EGDSHeading2, {
    size: 5,
    align: "center"
  }, cardContent.heading))), /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem2, null, (cardContent === null || cardContent === void 0 ? void 0 : cardContent.message) && /* @__PURE__ */React8.createElement(EGDSText3, {
    size: 400,
    align: "center"
  }, cardContent.message)), /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React8.createElement(EGDSSpacing5, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React8.createElement(EGDSLayoutFlex3, {
    wrap: "wrap",
    justifyContent: "center"
  }, flexibleDateSearchButtons === null || flexibleDateSearchButtons === void 0 ? void 0 : flexibleDateSearchButtons.map(function (flexibleDateSearchButton, index) {
    return /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem2, {
      key: index
    }, /* @__PURE__ */React8.createElement(PropertyListingFlexibleDateSearchButton, {
      onFlexibleDateButtonClick: onFlexibleDateButtonClick,
      data: flexibleDateSearchButton
    }));
  }), /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React8.createElement(EGDSSpacing5, {
    margin: {
      inlinestart: "three",
      blockend: "three"
    }
  }, changeDatesButton && /* @__PURE__ */React8.createElement(EGDSSecondaryButton3, {
    size: UitkButtonSize.SMALL,
    onClick: clickChangeDatesButton
  }, changeDatesButton.primary)))))))))));
};
PropertyListingFlexibleDateSearchCard.fragment = fragment5;
PropertyListingFlexibleDateSearchCard.displayName = "PropertyListingFlexibleDateSearchCard";
// src/components/property-listing-overfiltered/property-listing-overfiltered.tsx
import React9 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSSecondaryButton as EGDSSecondaryButton4 } from "@egds/react-core/button";
import { EGDSCard as EGDSCard3 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex4 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3, EGDSText as EGDSText4 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker3 } from "@shared-ui/clickstream-analytics-context";
import { SearchFilterPills } from "@shared-ui/lodging-fragments";
import { defaultViewSizes, useMediaQueries, ViewSizes as ViewSizes2 } from "@shared-ui/viewport-context";
var fragment6 = gql6(_templateObject5(), SearchFilterPills.fragment);
var PropertyListingOverfiltered = function (param) {
  var data = param.data,
    onRemoveAllFilters = param.onRemoveAllFilters,
    onFilterPillRemoval = param.onFilterPillRemoval;
  var cardContent = data.cardContent,
    impressionAnalytics = data.impressionAnalytics,
    action = data.action;
  var _ref = cardContent || {},
    heading = _ref.heading,
    description = _ref.message;
  var currentViewPortSize = useMediaQueries({
    viewSizes: defaultViewSizes
  });
  var isMobileView = currentViewPortSize <= defaultViewSizes[ViewSizes2.MEDIUM];
  var message = /* @__PURE__ */React9.createElement(React9.Fragment, null, heading ? /* @__PURE__ */React9.createElement(EGDSHeading3, {
    size: 4,
    tag: isMobileView ? "h4" : "h5",
    align: "center"
  }, heading) : null, description ? /* @__PURE__ */React9.createElement(EGDSSpacing6, {
    margin: {
      blockstart: "two",
      blockend: "one"
    }
  }, /* @__PURE__ */React9.createElement(EGDSText4, {
    size: 400
  }, description), " ") : null);
  var filterPills = /* @__PURE__ */React9.createElement(EGDSSpacing6, {
    margin: {
      blockstart: "four",
      inline: "three"
    }
  }, /* @__PURE__ */React9.createElement(EGDSLayoutFlex4, null, /* @__PURE__ */React9.createElement(SearchFilterPills, {
    data: data,
    disabled: false,
    onFilterPillRemoval: onFilterPillRemoval
  })));
  var removeAllButton = (action === null || action === void 0 ? void 0 : action.button.__typename) === "UISecondaryButton" ? /* @__PURE__ */React9.createElement(EGDSSpacing6, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React9.createElement(EGDSSecondaryButton4, {
    "data-stid": "remove-all-filters",
    onClick: function () {
      return onRemoveAllFilters === null || onRemoveAllFilters === void 0 ? void 0 : onRemoveAllFilters(action);
    }
  }, action === null || action === void 0 ? void 0 : action.button.primary)) : null;
  var propertyListingOverfiltered = /* @__PURE__ */React9.createElement("div", {
    "data-stid": "over-filtered-banner"
  }, /* @__PURE__ */React9.createElement(EGDSCard3, null, /* @__PURE__ */React9.createElement(EGDSSpacing6, {
    padding: {
      block: "six"
    }
  }, /* @__PURE__ */React9.createElement(EGDSLayoutFlex4, {
    direction: "column",
    alignItems: "center"
  }, message, filterPills, removeAllButton))));
  var WrappedComponent = impressionAnalytics ? /* @__PURE__ */React9.createElement(IntersectionTracker3, {
    referrerId: impressionAnalytics.referrerId,
    linkName: impressionAnalytics.event
  }, propertyListingOverfiltered) : propertyListingOverfiltered;
  return WrappedComponent;
};
PropertyListingOverfiltered.fragment = fragment6;
PropertyListingOverfiltered.displayName = "PropertyListingOverfiltered";
// src/components/property-listing-standard-messaging-card/property-listing-standard-messaging-card.tsx
import React10 from "react";
import { useHistory } from "react-router-dom";
import { gql as gql7 } from "@apollo/client";
import { EGDSCard as EGDSCard4 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSList, EGDSListItem } from "@egds/react-core/list";
import { EGDSHeading as EGDSHeading4, EGDSText as EGDSText5 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker4 } from "@shared-ui/clickstream-analytics-context";
import { EGDSStandardLink, UiGraphic as UiGraphic2 } from "@shared-ui/lodging-fragments";
var fragment7 = gql7(_templateObject6(), UiGraphic2.fragment, EGDSStandardLink.fragment);
var PropertyListingStandardMessagingCard = function (param) {
  var data = param.data,
    onClick = param.onClick,
    _param_showBorder = param.showBorder,
    showBorder = _param_showBorder === void 0 ? false : _param_showBorder;
  var history = useHistory();
  var graphic = data.graphic,
    heading = data.heading,
    message = data.message,
    themes = data.themes,
    links = data.links,
    impressionTracking = data.impressionTracking;
  var border = (themes === null || themes === void 0 ? void 0 : themes.includes("BORDERED" /* BORDERED */)) || showBorder;
  var handleClick = function (link) {
    var resource = link.action.resource;
    var relativePath = resource.__typename === "HttpURI" && link.action.useRelativePath && resource.relativePath;
    if (onClick) {
      onClick(data === null || data === void 0 ? void 0 : data.egdsElementId);
    } else if (relativePath) {
      history.push(relativePath);
    }
  };
  var propertyListingMessagingCard = /* @__PURE__ */React10.createElement(EGDSCard4, {
    padded: true,
    border: border
  }, /* @__PURE__ */React10.createElement(EGDSLayoutFlex5, {
    space: "three"
  }, graphic && /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem3, {
    maxWidth: "12x",
    alignSelf: "center"
  }, graphic.__typename === "Icon" ? /* @__PURE__ */React10.createElement("div", null, /* @__PURE__ */React10.createElement(UiGraphic2, {
    data: graphic
  })) : /* @__PURE__ */React10.createElement(UiGraphic2, {
    data: graphic
  })), /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem3, {
    alignSelf: "center"
  }, /* @__PURE__ */React10.createElement(EGDSLayoutFlex5, {
    direction: "column"
  }, heading && /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React10.createElement(EGDSHeading4, {
    tag: "h3",
    size: 7
  }, heading)), /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React10.createElement(EGDSText5, null, message)), links && /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React10.createElement(EGDSList, {
    bullet: "no-bullet",
    orientation: "inline"
  }, links === null || links === void 0 ? void 0 : links.map(function (linkData, linkIndex) {
    return /* @__PURE__ */React10.createElement(EGDSListItem, {
      key: linkIndex
    }, /* @__PURE__ */React10.createElement(EGDSStandardLink, {
      data: linkData,
      onClick: function () {
        return handleClick(linkData);
      }
    }));
  })))))));
  var _impressionTracking_referrerId, _impressionTracking_linkName;
  return /* @__PURE__ */React10.createElement(IntersectionTracker4, {
    referrerId: (_impressionTracking_referrerId = impressionTracking === null || impressionTracking === void 0 ? void 0 : impressionTracking.referrerId) !== null && _impressionTracking_referrerId !== void 0 ? _impressionTracking_referrerId : "",
    linkName: (_impressionTracking_linkName = impressionTracking === null || impressionTracking === void 0 ? void 0 : impressionTracking.linkName) !== null && _impressionTracking_linkName !== void 0 ? _impressionTracking_linkName : ""
  }, propertyListingMessagingCard);
};
PropertyListingStandardMessagingCard.fragment = fragment7;
PropertyListingStandardMessagingCard.displayName = "PropertyListingStandardMessagingCard";
// src/components/property-listing-expando-card/property-listing-expando-card.tsx
import React11 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSCard as EGDSCard5, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSExpandoList, EGDSExpandoListItem } from "@egds/react-core/expando";
import { EGDSIcon as EGDSIcon2, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSFigure, EGDSFigureAspectRatioType, EGDSImage } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSList as EGDSList2 } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading5, EGDSSubheading, EGDSText as EGDSText6 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
var fragment8 = gql8(_templateObject7());
var PropertyListingExpandoCard = function (param) {
  var data = param.data;
  var graphic = data.graphic,
    expandoCard = data.expandoCard,
    expandedContent = data.expandedContent;
  var track = useClickTracker4();
  var _React11_useState = _sliced_to_array(React11.useState(expandoCard ? expandoCard.expanded : false), 2),
    isVisible = _React11_useState[0],
    setIsVisible = _React11_useState[1];
  var _React11_useState1 = _sliced_to_array(React11.useState((expandoCard === null || expandoCard === void 0 ? void 0 : expandoCard.collapsedLabel) || ""), 2),
    expandoTitle = _React11_useState1[0],
    setExpandoTittle = _React11_useState1[1];
  var callback = React11.useCallback(function (id, description) {
    track(id, description);
  }, [track]);
  if (!expandoCard || !expandedContent) {
    return null;
  }
  var getTitle = function (title) {
    return /* @__PURE__ */React11.createElement(EGDSLayoutFlex6, {
      space: "three",
      alignItems: "center"
    }, (graphic === null || graphic === void 0 ? void 0 : graphic.__typename) === "Illustration" && /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem4, {
      maxWidth: "12x",
      alignSelf: "center"
    }, /* @__PURE__ */React11.createElement(EGDSFigure, {
      ratio: EGDSFigureAspectRatioType.R1_1,
      imageFit: "contain"
    }, /* @__PURE__ */React11.createElement(EGDSImage, {
      src: graphic.link,
      alt: graphic.description
    }))), /* @__PURE__ */React11.createElement(EGDSLayoutFlex6, {
      direction: "column"
    }, /* @__PURE__ */React11.createElement(EGDSText6, null, /* @__PURE__ */React11.createElement(EGDSHeading5, {
      size: 7
    }, title)), expandoCard.subtitle && /* @__PURE__ */React11.createElement(EGDSSubheading, null, expandoCard.subtitle)));
  };
  var expandoDescription = /* @__PURE__ */React11.createElement(EGDSSpacing7, {
    padding: "three",
    margin: {
      inlinestart: "three",
      blockstart: "three"
    }
  }, /* @__PURE__ */React11.createElement("div", null, /* @__PURE__ */React11.createElement(EGDSList2, {
    bullet: "icon-alternate",
    data: expandedContent.map(function (listItem) {
      return {
        content: listItem.text,
        icon: listItem.graphic.__typename === "Icon" && /* @__PURE__ */React11.createElement(EGDSText6, null, /* @__PURE__ */React11.createElement(EGDSIcon2, {
          theme: listItem.graphic.theme || void 0,
          size: EGDSIconSize[listItem.graphic.size || "SMALL"],
          name: listItem.graphic.id
        })) || void 0
      };
    })
  })));
  var handleToggle = function () {
    setIsVisible(!isVisible);
    setExpandoTittle(isVisible ? expandoCard.collapsedLabel : expandoCard.expandedLabel);
  };
  return /* @__PURE__ */React11.createElement(EGDSCard5, null, /* @__PURE__ */React11.createElement(EGDSCardContentSection, null, /* @__PURE__ */React11.createElement(EGDSExpandoList, null, /* @__PURE__ */React11.createElement(EGDSExpandoListItem, {
    isVisible: isVisible,
    isIndented: false,
    expandoTitle: getTitle(expandoTitle),
    expandoDescription: expandoDescription,
    onToggle: handleToggle,
    triggerPosition: "trailing",
    analytics: expandoCard.collapseAnalytics && expandoCard.expandAnalytics && {
      id: isVisible ? expandoCard.expandAnalytics.referrerId : expandoCard.collapseAnalytics.referrerId,
      description: isVisible ? expandoCard.expandAnalytics.linkName : expandoCard.collapseAnalytics.linkName,
      callback: callback
    } || void 0
  }))));
};
PropertyListingExpandoCard.displayName = "PropertyListingExpandoCard";
PropertyListingExpandoCard.fragment = fragment8;
// src/components/results-messaging-module/results-messaging-module.tsx
import React13 from "react";
import { gql as gql9 } from "@apollo/client";
// src/components/results-messaging-module/results-messaging-module-heading.tsx
import React12 from "react";
import { EGDSHeading as EGDSHeading6 } from "@egds/react-core/text";
import { ViewMedium, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
var ResultsMessagingModuleHeading = function (param) {
  var text = param.text;
  if (!text) {
    return null;
  }
  var headingProps = {
    tag: "h3",
    overflow: "truncate-3-lines"
  };
  return /* @__PURE__ */React12.createElement(Viewport2, null, /* @__PURE__ */React12.createElement(ViewSmall2, null, /* @__PURE__ */React12.createElement(EGDSHeading6, _object_spread_props(_object_spread({}, headingProps), {
    size: 6
  }), text)), /* @__PURE__ */React12.createElement(ViewMedium, null, /* @__PURE__ */React12.createElement(EGDSHeading6, _object_spread_props(_object_spread({}, headingProps), {
    size: 5
  }), text)));
};
ResultsMessagingModuleHeading.displayName = "ResultsMessagingModuleHeading";
// src/components/results-messaging-module/results-messaging-module.tsx
var __ResultsMessagingModuleFragment = gql9(_templateObject8());
var ResultsMessagingModule = function (param) {
  var data = param.data,
    error = param.error;
  var _data_summary_messagingModule_header, _data_summary_messagingModule;
  var text = data === null || data === void 0 ? void 0 : (_data_summary_messagingModule = data.summary.messagingModule) === null || _data_summary_messagingModule === void 0 ? void 0 : (_data_summary_messagingModule_header = _data_summary_messagingModule.header) === null || _data_summary_messagingModule_header === void 0 ? void 0 : _data_summary_messagingModule_header.text;
  if (!text || error) {
    return null;
  }
  return /* @__PURE__ */React13.createElement(ResultsMessagingModuleHeading, {
    text: text
  });
};
ResultsMessagingModule.displayName = "ResultsMessagingModule";
ResultsMessagingModule.fragment = __ResultsMessagingModuleFragment;
// src/components/package-product/package-product.tsx
import React23 from "react";
import { gql as gql18 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex9, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid4, EGDSLayoutGridItem as EGDSLayoutGridItem4 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { ShoppingActionProvider, ShoppingOverlay } from "@shared-ui/retail-shopping-tools-action-providers";
// src/components/package-product/package-product-utils.tsx
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useSessionOperations } from "@shared-ui/multi-item-operations-providers";
var callChangeSelectedProduct = function () {
  var _ref = _async_to_generator(function (changeSelectedProductCallback, context, keyValueParams) {
    var _response_data_multiItemShopping, _response_data, _getValueFromKeyValuePairs, _getValueFromKeyValuePairs1, _getValueFromKeyValuePairs2, variables, response, _response_data_multiItemShopping_changeSelectedProduct, changeSelectedProduct, redirectUrl;
    return _ts_generator(this, function (_state) {
      switch (_state.label) {
        case 0:
          if (!keyValueParams) {
            return [2];
          }
          variables = {
            context: context,
            sessionId: (_getValueFromKeyValuePairs = getValueFromKeyValuePairs(keyValueParams, "misId")) !== null && _getValueFromKeyValuePairs !== void 0 ? _getValueFromKeyValuePairs : "",
            priceToken: (_getValueFromKeyValuePairs1 = getValueFromKeyValuePairs(keyValueParams, "priceToken")) !== null && _getValueFromKeyValuePairs1 !== void 0 ? _getValueFromKeyValuePairs1 : "",
            properties: [JSON.parse((_getValueFromKeyValuePairs2 = getValueFromKeyValuePairs(keyValueParams, "propertyNaturalKeyInput")) !== null && _getValueFromKeyValuePairs2 !== void 0 ? _getValueFromKeyValuePairs2 : "")],
            changeAction: getValueFromKeyValuePairs(keyValueParams, "action")
          };
          return [4, changeSelectedProductCallback(variables, "CHANGE_SELECTED_PRODUCT")];
        case 1:
          response = _state.sent();
          changeSelectedProduct = response.success && ((_response_data_multiItemShopping_changeSelectedProduct = response === null || response === void 0 ? void 0 : (_response_data = response.data) === null || _response_data === void 0 ? void 0 : (_response_data_multiItemShopping = _response_data.multiItemShopping) === null || _response_data_multiItemShopping === void 0 ? void 0 : _response_data_multiItemShopping.changeSelectedProduct) !== null && _response_data_multiItemShopping_changeSelectedProduct !== void 0 ? _response_data_multiItemShopping_changeSelectedProduct : {});
          redirectUrl = changeSelectedProduct && "redirectUrl" in changeSelectedProduct && changeSelectedProduct.redirectUrl;
          if (redirectUrl) {
            window.location.href = redirectUrl;
          }
          return [2];
      }
    });
  });
  return function callChangeSelectedProduct(changeSelectedProductCallback, context, keyValueParams) {
    return _ref.apply(this, arguments);
  };
}();
var packgeProductInvokeFunctionCallBack = function (context, sessionOperation, name, keyValueParams) {
  if (name !== "changeSelectedProduct") {
    return;
  }
  callChangeSelectedProduct(sessionOperation.changeSelectedProduct, context, keyValueParams);
};
var getValueFromKeyValuePairs = function (keyValueParams, key) {
  var _keyValueParams_filter_;
  return keyValueParams ? (_keyValueParams_filter_ = keyValueParams.filter(function (rec) {
    return rec.key === key;
  })[0]) === null || _keyValueParams_filter_ === void 0 ? void 0 : _keyValueParams_filter_.value : null;
};
var useShoppingInvokeFunctionParams = function (params) {
  var context = useBexApi2().context;
  var sessionOperation = useSessionOperations();
  return function (functionType, name, paramsId) {
    var paramsContainer = params === null || params === void 0 ? void 0 : params.find(function (item) {
      return item.paramsId === paramsId;
    });
    packgeProductInvokeFunctionCallBack(context, sessionOperation, name, paramsContainer === null || paramsContainer === void 0 ? void 0 : paramsContainer.keyValueParams);
  };
};
// src/components/package-product/__private/bundle-product/selected-bundle-product-card.tsx
import React19 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSCard as EGDSCard6, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing8, EGDSSpacingHr } from "@egds/react-core/spacing";
// src/components/package-product/__private/bundle-product/selected-bundle-product-card-action.tsx
import React14 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkButtonSize as UitkButtonSize2 } from "@egds/react-core/button";
import { ShoppingLink as ShoppingLink2 } from "@shared-ui/lodging-fragments";
import { ShoppingActionButton } from "@shared-ui/retail-shopping-tools-action-providers";
var fragment9 = gql10(_templateObject9(), ShoppingActionButton.fragment, ShoppingLink2.fragment);
var SelectedBundleProductCardAction = function (param) {
  var data = param.data;
  switch (data.__typename) {
    case "ShoppingButton":
      return /* @__PURE__ */React14.createElement(ShoppingActionButton, {
        data: data,
        size: UitkButtonSize2.SMALL
      });
    case "ShoppingLink":
      return /* @__PURE__ */React14.createElement(ShoppingLink2, {
        data: data,
        useShoppingActionPackage: true
      });
    default:
      return null;
  }
};
SelectedBundleProductCardAction.fragment = fragment9;
SelectedBundleProductCardAction.displayName = "SelectedBundleProductCardAction";
// src/components/package-product/__private/bundle-product/selected-bundle-product-content.tsx
import React18 from "react";
import { gql as gql14 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { UiGraphic as UiGraphic3 } from "@shared-ui/lodging-fragments";
import { ViewMedium as ViewMedium2, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
// src/components/package-product/__private/bundle-product/selected-bundle-product-content-primary-section.tsx
import React16 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { LodgingBadge } from "@shared-ui/lodging-fragments";
// src/components/package-product/__private/bundle-product/selected-bundle-product-text.tsx
import React15 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSPlainText, EGDSSpannableText, EGDSStylizedText } from "@shared-ui/lodging-fragments";
var fragment10 = gql11(_templateObject10(), EGDSSpannableText.fragment, EGDSStylizedText.fragment);
var SelectedBundleProductText = function (param) {
  var data = param.data;
  switch (data.__typename) {
    case "EGDSSpannableText":
      return /* @__PURE__ */React15.createElement(EGDSSpannableText, {
        data: data,
        size: 200
      });
    case "EGDSStylizedText":
      return /* @__PURE__ */React15.createElement(EGDSStylizedText, {
        data: data,
        size: 200
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React15.createElement(EGDSPlainText, {
        data: data,
        size: 200
      });
    default:
      return null;
  }
};
SelectedBundleProductText.fragment = fragment10;
SelectedBundleProductText.displayName = "SelectedBundleProductText";
// src/components/package-product/__private/bundle-product/selected-bundle-product-content-primary-section.tsx
var fragment11 = gql12(_templateObject11(), LodgingBadge.fragment, SelectedBundleProductText.fragment);
var SelectedBundleProductContentPrimarySection = function (param) {
  var data = param.data;
  var badge = data.badge,
    primary = data.primary,
    secondary = data.secondary;
  return /* @__PURE__ */React16.createElement(React16.Fragment, null, /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React16.createElement(EGDSLayoutFlex7, {
    alignItems: "center",
    space: "two"
  }, (badge === null || badge === void 0 ? void 0 : badge.__typename) === "EGDSStandardBadge" && /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React16.createElement(LodgingBadge, {
    data: badge
  })), /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React16.createElement(EGDSLayoutFlex7, {
    alignItems: "center",
    space: "half"
  }, /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React16.createElement(SelectedBundleProductText, {
    data: primary
  })))))), secondary && /* @__PURE__ */React16.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React16.createElement(SelectedBundleProductText, {
    data: secondary
  })));
};
SelectedBundleProductContentPrimarySection.fragment = fragment11;
SelectedBundleProductContentPrimarySection.displayName = "SelectedBundleProductContentPrimarySection";
// src/components/package-product/__private/bundle-product/selected-bundle-product-content-secondary-section.tsx
import React17 from "react";
import { gql as gql13 } from "@apollo/client";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
var fragment12 = gql13(_templateObject12(), SelectedBundleProductText.fragment);
var SelectedBundleProductContentSecondarySection = function (param) {
  var data = param.data;
  var primary = data.primary,
    secondary = data.secondary;
  return /* @__PURE__ */React17.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React17.createElement(EGDSLayoutGrid, {
    space: "one",
    rows: 2
  }, /* @__PURE__ */React17.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React17.createElement(SelectedBundleProductText, {
    data: primary
  })), secondary && /* @__PURE__ */React17.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React17.createElement(SelectedBundleProductText, {
    data: secondary
  }))));
};
SelectedBundleProductContentSecondarySection.fragment = fragment12;
SelectedBundleProductContentSecondarySection.displayName = "SelectedBundleProductContentSecondarySection";
// src/components/package-product/__private/bundle-product/selected-bundle-product-content.tsx
var fragment13 = gql14(_templateObject13(), UiGraphic3.fragment, SelectedBundleProductContentPrimarySection.fragment, SelectedBundleProductContentSecondarySection.fragment);
var SelectedBundleProductContent = function (param) {
  var data = param.data;
  var graphics = data.graphics,
    primarySection = data.primarySection,
    secondarySections = data.secondarySections;
  var renderFlightPreviewContentForSmallView = /* @__PURE__ */React18.createElement(EGDSLayoutFlex8, {
    direction: "column",
    space: "one"
  }, /* @__PURE__ */React18.createElement(SelectedBundleProductContentPrimarySection, {
    data: primarySection
  }), /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React18.createElement(EGDSLayoutFlex8, {
    space: "three"
  }, graphics === null || graphics === void 0 ? void 0 : graphics.map(function (graphic, index) {
    return /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem6, {
      key: "graphic-section-".concat(index)
    }, /* @__PURE__ */React18.createElement(UiGraphic3, {
      data: graphic,
      markSize: 8
    }));
  }), /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem6, {
    grow: 1
  }, /* @__PURE__ */React18.createElement(EGDSLayoutGrid2, {
    space: "three",
    columns: 2
  }, secondarySections === null || secondarySections === void 0 ? void 0 : secondarySections.map(function (section, index) {
    return /* @__PURE__ */React18.createElement(SelectedBundleProductContentSecondarySection, {
      key: "secondary-section-".concat(index),
      data: section
    });
  }))))));
  var renderFlightPreviewContentForMediumView = /* @__PURE__ */React18.createElement(EGDSLayoutGrid2, {
    space: "three",
    columns: 2
  }, /* @__PURE__ */React18.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React18.createElement(EGDSLayoutFlex8, {
    space: "three"
  }, graphics === null || graphics === void 0 ? void 0 : graphics.map(function (graphic, index) {
    return /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem6, {
      key: "graphic-section-".concat(index)
    }, /* @__PURE__ */React18.createElement(UiGraphic3, {
      data: graphic,
      markSize: 10
    }));
  }), /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem6, {
    grow: 1
  }, /* @__PURE__ */React18.createElement(EGDSLayoutGrid2, {
    space: "one",
    rows: 2
  }, /* @__PURE__ */React18.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React18.createElement(SelectedBundleProductContentPrimarySection, {
    data: primarySection
  })))))), /* @__PURE__ */React18.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React18.createElement(EGDSLayoutGrid2, {
    space: "three",
    columns: 3
  }, secondarySections === null || secondarySections === void 0 ? void 0 : secondarySections.map(function (section, index) {
    return /* @__PURE__ */React18.createElement(SelectedBundleProductContentSecondarySection, {
      key: "secondary-section-".concat(index),
      data: section
    });
  }))));
  return /* @__PURE__ */React18.createElement(Viewport3, null, /* @__PURE__ */React18.createElement(ViewSmall3, null, renderFlightPreviewContentForSmallView), /* @__PURE__ */React18.createElement(ViewMedium2, null, renderFlightPreviewContentForMediumView));
};
SelectedBundleProductContent.fragment = fragment13;
SelectedBundleProductContent.displayName = "SelectedBundleProductContent";
// src/components/package-product/__private/bundle-product/selected-bundle-product-card.tsx
var fragment14 = gql15(_templateObject14(), SelectedBundleProductCardAction.fragment, SelectedBundleProductContent.fragment);
var SelectedBundleProductCard = function (param) {
  var data = param.data;
  var productContents = data.productContents,
    actions = data.actions;
  return /* @__PURE__ */React19.createElement(EGDSCard6, {
    backgroundTheme: "primary",
    border: true
  }, /* @__PURE__ */React19.createElement(EGDSCardContentSection2, null, productContents.map(function (productContent, index) {
    return /* @__PURE__ */React19.createElement(React19.Fragment, {
      key: "flight-preview-content-".concat(index)
    }, index > 0 && /* @__PURE__ */React19.createElement(EGDSSpacingHr, {
      blockMargin: "two"
    }), /* @__PURE__ */React19.createElement(SelectedBundleProductContent, {
      data: productContent
    }));
  }), /* @__PURE__ */React19.createElement(EGDSSpacing8, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React19.createElement(EGDSLayoutGrid3, {
    columns: 2
  }, actions === null || actions === void 0 ? void 0 : actions.map(function (action, index) {
    return /* @__PURE__ */React19.createElement(EGDSLayoutGridItem3, {
      key: "shoppingbutton-key-".concat(index)
    }, /* @__PURE__ */React19.createElement("div", null, /* @__PURE__ */React19.createElement(SelectedBundleProductCardAction, {
      data: action
    })));
  })))));
};
SelectedBundleProductCard.fragment = fragment14;
SelectedBundleProductCard.displayName = "SelectedBundleProductCard";
// src/components/package-product/__private/bundle-product-wrapper/disclaimer-card.tsx
import React20 from "react";
import { gql as gql16 } from "@apollo/client";
import { EGDSStandardMessagingCard } from "@shared-ui/lodging-fragments";
var fragment15 = gql16(_templateObject15(), EGDSStandardMessagingCard.fragment);
var DisclaimerCard = function (param) {
  var data = param.data;
  return /* @__PURE__ */React20.createElement(EGDSStandardMessagingCard, {
    data: data
  });
};
DisclaimerCard.fragment = fragment15;
DisclaimerCard.displayName = "DisclaimerCard";
// src/components/package-product/__private/bundle-product-wrapper/selected-bundle-product-header.tsx
import React22 from "react";
import { gql as gql17 } from "@apollo/client";
import { LodgingEGDSHeading, ShoppingLink as ShoppingLink4 } from "@shared-ui/lodging-fragments";
// src/components/package-product/__private/bundle-product/selected-bundle-product-header-icon.tsx
import React21 from "react";
import { EGDSSheetContent } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading7, EGDSText as EGDSText7 } from "@egds/react-core/text";
import { ShoppingLink as ShoppingLink3 } from "@shared-ui/lodging-fragments";
import { useShoppingOverlayContainer } from "@shared-ui/retail-shopping-tools-action-providers";
var SelectedBundleProductHeaderIcon = function (param) {
  var headerItem = param.headerItem,
    contents = param.contents;
  var currentOverlay = useShoppingOverlayContainer(headerItem === null || headerItem === void 0 ? void 0 : headerItem.actionId);
  var overlayContent = currentOverlay && (contents === null || contents === void 0 ? void 0 : contents.find(function (content) {
    return content.contentId === currentOverlay.contentId;
  }));
  var title = overlayContent && "title" in overlayContent.content && overlayContent.content.title;
  var subtitle = overlayContent && "subtitle" in overlayContent.content && overlayContent.content.subtitle;
  var overlayContentSheet = title && subtitle && /* @__PURE__ */React21.createElement(EGDSSpacing9, {
    padding: {
      blockend: "six",
      inlinestart: "six",
      blockstart: "six"
    }
  }, /* @__PURE__ */React21.createElement(EGDSSheetContent, {
    padded: false
  }, /* @__PURE__ */React21.createElement(EGDSHeading7, {
    size: 7,
    tag: "h2"
  }, title), /* @__PURE__ */React21.createElement(EGDSText7, {
    spacing: "two"
  }, subtitle)));
  return /* @__PURE__ */React21.createElement(ShoppingLink3, {
    data: headerItem,
    overlayContent: overlayContentSheet,
    useShoppingActionPackage: true,
    useToolbar: false
  });
};
SelectedBundleProductHeaderIcon.displayName = "SelectedBundleProductHeaderIcon";
// src/components/package-product/__private/bundle-product-wrapper/selected-bundle-product-header.tsx
var fragment16 = gql17(_templateObject16(), ShoppingLink4.fragment, LodgingEGDSHeading.fragment);
var SelectedBundleProductHeader = function (param) {
  var data = param.data,
    contents = param.contents;
  switch (data.__typename) {
    case "EGDSHeading":
      return /* @__PURE__ */React22.createElement(LodgingEGDSHeading, {
        data: data,
        size: 5,
        tag: "h3"
      });
    case "ShoppingLink":
      return /* @__PURE__ */React22.createElement(SelectedBundleProductHeaderIcon, {
        headerItem: data,
        contents: contents
      });
    default:
      return null;
  }
};
SelectedBundleProductHeader.fragment = fragment16;
SelectedBundleProductHeader.displayName = "SelectedBundleProductHeader";
// src/components/package-product/package-product.tsx
var fragment17 = gql18(_templateObject17(), SelectedBundleProductCard.fragment, ShoppingOverlay.fragment, SelectedBundleProductHeader.fragment, DisclaimerCard.fragment);
var PackageProductCard = function (param) {
  var data = param.data;
  var _data_packageProductCard;
  var _ref = (_data_packageProductCard = data.packageProductCard) !== null && _data_packageProductCard !== void 0 ? _data_packageProductCard : {},
    header = _ref.header,
    disclaimer = _ref.disclaimer,
    shoppingJoinListContainer = _ref.shoppingJoinListContainer,
    params = _ref.params,
    contents = _ref.contents,
    cards = _ref.cards;
  var shoppingInvokeFunctionCallBack = useShoppingInvokeFunctionParams(params);
  return /* @__PURE__ */React23.createElement(ShoppingActionProvider, {
    id: "package-product",
    shoppingJoinListContainer: shoppingJoinListContainer,
    shoppingInvokeFunctionCallBack: shoppingInvokeFunctionCallBack
  }, /* @__PURE__ */React23.createElement(EGDSSpacing10, {
    margin: {
      blockstart: "six",
      blockend: "three"
    }
  }, /* @__PURE__ */React23.createElement(EGDSLayoutGrid4, {
    columns: 1,
    space: "three"
  }, /* @__PURE__ */React23.createElement(EGDSLayoutGridItem4, null, /* @__PURE__ */React23.createElement(EGDSLayoutFlex9, {
    space: "one"
  }, header === null || header === void 0 ? void 0 : header.map(function (headerItem, index) {
    return /* @__PURE__ */React23.createElement(EGDSLayoutFlexItem7, {
      key: "header-part-".concat(index)
    }, /* @__PURE__ */React23.createElement(SelectedBundleProductHeader, {
      data: headerItem,
      contents: contents
    }));
  }))), /* @__PURE__ */React23.createElement(EGDSLayoutGridItem4, null, /* @__PURE__ */React23.createElement(EGDSLayoutGrid4, {
    columns: 1,
    space: "three"
  }, disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.map(function (disclaimerItem, index) {
    return /* @__PURE__ */React23.createElement(EGDSLayoutGridItem4, {
      key: "disclaimer-".concat(index)
    }, /* @__PURE__ */React23.createElement(DisclaimerCard, {
      data: disclaimerItem
    }));
  }), cards === null || cards === void 0 ? void 0 : cards.map(function (card, index) {
    return /* @__PURE__ */React23.createElement(EGDSLayoutGridItem4, {
      key: "product-card-".concat(index)
    }, /* @__PURE__ */React23.createElement(SelectedBundleProductCard, {
      data: card
    }));
  }))))));
};
PackageProductCard.fragment = fragment17;
PackageProductCard.displayName = "PackageProductCard";
// src/components/price-display-change-onboarding/price-display-change-onboarding.tsx
import React26, { useMemo } from "react";
import { gql as gql20 } from "@apollo/client";
import { ShoppingActionProvider as ShoppingActionProvider2, ShoppingOverlay as ShoppingOverlay2 } from "@shared-ui/retail-shopping-tools-action-providers";
// src/components/price-display-change-onboarding/price-display-change-onboarding-utils.tsx
var updateLocalStorage = function () {
  var _ref = _async_to_generator(function (keyValueParams) {
    var identifier, timesToShow, localStorageItem, timesToShowValue;
    return _ts_generator(this, function (_state) {
      if (!keyValueParams) {
        return [2];
      }
      identifier = getValueFromKeyValuePairs2(keyValueParams, "identifier");
      timesToShow = getValueFromKeyValuePairs2(keyValueParams, "times-to-show");
      if (!identifier) {
        return [2];
      }
      localStorageItem = localStorage.getItem(identifier);
      timesToShowValue = Number(timesToShow);
      if (localStorageItem && timesToShowValue && Number(localStorageItem) <= timesToShowValue) {
        localStorage.setItem(identifier, "".concat(Number(localStorageItem) + 1));
      } else if (timesToShowValue) {
        localStorage.setItem(identifier, "1");
      } else {
        localStorage.setItem(identifier, "true");
      }
      return [2];
    });
  });
  return function updateLocalStorage(keyValueParams) {
    return _ref.apply(this, arguments);
  };
}();
var priceDisplayChangeOnboardingInvokeFunctionCallBack = function (name, keyValueParams) {
  if (name !== "updateLocalStorage") {
    return;
  }
  updateLocalStorage(keyValueParams);
};
var getValueFromKeyValuePairs2 = function (keyValueParams, key) {
  var _keyValueParams_filter_;
  return keyValueParams ? (_keyValueParams_filter_ = keyValueParams.filter(function (rec) {
    return rec.key === key;
  })[0]) === null || _keyValueParams_filter_ === void 0 ? void 0 : _keyValueParams_filter_.value : null;
};
var useShoppingInvokeFunctionParams2 = function (params) {
  return function (functionType, name, paramsId) {
    var paramsContainer = params === null || params === void 0 ? void 0 : params.find(function (item) {
      return item.paramsId === paramsId;
    });
    priceDisplayChangeOnboardingInvokeFunctionCallBack(name, paramsContainer === null || paramsContainer === void 0 ? void 0 : paramsContainer.keyValueParams);
  };
};
// src/components/price-display-change-onboarding/__private/__fragments/price-display-change-onboarding-content.tsx
import React24 from "react";
import { gql as gql19 } from "@apollo/client";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2, EGDSImage as EGDSImage2 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex10, EGDSLayoutFlexItem as EGDSLayoutFlexItem8 } from "@egds/react-core/layout-flex";
import { EGDSSheetContent as EGDSSheetContent2 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing11 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading8, EGDSText as EGDSText8 } from "@egds/react-core/text";
import { ShoppingButton } from "@shared-ui/lodging-fragments";
import { ShoppingActionButton as ShoppingActionButton2 } from "@shared-ui/retail-shopping-tools-action-providers";
var fragment18 = gql19(_templateObject18(), ShoppingButton.fragment);
var PriceDisplayChangeOnboardingContent = function (param) {
  var data = param.data;
  if (!(data === null || data === void 0 ? void 0 : data.image)) {
    return null;
  }
  var button = data.button,
    disclaimer = data.disclaimer,
    _data_image = data.image,
    url = _data_image.url,
    description = _data_image.description,
    title = data.title;
  return /* @__PURE__ */React24.createElement(EGDSSheetContent2, null, title && /* @__PURE__ */React24.createElement(EGDSSpacing11, {
    padding: {
      blockend: "three"
    }
  }, /* @__PURE__ */React24.createElement(EGDSHeading8, {
    tag: "h1",
    size: 4
  }, title)), /* @__PURE__ */React24.createElement(EGDSSpacing11, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React24.createElement(EGDSFigure2, {
    imageFit: "contain",
    ratio: EGDSFigureAspectRatioType2.R3_2
  }, /* @__PURE__ */React24.createElement(EGDSImage2, {
    alt: description,
    src: url
  }))), disclaimer && /* @__PURE__ */React24.createElement(EGDSText8, {
    weight: "regular",
    size: 200
  }, disclaimer), button && /* @__PURE__ */React24.createElement(EGDSSpacing11, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React24.createElement(EGDSLayoutFlex10, {
    justifyContent: "center"
  }, /* @__PURE__ */React24.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React24.createElement(ShoppingActionButton2, {
    data: button,
    isFullWidth: true
  })))));
};
PriceDisplayChangeOnboardingContent.fragment = fragment18;
PriceDisplayChangeOnboardingContent.displayName = "PriceDisplayChangeOnboardingContent";
// src/components/price-display-change-onboarding/__private/price-display-change-onboarding-overlay-builder.tsx
import React25 from "react";
import { ShoppingOverlayMapper, useShoppingOverlayContainer as useShoppingOverlayContainer2 } from "@shared-ui/retail-shopping-tools-action-providers";
var PriceDisplayChangeOnboardingOverlayBuilder = function (param) {
  var actionId = param.actionId,
    summaryContents = param.summaryContents;
  var overlayContainer = useShoppingOverlayContainer2(actionId);
  if (!overlayContainer) {
    return null;
  }
  var contentId = overlayContainer.contentId;
  var priceDisplayContentContainer = summaryContents === null || summaryContents === void 0 ? void 0 : summaryContents.find(function (content) {
    return content.contentId === contentId;
  });
  if (!priceDisplayContentContainer || priceDisplayContentContainer.content.__typename !== "PriceDisplayChangeOnboardingContent") {
    return null;
  }
  return /* @__PURE__ */React25.createElement(ShoppingOverlayMapper, {
    actionId: actionId,
    renderNavigateBar: false,
    useToolbar: false,
    hasModal: true,
    tall: true,
    openOnLoad: true
  }, /* @__PURE__ */React25.createElement(PriceDisplayChangeOnboardingContent, {
    data: priceDisplayContentContainer.content
  }));
};
PriceDisplayChangeOnboardingOverlayBuilder.displayName = "PriceDisplayChangeOnboardingOverlayBuilder";
// src/components/price-display-change-onboarding/price-display-change-onboarding.tsx
var __PriceDisplayChangeOnboardingFragment = gql20(_templateObject19(), ShoppingOverlay2.fragment, PriceDisplayChangeOnboardingContent.fragment);
var PriceDisplayChangeOnboarding = function (param) {
  var data = param.data;
  var _shoppingJoinListContainer_actions;
  var _data_summary;
  var _ref = (_data_summary = data === null || data === void 0 ? void 0 : data.summary) !== null && _data_summary !== void 0 ? _data_summary : {},
    contents = _ref.contents,
    priceDisplayChangeOnboardingAction = _ref.priceDisplayChangeOnboardingAction,
    shoppingJoinListContainer = _ref.shoppingJoinListContainer,
    shoppingInvokeFunctionParams = _ref.shoppingInvokeFunctionParams;
  var updateLocalStorageAction = shoppingJoinListContainer === null || shoppingJoinListContainer === void 0 ? void 0 : (_shoppingJoinListContainer_actions = shoppingJoinListContainer.actions) === null || _shoppingJoinListContainer_actions === void 0 ? void 0 : _shoppingJoinListContainer_actions.find(function (action) {
    return action.__typename === "ShoppingInvokeFunction" && action.name === "updateLocalStorage";
  });
  var shoppingInvokeFunctionCallBack = useShoppingInvokeFunctionParams2(shoppingInvokeFunctionParams);
  var shouldShowOnboarding = useMemo(function () {
    if (shoppingInvokeFunctionParams && updateLocalStorageAction) {
      var _shoppingInvokeFunctionParams_find;
      var updateLocalStorageKeyValueParams = (_shoppingInvokeFunctionParams_find = shoppingInvokeFunctionParams.find(function (params) {
        return params.paramsId === updateLocalStorageAction.paramsId;
      })) === null || _shoppingInvokeFunctionParams_find === void 0 ? void 0 : _shoppingInvokeFunctionParams_find.keyValueParams;
      if (updateLocalStorageKeyValueParams) {
        var identifier = getValueFromKeyValuePairs2(updateLocalStorageKeyValueParams, "identifier");
        var timesToShow = getValueFromKeyValuePairs2(updateLocalStorageKeyValueParams, "times-to-show");
        if (identifier) {
          var localStorageItem = localStorage.getItem(identifier);
          if (localStorageItem) {
            return timesToShow ? Number(localStorageItem) < Number(timesToShow) : localStorageItem === "false";
          }
        }
      }
    }
    return true;
  }, [shoppingInvokeFunctionParams]);
  if ((priceDisplayChangeOnboardingAction === null || priceDisplayChangeOnboardingAction === void 0 ? void 0 : priceDisplayChangeOnboardingAction.actionId) && shouldShowOnboarding) {
    return /* @__PURE__ */React26.createElement(ShoppingActionProvider2, {
      id: "price-display-change-onboarding",
      shoppingJoinListContainer: shoppingJoinListContainer,
      shoppingInvokeFunctionCallBack: shoppingInvokeFunctionCallBack
    }, /* @__PURE__ */React26.createElement(PriceDisplayChangeOnboardingOverlayBuilder, {
      actionId: priceDisplayChangeOnboardingAction.actionId,
      summaryContents: contents
    }));
  }
  return null;
};
PriceDisplayChangeOnboarding.displayName = "PriceDisplayChangeOnboarding";
PriceDisplayChangeOnboarding.fragment = __PriceDisplayChangeOnboardingFragment;
// src/components/listing-container/shopping-listing-container.tsx
import React32, { useEffect, useMemo as useMemo2 } from "react";
import { gql as gql25 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing14 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { LodgingCard, ShoppingSelectableImageCard } from "@shared-ui/lodging-fragments";
// src/components/listing-container/container-utils.ts
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType3 } from "@egds/react-core/images";
import { LodgingCardView } from "@shared-ui/lodging-fragments";
var DESTINATION_LIST = "destination_list";
var PRODUCT_LIST = "product_list";
var CATEGORY_LIST = "category_list";
var categoryMap = function (isMweb, isNested) {
  return {
    destination_list: {
      lodgingCardOptions: {
        headingSize: {
          heading: 7
        },
        headingOverflow: "truncate"
      },
      carouselOptions: {
        itemsVisible: {
          lg: 3,
          md: 3,
          sm: 1
        },
        peekAmount: {
          sm: 142,
          md: 64,
          lg: 64
        }
      },
      headingOptions: isNested ? {
        tag: "h4",
        size: 6
      } : void 0
    },
    product_list: {
      lodgingCardOptions: {
        headingSize: {
          heading: 6,
          subHeading: 200
        },
        headingOverflow: "truncate-2-lines"
      },
      headingOptions: isNested ? {
        tag: "h4",
        size: 6
      } : void 0
    },
    category_list: {
      carouselOptions: {
        itemsVisible: {
          lg: 6,
          md: 6,
          sm: 3
        },
        peekAmount: {
          sm: 48,
          md: 48,
          lg: 48
        },
        itemsGap: {
          sm: 8,
          md: 8,
          lg: 8
        }
      },
      headingOptions: isNested ? {
        tag: "h4",
        size: 6
      } : {
        tag: isMweb ? "h5" : "h4",
        size: isMweb ? 5 : 4
      }
    }
  };
};
var getPropertiesByContainerFormatAndCategory = function (isMweb, format, category, isNested) {
  switch (format) {
    case "ShoppingCarouselFormat":
      {
        var propsByCategory = categoryMap(isMweb, isNested)[category !== null && category !== void 0 ? category : ""];
        return {
          lodgingCardOptions: _object_spread({
            view: LodgingCardView.COMPACT,
            imageRatio: EGDSFigureAspectRatioType3.R16_9,
            isOneColumnLayout: true
          }, propsByCategory === null || propsByCategory === void 0 ? void 0 : propsByCategory.lodgingCardOptions),
          carouselOptions: _object_spread({}, propsByCategory === null || propsByCategory === void 0 ? void 0 : propsByCategory.carouselOptions),
          headingOptions: _object_spread({}, propsByCategory === null || propsByCategory === void 0 ? void 0 : propsByCategory.headingOptions)
        };
      }
    default:
      return {
        lodgingCardOptions: {
          view: LodgingCardView.RESPONSIVE
        }
      };
  }
};
var getSelectedItemIndex = function (items) {
  var selectedItem = items === null || items === void 0 ? void 0 : items.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.__typename) === "ShoppingSelectableImageCard" && item.state === "SELECTED" /* SELECTED */;
  });
  return selectedItem ? items.indexOf(selectedItem) : -1;
};
// src/components/listing-container/analytics/container-analytics-utils.ts
var mapListItemAttributes = function (attribute) {
  switch (attribute.__typename) {
    case "ProductListContentEventAttributes":
      return {
        product_id: attribute.productId,
        product_line: attribute.productLine
      };
    case "DestinationListContentEventAttributes":
      return {
        destination_geo_id: attribute.destinationGeoId
      };
    default:
      return {};
  }
};
var SEARCH_PRODUCT_POSITION = "search_product_position";
var DESTINATION_POSITION = "destination_position";
var eventVersionMap = /* @__PURE__ */new Map([["destination_list.selected", "2.3.0"], ["destination_list.presented", "2.3.0"], ["destination.selected", "2.3.0"], ["destination.presented", "2.3.0"], ["product_list.presented", "1.1.0"]]);
var mapListAttributes = function (listAttributes, index) {
  var _listAttributes_;
  var isProductList = ((_listAttributes_ = listAttributes[0]) === null || _listAttributes_ === void 0 ? void 0 : _listAttributes_.__typename) === "ProductListContentEventAttributes";
  var _ref = _sliced_to_array(isProductList ? [PRODUCT_LIST, SEARCH_PRODUCT_POSITION] : [DESTINATION_LIST, DESTINATION_POSITION], 2),
    listObjectKey = _ref[0],
    positionObjectKey = _ref[1];
  var itemData = index !== void 0 && listAttributes[index];
  if (itemData) {
    var positionData = _define_property({}, positionObjectKey, index + 1);
    return _define_property({}, listObjectKey, [_object_spread({}, mapListItemAttributes(itemData), positionData)]);
  }
  return _define_property({}, listObjectKey, listAttributes.map(function (listAttribute, listAttributeIndex) {
    return _object_spread_props(_object_spread({}, mapListItemAttributes(listAttribute)), _define_property({}, positionObjectKey, listAttributeIndex + 1));
  }));
};
var LIST_SUFFIX = "_list";
var buildClickStreamEvent = function (clickstreamAnalytics, eventType, index) {
  var imageAnalytics = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
  var template_id = clickstreamAnalytics.experienceTemplateId,
    search_id = clickstreamAnalytics.searchId,
    contentListAttributes = clickstreamAnalytics.contentListAttributes,
    presented = clickstreamAnalytics.presented,
    selected = clickstreamAnalytics.selected,
    _clickstreamAnalytics_additionalContext = clickstreamAnalytics.additionalContext,
    component_name = _clickstreamAnalytics_additionalContext.componentName,
    component_id = _clickstreamAnalytics_additionalContext.componentId,
    component_position = _clickstreamAnalytics_additionalContext.componentPosition,
    content_id = _clickstreamAnalytics_additionalContext.contentId,
    eventContext = clickstreamAnalytics.eventContext;
  var clickstreamEvent = eventType === "Impression" /* IMPRESSION */ ? presented : selected;
  if (!clickstreamEvent) {
    return null;
  }
  var eventName = clickstreamEvent.eventName,
    event_category = clickstreamEvent.eventCategory;
  var isListEvent = index === void 0;
  var isDestinationList = event_category === DESTINATION_LIST;
  var event_name = isListEvent ? eventName : eventName.replace(LIST_SUFFIX, "");
  var event_version = eventVersionMap.get(event_name);
  var eventObject = {
    event: {
      event_version: event_version,
      event_type: eventType,
      event_category: event_category,
      event_name: event_name
    }
  };
  var algorithmList = eventContext.map(function (param) {
    var id = param.id,
      type = param.type;
    return {
      algorithm_id: id,
      algorithm_name: type
    };
  });
  var imageList = imageAnalytics.map(function (param, imageIndex) {
    var imageId = param.imageId,
      imageUrl = param.imageUrl;
    return _object_spread({
      gallery_position: imageIndex + 1,
      image_url: imageUrl
    }, imageId && {
      image_id: imageId
    });
  });
  var imageGallery = {
    gallery_name: "DESTINATION_CARD",
    gallery_type: "GALLERY_TYPE_SINGLE",
    gallery_max_position: imageAnalytics.length
  };
  var moduleObject = {
    module_product_line: "Lodging"
  };
  return _object_spread(_object_spread_props(_object_spread({}, eventObject), {
    additional_context: _object_spread({
      user_interface: {
        component_name: component_name,
        component_id: component_id,
        component_position: component_position,
        content_id: content_id
      },
      algorithm_list: algorithmList
    }, !isListEvent && {
      image_list: imageList,
      image_gallery: imageGallery
    })
  }), isDestinationList && {
    module: moduleObject
  }, template_id && {
    experience: {
      template_id: template_id
    }
  }, search_id && {
    search_request: {
      search_id: search_id
    }
  }, mapListAttributes(contentListAttributes, index));
};
var getImageAnalytics = function (lodgingCard) {
  var _lodgingCard_mediaSection_gallery;
  var isValidImageAnalytics = function (object) {
    return (typeof object.imageId === "string" || object.imageId === null) && typeof object.imageUrl === "string";
  };
  var _lodgingCard_mediaSection_gallery_media_map_filter;
  return (_lodgingCard_mediaSection_gallery_media_map_filter = lodgingCard === null || lodgingCard === void 0 ? void 0 : (_lodgingCard_mediaSection_gallery = lodgingCard.mediaSection.gallery) === null || _lodgingCard_mediaSection_gallery === void 0 ? void 0 : _lodgingCard_mediaSection_gallery.media.map(function (media) {
    return {
      imageId: media.id,
      imageUrl: media.media.__typename === "Image" ? media.media.url : null
    };
  }).filter(isValidImageAnalytics)) !== null && _lodgingCard_mediaSection_gallery_media_map_filter !== void 0 ? _lodgingCard_mediaSection_gallery_media_map_filter : [];
};
var buildListImpressionClickstreamEvent = function (clickstreamAnalytics) {
  return buildClickStreamEvent(clickstreamAnalytics, "Impression" /* IMPRESSION */);
};
var buildListInteractionClickStreamEvent = function (clickstreamAnalytics) {
  return buildClickStreamEvent(clickstreamAnalytics, "Interaction" /* INTERACTION */);
};
var buildListItemImpressionClickstreamEvent = function (clickstreamAnalytics, index, imageAnalytics) {
  return buildClickStreamEvent(clickstreamAnalytics, "Impression" /* IMPRESSION */, index, imageAnalytics);
};
var buildListItemInteractionClickStreamEvent = function (clickstreamAnalytics, index, imageAnalytics) {
  return buildClickStreamEvent(clickstreamAnalytics, "Interaction" /* INTERACTION */, index, imageAnalytics);
};
// src/components/listing-container/analytics/clickstream-impression-tracker.tsx
import React27 from "react";
import { EgClickstreamImpressionTracker } from "@shared-ui/clickstream-analytics-context";
var ClickstreamImpressionTracker = function (_param) {
  var children = _param.children,
    eventData = _param.eventData,
    props = _object_without_properties(_param, ["children", "eventData"]);
  if (eventData) {
    return /* @__PURE__ */React27.createElement(EgClickstreamImpressionTracker, _object_spread({
      eventData: eventData
    }, props), children);
  }
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, children);
};
// src/components/listing-container/analytics/shopping-listing-container-analytics.tsx
import React28 from "react";
import { gql as gql21 } from "@apollo/client";
var fragment19 = gql21(_templateObject20());
var ShoppingListingContainerIntersectionTracker = function (param) {
  var children = param.children,
    data = param.data;
  var clickstreamAnalytics = data.clickstreamAnalytics;
  var eventData = clickstreamAnalytics && buildListImpressionClickstreamEvent(clickstreamAnalytics);
  return /* @__PURE__ */React28.createElement(ClickstreamImpressionTracker, {
    eventData: eventData
  }, children);
};
ShoppingListingContainerIntersectionTracker.displayName = "ListingContainerIntersectionTracker";
ShoppingListingContainerIntersectionTracker.fragment = fragment19;
// src/components/listing-container/container-format.tsx
import React29 from "react";
import { gql as gql22 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing12 } from "@egds/react-core/spacing";
import { ShoppingCarousel } from "@shared-ui/lodging-fragments";
var fragment20 = gql22(_templateObject21(), ShoppingCarousel.fragment);
var ContainerFormat = function (param) {
  var data = param.data,
    children = param.children,
    carouselOptions = param.carouselOptions;
  switch (data === null || data === void 0 ? void 0 : data.__typename) {
    case "ShoppingCarouselFormat":
      return /* @__PURE__ */React29.createElement(ShoppingCarousel, _object_spread({
        data: data
      }, carouselOptions), children);
    default:
      return /* @__PURE__ */React29.createElement(React29.Fragment, null, React29.Children.map(children, function (item, itemIndex) {
        return /* @__PURE__ */React29.createElement(EGDSSpacing12, {
          key: itemIndex,
          margin: {
            blockstart: "three"
          }
        }, /* @__PURE__ */React29.createElement("div", null, item));
      }));
  }
};
ContainerFormat.fragment = fragment20;
ContainerFormat.displayName = "Container";
// src/components/listing-container/container-heading.tsx
import React31 from "react";
import { gql as gql24 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex11 } from "@egds/react-core/layout-flex";
import { EGDSHeading as EGDSHeading10, EGDSSubheading as EGDSSubheading2 } from "@egds/react-core/text";
import { LodgingEGDSHeading as LodgingEGDSHeading2 } from "@shared-ui/lodging-fragments";
// src/components/listing-container/container-heading-disclaimer.tsx
import React30, { useRef } from "react";
import { gql as gql23 } from "@apollo/client";
import { EGDSPrimaryButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon3 } from "@egds/react-core/icons";
import { EGDSMoreInfoTrigger } from "@egds/react-core/more-info-trigger";
import { EGDSSheet, EGDSSheetContent as EGDSSheetContent3, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing13 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading9, EGDSParagraph } from "@egds/react-core/text";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium3, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
var fragment21 = gql23(_templateObject22());
var ContainerHeadingDisclaimer = function (param) {
  var data = param.data;
  var _trigger_icon;
  var title = data.title,
    content = data.content,
    primaryUIButton = data.primaryUIButton,
    trigger = data.trigger;
  var trackClick = useClickTracker5();
  var triggerRef = useRef(null);
  var _useDialog = _sliced_to_array(useDialog("shopping-listing-header-disclaimer-dialog"), 3),
    isDialogOpen = _useDialog[0],
    dialogActions = _useDialog[1],
    DialogComponent = _useDialog[2];
  if (!((_trigger_icon = trigger.icon) === null || _trigger_icon === void 0 ? void 0 : _trigger_icon.id) || !(primaryUIButton === null || primaryUIButton === void 0 ? void 0 : primaryUIButton.primary)) {
    return null;
  }
  var _trigger_clientSideAnalytics;
  var _ref = (_trigger_clientSideAnalytics = trigger.clientSideAnalytics) !== null && _trigger_clientSideAnalytics !== void 0 ? _trigger_clientSideAnalytics : {},
    linkName = _ref.linkName,
    referrerId = _ref.referrerId;
  var openDialog = function () {
    dialogActions.openDialog();
    if (linkName && referrerId) {
      trackClick(referrerId, linkName);
    }
  };
  var closeDialog = function () {
    dialogActions.closeDialog();
  };
  var _trigger_icon_title;
  return /* @__PURE__ */React30.createElement(React30.Fragment, null, /* @__PURE__ */React30.createElement(EGDSSpacing13, {
    margin: {
      inlinestart: "one"
    }
  }, /* @__PURE__ */React30.createElement(EGDSMoreInfoTrigger, {
    onClick: openDialog
  }, /* @__PURE__ */React30.createElement("button", {
    type: "button"
  }, /* @__PURE__ */React30.createElement(EGDSIcon3, {
    name: trigger.icon.id,
    id: trigger.icon.id,
    title: (_trigger_icon_title = trigger.icon.title) !== null && _trigger_icon_title !== void 0 ? _trigger_icon_title : void 0
  })))), /* @__PURE__ */React30.createElement(EGDSSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React30.createElement(DialogComponent, null, /* @__PURE__ */React30.createElement(Viewport4, null, /* @__PURE__ */React30.createElement(ViewSmall4, null, /* @__PURE__ */React30.createElement(EGDSSheet, {
    type: "bottom",
    isVisible: isDialogOpen,
    triggerRef: triggerRef,
    hasModal: true
  }, /* @__PURE__ */React30.createElement(EGDSSheetContent3, null, /* @__PURE__ */React30.createElement(EGDSHeading9, null, title), content.map(function (paragraph, index) {
    return /* @__PURE__ */React30.createElement(EGDSParagraph, {
      key: index
    }, paragraph);
  }), /* @__PURE__ */React30.createElement(EGDSSpacing13, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React30.createElement(EGDSPrimaryButton, {
    isFullWidth: true,
    onClick: closeDialog
  }, primaryUIButton.primary))))), /* @__PURE__ */React30.createElement(ViewMedium3, null, /* @__PURE__ */React30.createElement(EGDSSheet, {
    type: "centered",
    centeredSheetSize: "small",
    isVisible: isDialogOpen,
    triggerRef: triggerRef
  }, /* @__PURE__ */React30.createElement(EGDSSheetContent3, null, /* @__PURE__ */React30.createElement(EGDSHeading9, null, title), content.map(function (paragraph, index) {
    return /* @__PURE__ */React30.createElement(EGDSParagraph, {
      key: index
    }, paragraph);
  }), /* @__PURE__ */React30.createElement(EGDSSpacing13, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React30.createElement(EGDSPrimaryButton, {
    onClick: closeDialog
  }, primaryUIButton.primary)))))))));
};
ContainerHeadingDisclaimer.displayName = "ContainerHeadingDisclaimer";
ContainerHeadingDisclaimer.fragment = fragment21;
// src/components/listing-container/container-heading.tsx
var fragment22 = gql24(_templateObject23(), LodgingEGDSHeading2.fragment, ContainerHeadingDisclaimer.fragment);
var ContainerHeading = function (param) {
  var data = param.data,
    tag = param.tag,
    size = param.size;
  switch (data === null || data === void 0 ? void 0 : data.__typename) {
    case "EGDSHeading":
      return /* @__PURE__ */React31.createElement(LodgingEGDSHeading2, {
        data: data,
        size: size !== null && size !== void 0 ? size : 4,
        tag: tag !== null && tag !== void 0 ? tag : "h3",
        overflow: "truncate-2-lines"
      });
    case "ShoppingListingHeader":
      return /* @__PURE__ */React31.createElement(React31.Fragment, null, /* @__PURE__ */React31.createElement(EGDSLayoutFlex11, {
        alignItems: "center"
      }, /* @__PURE__ */React31.createElement(EGDSHeading10, {
        size: size !== null && size !== void 0 ? size : 5,
        tag: tag !== null && tag !== void 0 ? tag : "h3",
        overflow: "truncate-2-lines"
      }, data.title), data.disclaimer && /* @__PURE__ */React31.createElement(ContainerHeadingDisclaimer, {
        data: data.disclaimer
      })), data.subTitle && /* @__PURE__ */React31.createElement(EGDSSubheading2, null, data.subTitle));
    default:
      return null;
  }
};
ContainerHeading.fragment = fragment22;
ContainerHeading.displayName = "Container";
// src/components/listing-container/shopping-listing-container.tsx
var fragment23 = gql25(_templateObject24(), ContainerHeading.fragment, LodgingCard.fragment, ShoppingSelectableImageCard.fragment, ContainerFormat.fragment, ShoppingListingContainerIntersectionTracker.fragment);
var ShoppingListingContainer = function (param) {
  var data = param.data,
    tmp = param.lodgingCardOptions,
    lodgingCardOptionsProp = tmp === void 0 ? {} : tmp,
    tmp1 = param.carouselOptions,
    carouselOptionsProp = tmp1 === void 0 ? {} : tmp1,
    onImageCardClickCallback = param.onImageCardClickCallback,
    containerIndex = param.containerIndex,
    isNested = param.isNested;
  var _data_clickstreamAnalytics_presented, _data_clickstreamAnalytics, _context_device, _data_clickstreamAnalytics_presented1, _data_clickstreamAnalytics1, _propsByFormatAndCategory_carouselOptions_itemsVisible, _propsByFormatAndCategory_carouselOptions;
  var containerHeading = data.containerHeading,
    items = data.items,
    format = data.format;
  var track = useEgClickstream();
  var onClickCallback = lodgingCardOptionsProp.onClickCallback,
    lazyLoadImg = lodgingCardOptionsProp.lazyLoadImg,
    fetchPriority = lodgingCardOptionsProp.fetchPriority,
    restLodgingCardOptions = _object_without_properties(lodgingCardOptionsProp, ["onClickCallback", "lazyLoadImg", "fetchPriority"]);
  var carouselType = (_data_clickstreamAnalytics = data.clickstreamAnalytics) === null || _data_clickstreamAnalytics === void 0 ? void 0 : (_data_clickstreamAnalytics_presented = _data_clickstreamAnalytics.presented) === null || _data_clickstreamAnalytics_presented === void 0 ? void 0 : _data_clickstreamAnalytics_presented.eventCategory;
  var _React32_useState = _sliced_to_array(React32.useState(getSelectedItemIndex(items)), 2),
    selectedItemIndex = _React32_useState[0],
    setselectedItemIndex = _React32_useState[1];
  var carouselRef = React32.useRef(null);
  var context = useBexApi3().context;
  var isMweb = (context === null || context === void 0 ? void 0 : (_context_device = context.device) === null || _context_device === void 0 ? void 0 : _context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */;
  var propsByFormatAndCategory = useMemo2(function () {
    var _getPropertiesByContainerFormatAndCategory;
    return (_getPropertiesByContainerFormatAndCategory = getPropertiesByContainerFormatAndCategory(isMweb, format === null || format === void 0 ? void 0 : format.__typename, carouselType, isNested)) !== null && _getPropertiesByContainerFormatAndCategory !== void 0 ? _getPropertiesByContainerFormatAndCategory : {
      lodgingCardProps: lodgingCardOptionsProp,
      carouselProps: carouselOptionsProp,
      cardWrapperOptions: {},
      headingOptions: {}
    };
  }, [format, carouselType, lodgingCardOptionsProp, carouselOptionsProp, isMweb, isNested]);
  useEffect(function () {
    if ((carouselRef === null || carouselRef === void 0 ? void 0 : carouselRef.current) && selectedItemIndex !== -1) {
      var _carouselRef_current;
      (_carouselRef_current = carouselRef.current) === null || _carouselRef_current === void 0 ? void 0 : _carouselRef_current.changeIndex(selectedItemIndex);
    }
  }, [selectedItemIndex]);
  var _React32_useMemo = _sliced_to_array(React32.useMemo(function () {
      return [carouselType === DESTINATION_LIST, {
        lodgingCardOptions: _object_spread({}, propsByFormatAndCategory.lodgingCardOptions, restLodgingCardOptions),
        carouselOptions: _object_spread({}, propsByFormatAndCategory === null || propsByFormatAndCategory === void 0 ? void 0 : propsByFormatAndCategory.carouselOptions, carouselOptionsProp)
      }];
    }, [carouselOptionsProp, (_data_clickstreamAnalytics1 = data.clickstreamAnalytics) === null || _data_clickstreamAnalytics1 === void 0 ? void 0 : (_data_clickstreamAnalytics_presented1 = _data_clickstreamAnalytics1.presented) === null || _data_clickstreamAnalytics_presented1 === void 0 ? void 0 : _data_clickstreamAnalytics_presented1.eventCategory, format === null || format === void 0 ? void 0 : format.__typename, propsByFormatAndCategory]), 2),
    useClickStreamAnalytics = _React32_useMemo[0],
    _React32_useMemo_ = _React32_useMemo[1],
    carouselOptions = _React32_useMemo_.carouselOptions,
    lodgingCardOptions = _React32_useMemo_.lodgingCardOptions;
  var onImageCardChange = React32.useCallback(function (imageCard, index) {
    setselectedItemIndex(selectedItemIndex === index ? -1 : index);
    onImageCardClickCallback === null || onImageCardClickCallback === void 0 ? void 0 : onImageCardClickCallback(imageCard);
  }, [onImageCardClickCallback, selectedItemIndex]);
  if (!data || !items || !items.length) {
    return null;
  }
  var itemSelectedAnalytics = function (index) {
    return function () {
      onClickCallback === null || onClickCallback === void 0 ? void 0 : onClickCallback();
      var item = data.items[index];
      if (useClickStreamAnalytics && data.clickstreamAnalytics && (item === null || item === void 0 ? void 0 : item.__typename) === "LodgingCard") {
        var eventData = buildListItemInteractionClickStreamEvent(data.clickstreamAnalytics, index, getImageAnalytics(item));
        if (eventData) {
          track(eventData);
        }
      }
    };
  };
  var _propsByFormatAndCategory_carouselOptions_itemsVisible_md, _ref;
  var itemsVisible = (_ref = (_propsByFormatAndCategory_carouselOptions_itemsVisible_md = (_propsByFormatAndCategory_carouselOptions = propsByFormatAndCategory.carouselOptions) === null || _propsByFormatAndCategory_carouselOptions === void 0 ? void 0 : (_propsByFormatAndCategory_carouselOptions_itemsVisible = _propsByFormatAndCategory_carouselOptions.itemsVisible) === null || _propsByFormatAndCategory_carouselOptions_itemsVisible === void 0 ? void 0 : _propsByFormatAndCategory_carouselOptions_itemsVisible.md) !== null && _propsByFormatAndCategory_carouselOptions_itemsVisible_md !== void 0 ? _propsByFormatAndCategory_carouselOptions_itemsVisible_md : format === null || format === void 0 ? void 0 : format.itemsVisible) !== null && _ref !== void 0 ? _ref : 3;
  return /* @__PURE__ */React32.createElement(ShoppingListingContainerIntersectionTracker, {
    data: data
  }, containerHeading && /* @__PURE__ */React32.createElement(EGDSSpacing14, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React32.createElement("div", null, /* @__PURE__ */React32.createElement(ContainerHeading, _object_spread({
    data: containerHeading
  }, propsByFormatAndCategory.headingOptions)))), /* @__PURE__ */React32.createElement(ContainerFormat, {
    data: format,
    carouselOptions: carouselType === CATEGORY_LIST ? _object_spread_props(_object_spread({}, propsByFormatAndCategory.carouselOptions), {
      startIndex: selectedItemIndex,
      carouselRef: carouselRef
    }) : carouselOptions
  }, items.map(function (item, index) {
    switch (item.__typename) {
      case "LodgingCard":
        {
          var shouldLazyLoad = lazyLoadImg || index > itemsVisible;
          var fetchPriorityProp = fetchPriority || (shouldLazyLoad ? "low" : "high");
          return /* @__PURE__ */React32.createElement(ClickstreamImpressionTracker, {
            eventData: useClickStreamAnalytics && data.clickstreamAnalytics ? buildListItemImpressionClickstreamEvent(data.clickstreamAnalytics, index, getImageAnalytics(item)) : null,
            trackOnce: true
          }, /* @__PURE__ */React32.createElement(LodgingCard, _object_spread_props(_object_spread({
            key: "shopping-listing-container-card-".concat(index),
            index: index,
            data: item
          }, lodgingCardOptions), {
            onClickCallback: itemSelectedAnalytics(index),
            lazyLoadImg: shouldLazyLoad,
            fetchPriority: fetchPriorityProp
          })));
        }
      case "ShoppingSelectableImageCard":
        {
          var shouldLazyLoad1 = index > itemsVisible - 1;
          var fetchPriorityProp1 = containerIndex === 0 && !shouldLazyLoad1 ? "high" : void 0;
          return /* @__PURE__ */React32.createElement(ShoppingSelectableImageCard, {
            index: index,
            data: item,
            onImageCardClick: onImageCardChange,
            lazyLoad: shouldLazyLoad1,
            selected: selectedItemIndex === index,
            key: "selectable-image-card-".concat(item.id, "-").concat(index),
            fetchPriority: fetchPriorityProp1
          });
        }
      default:
        return null;
    }
  })));
};
ShoppingListingContainer.displayName = "sharedui-ListingContainer";
ShoppingListingContainer.fragment = fragment23;
// src/components/property-listing.tsx
import React57 from "react";
import { gql as gql44, useQuery } from "@apollo/client";
import { useBexApi as useBexApi6 } from "@shared-ui/bex-api-context";
import { useSignalPublisher } from "@shared-ui/signal-events-context";
// src/components/dynamic-map-wrapper/dynamic-map-wrapper.tsx
import React33 from "react";
import { gql as gql26 } from "@apollo/client";
import { AdaptExAnalyticsEventFragment, clientSideAnalyticsFragment, LodgingCard as LodgingCard2, LodgingEGDSCheckbox, LodgingEGDSFloatingButton, LodgingEGDSIcon, lodgingUILinkActionFragment, PropertyOverfilteredCard } from "@shared-ui/lodging-fragments";
import { DynamicSearchMap } from "@shared-ui/lodging-property-search";
import { DynamicMap } from "@shared-ui/retail-dynamic-map";
var fragment24 = gql26(_templateObject25(), AdaptExAnalyticsEventFragment, clientSideAnalyticsFragment, LodgingEGDSIcon.fragment, clientSideAnalyticsFragment, lodgingUILinkActionFragment, LodgingEGDSFloatingButton.fragment, LodgingEGDSCheckbox.fragment, DynamicMap.fragment, LodgingCard2.fragment, PropertyOverfilteredCard.fragment);
var DynamicMapWrapper = function (props) {
  var data = props.data,
    variables = props.variables,
    dynamicSearchMapProps = _object_without_properties(props, ["data", "variables"]);
  var propertySearchResult = (variables === null || variables === void 0 ? void 0 : variables.includeDynamicMap) ? {
    __typename: "PropertySearchResults",
    dynamicMap: data === null || data === void 0 ? void 0 : data.dynamicMap,
    propertySearchListings: data === null || data === void 0 ? void 0 : data.propertySearchListings
  } : void 0;
  return /* @__PURE__ */React33.createElement(DynamicSearchMap, _object_spread({
    propertySearchResult: propertySearchResult,
    inputs: variables,
    height: "100%"
  }, dynamicSearchMapProps));
};
DynamicMapWrapper.displayName = "DynamicMapWrapper";
DynamicMapWrapper.fragment = fragment24;
// src/components/map-trigger-wrapper/map-trigger-wrapper.tsx
import React34 from "react";
import { gql as gql27 } from "@apollo/client";
import { fullscreenOptionsCloseMapDialogPropBuilder, MapTrigger } from "@shared-ui/lodging-fragments";
var __MapTriggerWrapperFragment = gql27(_templateObject26(), MapTrigger.fragment);
var MapTriggerWrapper = function (props) {
  var _previousData_propertySearch, _previousData_propertySearch1;
  var children = props.children,
    className = props.className,
    dialogId = props.dialogId,
    dialogQueryKey = props.dialogQueryKey,
    dialogView = props.dialogView,
    externalData = props.externalData,
    data = props.data,
    previousData = props.previousData,
    shouldUsePreviousData = props.shouldUsePreviousData;
  var _data_mapTrigger, _ref;
  var currentMapTriggerData = (_ref = (_data_mapTrigger = data === null || data === void 0 ? void 0 : data.mapTrigger) !== null && _data_mapTrigger !== void 0 ? _data_mapTrigger : externalData === null || externalData === void 0 ? void 0 : externalData.mapTrigger) !== null && _ref !== void 0 ? _ref : previousData === null || previousData === void 0 ? void 0 : (_previousData_propertySearch = previousData.propertySearch) === null || _previousData_propertySearch === void 0 ? void 0 : _previousData_propertySearch.mapTrigger;
  var mapTriggerData = shouldUsePreviousData ? previousData === null || previousData === void 0 ? void 0 : (_previousData_propertySearch1 = previousData.propertySearch) === null || _previousData_propertySearch1 === void 0 ? void 0 : _previousData_propertySearch1.mapTrigger : currentMapTriggerData;
  if (!mapTriggerData) {
    return null;
  }
  return /* @__PURE__ */React34.createElement(MapTrigger, {
    data: mapTriggerData,
    className: className,
    dialogId: dialogId,
    dialogQueryKey: dialogQueryKey,
    dialogView: dialogView,
    closeMapDialogPropBuilder: fullscreenOptionsCloseMapDialogPropBuilder
  }, children);
};
MapTriggerWrapper.displayName = "MapTriggerWrapper";
MapTriggerWrapper.fragment = __MapTriggerWrapperFragment;
// src/components/property-listing/property-listing.tsx
import React50, { useCallback as useCallback3, useEffect as useEffect3, useState as useState4 } from "react";
import LazyLoad from "react-lazy-load";
import { gql as gql37 } from "@apollo/client";
import { EGDSSecondaryButton as EGDSSecondaryButton5 } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex16, EGDSLayoutFlexItem as EGDSLayoutFlexItem11 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid6, EGDSLayoutGridItem as EGDSLayoutGridItem6, Repeat } from "@egds/react-core/layout-grid";
import { EGDSLoader } from "@egds/react-core/loader";
import { EGDSSpacing as EGDSSpacing21 } from "@egds/react-core/spacing";
import { Level, liveAnnounce } from "@egds/react-core/utils";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { AdaptExAnalyticsEventFragment as AdaptExAnalyticsEventFragment2, AdaptExEventsProvider, LodgingHeader } from "@shared-ui/lodging-fragments";
import { buildStateProvider } from "@shared-ui/provided-state-context";
import { LodgingCompare, LodgingCompareStateChunk } from "@shared-ui/retail-lodging-compare";
import { TripsToastStateChunk, ValidatedInputsState } from "@shared-ui/trips-save-item";
// src/components/property-listing-pagination/property-listing-pagination.tsx
import React36 from "react";
// src/components/property-listing-pagination/property-listing-pagination-navigation.tsx
import React35 from "react";
import { EGDSButtonSize, EGDSPrimaryButton as EGDSPrimaryButton2 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon4 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex12, EGDSLayoutFlexItem as EGDSLayoutFlexItem9 } from "@egds/react-core/layout-flex";
import { EGDSLineSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing15 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText9 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
var PropertyListingPaginationNavigation = function (param) {
  var isLoading = param.isLoading,
    onNextPage = param.onNextPage,
    onPrevPage = param.onPrevPage,
    paginationLabel = param.paginationLabel,
    pagingNextButton = param.pagingNextButton,
    pagingPrevButton = param.pagingPrevButton;
  var clickTracker = useClickTracker6();
  var _pagingPrevButton_accessibility, _pagingPrevButton_disabled, _pagingNextButton_accessibility, _pagingNextButton_disabled;
  return /* @__PURE__ */React35.createElement(EGDSLayoutFlex12, {
    "data-stid": "pagination-navigation",
    direction: "column",
    justifyContent: "center",
    alignItems: "center"
  }, /* @__PURE__ */React35.createElement(EGDSSpacing15, {
    margin: {
      blockend: "four"
    }
  }, /* @__PURE__ */React35.createElement(EGDSLayoutFlex12, {
    space: "six",
    alignItems: "center",
    justifyContent: "center"
  }, /* @__PURE__ */React35.createElement(EGDSSpacing15, {
    margin: {
      inlineend: "four"
    }
  }, /* @__PURE__ */React35.createElement(EGDSPrimaryButton2, {
    "aria-label": (_pagingPrevButton_accessibility = pagingPrevButton === null || pagingPrevButton === void 0 ? void 0 : pagingPrevButton.accessibility) !== null && _pagingPrevButton_accessibility !== void 0 ? _pagingPrevButton_accessibility : "",
    "data-stid": "previous-button",
    disabled: !pagingPrevButton || isLoading || ((_pagingPrevButton_disabled = pagingPrevButton === null || pagingPrevButton === void 0 ? void 0 : pagingPrevButton.disabled) !== null && _pagingPrevButton_disabled !== void 0 ? _pagingPrevButton_disabled : false),
    onClick: function () {
      var _pagingPrevButton_analytics, _pagingPrevButton_analytics1;
      onPrevPage();
      var _pagingPrevButton_analytics_referrerId, _pagingPrevButton_analytics_linkName;
      clickTracker((_pagingPrevButton_analytics_referrerId = pagingPrevButton === null || pagingPrevButton === void 0 ? void 0 : (_pagingPrevButton_analytics = pagingPrevButton.analytics) === null || _pagingPrevButton_analytics === void 0 ? void 0 : _pagingPrevButton_analytics.referrerId) !== null && _pagingPrevButton_analytics_referrerId !== void 0 ? _pagingPrevButton_analytics_referrerId : "", (_pagingPrevButton_analytics_linkName = pagingPrevButton === null || pagingPrevButton === void 0 ? void 0 : (_pagingPrevButton_analytics1 = pagingPrevButton.analytics) === null || _pagingPrevButton_analytics1 === void 0 ? void 0 : _pagingPrevButton_analytics1.linkName) !== null && _pagingPrevButton_analytics_linkName !== void 0 ? _pagingPrevButton_analytics_linkName : "");
    },
    size: EGDSButtonSize.MEDIUM,
    type: "button"
  }, /* @__PURE__ */React35.createElement(EGDSIcon4, {
    name: "chevron_left"
  }))), isLoading ? /* @__PURE__ */React35.createElement(EGDSLayoutFlexItem9, {
    minWidth: 12,
    shrink: 0
  }, /* @__PURE__ */React35.createElement(EGDSLineSkeleton, {
    type: "secondary"
  })) : paginationLabel && /* @__PURE__ */React35.createElement(EGDSText9, {
    size: 300,
    weight: "regular"
  }, paginationLabel), /* @__PURE__ */React35.createElement(EGDSSpacing15, {
    margin: {
      inlinestart: "four"
    }
  }, /* @__PURE__ */React35.createElement(EGDSPrimaryButton2, {
    "aria-label": (_pagingNextButton_accessibility = pagingNextButton === null || pagingNextButton === void 0 ? void 0 : pagingNextButton.accessibility) !== null && _pagingNextButton_accessibility !== void 0 ? _pagingNextButton_accessibility : "",
    "data-stid": "next-button",
    disabled: !pagingNextButton || isLoading || ((_pagingNextButton_disabled = pagingNextButton === null || pagingNextButton === void 0 ? void 0 : pagingNextButton.disabled) !== null && _pagingNextButton_disabled !== void 0 ? _pagingNextButton_disabled : false),
    onClick: function () {
      var _pagingNextButton_analytics, _pagingNextButton_analytics1;
      onNextPage();
      var _pagingNextButton_analytics_referrerId, _pagingNextButton_analytics_linkName;
      clickTracker((_pagingNextButton_analytics_referrerId = pagingNextButton === null || pagingNextButton === void 0 ? void 0 : (_pagingNextButton_analytics = pagingNextButton.analytics) === null || _pagingNextButton_analytics === void 0 ? void 0 : _pagingNextButton_analytics.referrerId) !== null && _pagingNextButton_analytics_referrerId !== void 0 ? _pagingNextButton_analytics_referrerId : "", (_pagingNextButton_analytics_linkName = pagingNextButton === null || pagingNextButton === void 0 ? void 0 : (_pagingNextButton_analytics1 = pagingNextButton.analytics) === null || _pagingNextButton_analytics1 === void 0 ? void 0 : _pagingNextButton_analytics1.linkName) !== null && _pagingNextButton_analytics_linkName !== void 0 ? _pagingNextButton_analytics_linkName : "");
    },
    size: EGDSButtonSize.MEDIUM,
    type: "button"
  }, /* @__PURE__ */React35.createElement(EGDSIcon4, {
    name: "chevron_right"
  }))))));
};
PropertyListingPaginationNavigation.displayName = "sharedui-PaginationNavigation";
// src/components/property-listing-pagination/property-listing-pagination.tsx
var refreshAds = function () {
  if (document && CustomEvent && typeof document.dispatchEvent === "function") {
    document.dispatchEvent(new CustomEvent("mesoTriggeredRefresh", {
      detail: {
        type: "impressionRefresh"
      }
    }));
  }
};
var PropertyListingPagination = function (param) {
  var handlePagination = param.handlePagination,
    isLoading = param.isLoading,
    pagination = param.pagination,
    onPaginationNext = param.onPaginationNext,
    onPaginationPrev = param.onPaginationPrev,
    showPagination = param.showPagination;
  var _pagination_trigger;
  var handleNewPage = function (startingIndex) {
    refreshAds();
    handlePagination(startingIndex);
  };
  var handleNext = function (startingIndex) {
    if (showPagination) {
      onPaginationNext === null || onPaginationNext === void 0 ? void 0 : onPaginationNext();
    } else {
      handleNewPage(startingIndex);
    }
  };
  var handlePrev = function (startingIndex) {
    if (showPagination) {
      onPaginationPrev === null || onPaginationPrev === void 0 ? void 0 : onPaginationPrev();
    } else {
      handleNewPage(startingIndex);
    }
  };
  if ((pagination === null || pagination === void 0 ? void 0 : (_pagination_trigger = pagination.trigger) === null || _pagination_trigger === void 0 ? void 0 : _pagination_trigger.__typename) !== "LodgingPaginationNavigationButtons") {
    return null;
  }
  var _pagination_paginationLabel;
  return /* @__PURE__ */React36.createElement(PropertyListingPaginationNavigation, {
    isLoading: isLoading,
    onNextPage: function () {
      var _pagination_subSets_nextSubSet, _pagination_subSets;
      return handleNext((_pagination_subSets = pagination.subSets) === null || _pagination_subSets === void 0 ? void 0 : (_pagination_subSets_nextSubSet = _pagination_subSets.nextSubSet) === null || _pagination_subSets_nextSubSet === void 0 ? void 0 : _pagination_subSets_nextSubSet.startingIndex);
    },
    onPrevPage: function () {
      var _pagination_subSets_previousSubset, _pagination_subSets;
      return handlePrev((_pagination_subSets = pagination.subSets) === null || _pagination_subSets === void 0 ? void 0 : (_pagination_subSets_previousSubset = _pagination_subSets.previousSubset) === null || _pagination_subSets_previousSubset === void 0 ? void 0 : _pagination_subSets_previousSubset.startingIndex);
    },
    paginationLabel: (_pagination_paginationLabel = pagination.paginationLabel) !== null && _pagination_paginationLabel !== void 0 ? _pagination_paginationLabel : "",
    pagingNextButton: pagination.trigger.nextButton,
    pagingPrevButton: pagination.trigger.previousButton
  });
};
PropertyListingPagination.displayName = "sharedui-PropertyListingPagination";
// src/components/property-listing/__private/__fragments/property-listing-toast.tsx
import React37 from "react";
import { gql as gql28 } from "@apollo/client";
import { EGDSToast } from "@egds/react-core/toast";
import { IntersectionTracker as IntersectionTracker5 } from "@shared-ui/clickstream-analytics-context";
var TEST_ID = "property-listing-toast";
var RFRR_ID = "HOT.SR.PreApplyFilterMessage.Viewed";
var LINK_NAME = "Pre apply filter message viewed";
var fragment25 = gql28(_templateObject27());
var PropertyListingsToast = function (param) {
  var data = param.data,
    hideListingToast = param.hideListingToast,
    autoHideTimer = param.autoHideTimer;
  return /* @__PURE__ */React37.createElement("div", {
    "data-stid": TEST_ID
  }, /* @__PURE__ */React37.createElement(IntersectionTracker5, {
    referrerId: RFRR_ID,
    linkName: LINK_NAME
  }, /* @__PURE__ */React37.createElement(EGDSToast, {
    show: true,
    onDismiss: hideListingToast,
    autoHideTimer: autoHideTimer || 4e3
  }, data === null || data === void 0 ? void 0 : data.text)));
};
PropertyListingsToast.fragment = fragment25;
PropertyListingsToast.displayName = "PropertyListingsToast";
// src/components/property-listing/__private/listing.tsx
import React47, { useState as useState3 } from "react";
import { gql as gql36 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing18 } from "@egds/react-core/spacing";
import { EGDSStandardMessagingCard as EGDSStandardMessagingCard2, LodgingCard as LodgingCard3, LodgingCardView as LodgingCardView2, LodgingHeading, LodgingIntentCard, MessageResult as MessageResult2, SparkleBanner, ThemeCardWrapper } from "@shared-ui/lodging-fragments";
import { useViewportMap as useViewportMap2, ViewMedium as ViewMedium4, Viewport as Viewport5, ViewSizes as ViewSizes3, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
// src/components/nested-listing-container/nested-listing-container.tsx
import React41 from "react";
import { gql as gql31 } from "@apollo/client";
import { IntersectionTrackerWrapper, ShoppingRangeIndicatorCard as ShoppingRangeIndicatorCard2 } from "@shared-ui/lodging-fragments";
// src/components/nested-listing-container/nested-listing-container-layout.tsx
import React40, { useCallback, useRef as useRef2, useState } from "react";
import { gql as gql30 } from "@apollo/client";
import { EGDSTab, EGDSTabs, EGDSTabsBackGroundColorType, EGDSTabsType } from "@egds/react-core/tabs";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
// src/components/nested-listing-container/nested-listing-container-item.tsx
import React38 from "react";
import { ShoppingRangeIndicatorCard } from "@shared-ui/lodging-fragments";
var NestedListingContainerItem = function (param) {
  var data = param.data,
    lodgingCardOptions = param.lodgingCardOptions;
  var __typename = data.__typename;
  switch (__typename) {
    case "ShoppingListingContainer":
      return /* @__PURE__ */React38.createElement(ShoppingListingContainer, {
        data: data,
        lodgingCardOptions: lodgingCardOptions,
        isNested: true
      });
    case "ShoppingRangeIndicatorCard":
      return /* @__PURE__ */React38.createElement(ShoppingRangeIndicatorCard, {
        data: data
      });
    default:
      return null;
  }
};
// src/components/nested-listing-container/nested-listing-expando-card-container.tsx
import React39 from "react";
import { gql as gql29 } from "@apollo/client";
import { EGDSCard as EGDSCard7, EGDSCardContentSection as EGDSCardContentSection3 } from "@egds/react-core/cards";
import { EGDSExpandoList as EGDSExpandoList2, EGDSExpandoListItem as EGDSExpandoListItem2 } from "@egds/react-core/expando";
import { EGDSLayoutFlex as EGDSLayoutFlex13, EGDSLayoutFlexItem as EGDSLayoutFlexItem10, UitkLayoutFlex } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText10 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { UiGraphic as UiGraphic4 } from "@shared-ui/lodging-fragments";
var fragment26 = gql29(_templateObject28(), UiGraphic4.fragment);
var NestedListingExpandoCardContainer = function (param) {
  var data = param.data,
    items = param.items,
    lodgingCardOptions = param.lodgingCardOptions;
  var graphic = data.graphic,
    expando = data.expando;
  var expanded = expando.expanded,
    collapseAnalytics = expando.collapseAnalytics,
    expandAnalytics = expando.expandAnalytics,
    expandedLabel = expando.expandedLabel,
    collapsedLabel = expando.collapsedLabel,
    subtitle = expando.subtitle;
  var _React39_useState = _sliced_to_array(React39.useState(expanded), 2),
    isExpanded = _React39_useState[0],
    setIsExpanded = _React39_useState[1];
  var track = useClickTracker7();
  var expandoTitle = isExpanded ? expandedLabel : collapsedLabel;
  var analytics = React39.useMemo(function () {
    return collapseAnalytics && expandAnalytics && {
      id: isExpanded ? expandAnalytics.referrerId : collapseAnalytics.referrerId,
      description: isExpanded ? expandAnalytics.linkName : collapseAnalytics.linkName,
      callback: function (id, description) {
        return track(id, description);
      }
    } || void 0;
  }, [expando, isExpanded, track]);
  if (!(items === null || items === void 0 ? void 0 : items.length)) {
    return null;
  }
  var handleToggle = function () {
    setIsExpanded(!isExpanded);
  };
  var titleElement = /* @__PURE__ */React39.createElement(EGDSLayoutFlex13, {
    space: "three",
    alignItems: "center"
  }, graphic && /* @__PURE__ */React39.createElement(EGDSLayoutFlexItem10, {
    maxWidth: "12x"
  }, /* @__PURE__ */React39.createElement(UiGraphic4, {
    data: graphic
  })), /* @__PURE__ */React39.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */React39.createElement(EGDSLayoutFlex13, {
    direction: "column",
    space: "half"
  }, /* @__PURE__ */React39.createElement(EGDSText10, {
    weight: "medium",
    size: 400
  }, expandoTitle), subtitle && /* @__PURE__ */React39.createElement(EGDSText10, null, subtitle))));
  var descriptionElement = /* @__PURE__ */React39.createElement(UitkLayoutFlex, {
    space: "six",
    direction: "column"
  }, items.map(function (item, index) {
    return /* @__PURE__ */React39.createElement(NestedListingContainerItem, {
      key: index,
      data: item,
      lodgingCardOptions: lodgingCardOptions
    });
  }));
  return /* @__PURE__ */React39.createElement(EGDSCard7, {
    backgroundTheme: "secondary"
  }, /* @__PURE__ */React39.createElement(EGDSCardContentSection3, null, /* @__PURE__ */React39.createElement(EGDSExpandoList2, null, /* @__PURE__ */React39.createElement(EGDSExpandoListItem2, {
    isVisible: isExpanded,
    isIndented: false,
    expandoTitle: titleElement,
    expandoDescription: descriptionElement,
    onToggle: handleToggle,
    triggerPosition: "trailing",
    analytics: analytics
  }))));
};
NestedListingExpandoCardContainer.displayName = "NestedListingExpandoContainer";
NestedListingExpandoCardContainer.fragment = fragment26;
// src/components/nested-listing-container/nested-listing-container-layout.tsx
var tabsLayoutFragment = gql30(_templateObject29());
var TabsLayout = function (param) {
  var data = param.data,
    items = param.items,
    lodgingCardOptions = param.lodgingCardOptions;
  var _useBexApi4_context_device, _useBexApi4_context;
  var tabs = data.tabs;
  var isMobile = ((_useBexApi4_context = useBexApi4().context) === null || _useBexApi4_context === void 0 ? void 0 : (_useBexApi4_context_device = _useBexApi4_context.device) === null || _useBexApi4_context_device === void 0 ? void 0 : _useBexApi4_context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */;
  var _useState = _sliced_to_array(useState(0), 2),
    selectedTabIndex = _useState[0],
    setSelectedTabIndex = _useState[1];
  var track = useEgClickstream2();
  var shownTabIndexes = useRef2( /* @__PURE__ */new Set([selectedTabIndex]));
  var onTabSelect = useCallback(function (index) {
    shownTabIndexes.current.add(index);
    setSelectedTabIndex(index);
    var item = items[index];
    if ((item === null || item === void 0 ? void 0 : item.__typename) === "ShoppingListingContainer") {
      var analytics = item === null || item === void 0 ? void 0 : item.clickstreamAnalytics;
      if (analytics) {
        var eventData = buildListInteractionClickStreamEvent(analytics);
        if (eventData) {
          track(eventData);
        }
      }
    }
  }, [items, track]);
  return /* @__PURE__ */React40.createElement(EGDSTabs, {
    backgroundColor: EGDSTabsBackGroundColorType.SECONDARY,
    tabsType: EGDSTabsType.NATURAL,
    selectedTab: selectedTabIndex,
    onTabSelect: onTabSelect,
    withBorder: !isMobile
  }, tabs.map(function (tab, index) {
    var item = items[index];
    if (!item) {
      return null;
    }
    return /* @__PURE__ */React40.createElement(EGDSTab, {
      key: tab.tabId,
      name: tab.label,
      targetURI: "&selectedTab=".concat(tab.tabId)
    }, shownTabIndexes.current.has(index) ? /* @__PURE__ */React40.createElement(NestedListingContainerItem, {
      key: tab.tabId,
      data: item,
      lodgingCardOptions: lodgingCardOptions
    }) : null);
  }).filter(function (element) {
    return element;
  }));
};
TabsLayout.displayName = "TabsLayout";
TabsLayout.fragment = tabsLayoutFragment;
var fragment27 = gql30(_templateObject30(), TabsLayout.fragment, NestedListingExpandoCardContainer.fragment);
var NestedListingContainerLayout = function (param) {
  var data = param.data,
    items = param.items,
    lodgingCardOptions = param.lodgingCardOptions;
  switch (data.__typename) {
    case "EGDSBasicTabs":
      return /* @__PURE__ */React40.createElement(TabsLayout, {
        data: data,
        items: items,
        lodgingCardOptions: lodgingCardOptions
      });
    case "ShoppingListingExpandoCardContainer":
      return /* @__PURE__ */React40.createElement(NestedListingExpandoCardContainer, {
        data: data,
        items: items,
        lodgingCardOptions: lodgingCardOptions
      });
    default:
      return null;
  }
};
NestedListingContainerLayout.displayName = "NestedListingContainerLayout";
NestedListingContainerLayout.fragment = fragment27;
// src/components/nested-listing-container/nested-listing-container.tsx
var fragment28 = gql31(_templateObject31(), NestedListingContainerLayout.fragment, ShoppingListingContainer.fragment, ContainerHeading.fragment, ShoppingRangeIndicatorCard2.fragment);
var NestedListingContainer = function (param) {
  var data = param.data,
    _param_lodgingCardOptions = param.lodgingCardOptions,
    lodgingCardOptions = _param_lodgingCardOptions === void 0 ? {} : _param_lodgingCardOptions;
  var nestedContainerHeading = data.nestedContainerHeading,
    items = data.items,
    layout = data.layout,
    impressionAnalytics = data.impressionAnalytics;
  if (!items.length) {
    return null;
  }
  return /* @__PURE__ */React41.createElement(IntersectionTrackerWrapper, {
    referrerId: impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId,
    linkName: impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName
  }, nestedContainerHeading && /* @__PURE__ */React41.createElement(ContainerHeading, {
    data: nestedContainerHeading
  }), /* @__PURE__ */React41.createElement(NestedListingContainerLayout, {
    data: layout,
    items: items,
    lodgingCardOptions: lodgingCardOptions
  }));
};
NestedListingContainer.displayName = "NestedListingContainer";
NestedListingContainer.fragment = fragment28;
// src/components/property-listing-divider/property-listing-divider.tsx
import React42 from "react";
import { gql as gql32 } from "@apollo/client";
import { EGDSCard as EGDSCard8 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex14 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing16 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading11 } from "@egds/react-core/text";
import { IntersectionTracker as IntersectionTracker6 } from "@shared-ui/clickstream-analytics-context";
import { UiGraphic as UiGraphic5 } from "@shared-ui/lodging-fragments";
var fragment29 = gql32(_templateObject32(), UiGraphic5.fragment);
var PropertyListingDivider = function (param) {
  var _param_data = param.data,
    backgroundTheme = _param_data.backgroundTheme,
    title = _param_data.title,
    graphic = _param_data.graphic,
    impressionAnalytics = _param_data.impressionAnalytics,
    listingSpacing2 = param.listingSpacing;
  var bgTheme = backgroundTheme;
  var listingDivider = React42.useMemo(function () {
    if (!graphic) {
      if (title === null || title === void 0 ? void 0 : title.titleText) {
        return /* @__PURE__ */React42.createElement(EGDSSpacing16, {
          padding: {
            blockstart: "six"
          },
          margin: listingSpacing2
        }, /* @__PURE__ */React42.createElement("div", {
          "data-test-id": "property-listing-divider-header-only"
        }, /* @__PURE__ */React42.createElement(EGDSHeading11, {
          tag: "h3",
          size: 5,
          align: "left"
        }, title.titleText)));
      }
      return /* @__PURE__ */React42.createElement(React42.Fragment, null);
    }
    return /* @__PURE__ */React42.createElement(EGDSSpacing16, {
      margin: listingSpacing2
    }, /* @__PURE__ */React42.createElement(EGDSCard8, {
      backgroundTheme: bgTheme
    }, /* @__PURE__ */React42.createElement(EGDSSpacing16, {
      padding: {
        block: "twelve"
      }
    }, /* @__PURE__ */React42.createElement(EGDSLayoutFlex14, {
      direction: "column",
      justifyContent: "center",
      alignItems: "center",
      dataTestId: "property-listing-divider-banner"
    }, /* @__PURE__ */React42.createElement(EGDSSpacing16, {
      margin: {
        blockend: "two"
      }
    }, /* @__PURE__ */React42.createElement(UiGraphic5, {
      data: graphic
    })), (title === null || title === void 0 ? void 0 : title.titleText) && /* @__PURE__ */React42.createElement(EGDSHeading11, {
      tag: "h3",
      size: 4,
      align: "center"
    }, title.titleText)))));
  }, [bgTheme, graphic, listingSpacing2, title === null || title === void 0 ? void 0 : title.titleText]);
  return impressionAnalytics ? /* @__PURE__ */React42.createElement(IntersectionTracker6, {
    referrerId: impressionAnalytics.referrerId,
    linkName: impressionAnalytics.event,
    trackOnce: true
  }, listingDivider) : listingDivider;
};
PropertyListingDivider.fragment = fragment29;
PropertyListingDivider.displayName = "PropertyListingDivider";
// src/components/property-listing-recently-viewed-carousel-wrapper/property-listing-recently-viewed-carousel-wrapper.tsx
import React43 from "react";
import { gql as gql33 } from "@apollo/client";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2 } from "@shared-ui/experiment-context";
import { DiscoveryCardContentSize as DiscoveryCardContentSize2, DiscoveryContainerType as DiscoveryContainerType2, LineOfBusinessDomain as LineOfBusinessDomain2, RecentActivitiesModule, RecentActivityType } from "@shared-ui/retail-recent-activities";
// src/components/property-listing-recently-viewed-carousel-wrapper/helpers/marketing-channel-util.tsx
var getMarketingChannelByid = function (id, searchCriteriaSelections) {
  var searchCriteriaSelectionObj = searchCriteriaSelections === null || searchCriteriaSelections === void 0 ? void 0 : searchCriteriaSelections.find(function (searchCriteriaSelection) {
    return searchCriteriaSelection.id === id;
  });
  return searchCriteriaSelectionObj ? searchCriteriaSelectionObj.value : null;
};
var getMarketingChannelTypeCode = function (searchCriteriaSelections) {
  var marketingChannelTypeCode = getMarketingChannelByid("mctc", searchCriteriaSelections);
  var numberMarketingChannelTypeCode = Number(marketingChannelTypeCode);
  return Number.isNaN(numberMarketingChannelTypeCode) ? 0 : numberMarketingChannelTypeCode;
};
// src/components/property-listing-recently-viewed-carousel-wrapper/property-listing-recently-viewed-carousel-wrapper.tsx
var fragment30 = gql33(_templateObject33());
var PropertyListingRecentlyViewedPropertiesCarouselWrapper = function (param) {
  var inputs = param.inputs,
    onHoverChanged = param.onHoverChanged;
  var _inputs_criteria, _inputs_criteria1, _inputs_criteria_secondary, _inputs_criteria2, _inputs_criteria_primary_dateRange, _inputs_criteria_primary, _inputs_criteria3, _inputs_criteria_primary_dateRange1, _inputs_criteria_primary1, _inputs_criteria4, _inputs_criteria_primary_rooms, _inputs_criteria5, _inputs_criteria6;
  return inputs ? /* @__PURE__ */React43.createElement(Experiment2, {
    name: "Recently_viewed_property_carousel_Web"
  }, /* @__PURE__ */React43.createElement(ExperimentControl2, null), /* @__PURE__ */React43.createElement(ExperimentVariant2, {
    bucket: 1
  }, /* @__PURE__ */React43.createElement(RecentActivitiesModule, {
    inputs: {
      regionId: (_inputs_criteria = inputs.criteria) === null || _inputs_criteria === void 0 ? void 0 : _inputs_criteria.primary.destination.regionId,
      containerType: DiscoveryContainerType2.CAROUSEL,
      typeFilter: [RecentActivityType.VIEWED_OFFERS],
      contentSize: ((_inputs_criteria1 = inputs.criteria) === null || _inputs_criteria1 === void 0 ? void 0 : _inputs_criteria1.primary.dateRange) ? DiscoveryCardContentSize2.UBER_ABBREVIATED_PRICE : DiscoveryCardContentSize2.UBER_ABBREVIATED,
      discoveryRecentActivityContext: {
        outputLineOfBusiness: LineOfBusinessDomain2.LODGING,
        marketingChannelTypeCode: getMarketingChannelTypeCode((_inputs_criteria2 = inputs.criteria) === null || _inputs_criteria2 === void 0 ? void 0 : (_inputs_criteria_secondary = _inputs_criteria2.secondary) === null || _inputs_criteria_secondary === void 0 ? void 0 : _inputs_criteria_secondary.selections),
        pageId: "HOT.SR",
        lodging: {
          checkin: inputs === null || inputs === void 0 ? void 0 : (_inputs_criteria3 = inputs.criteria) === null || _inputs_criteria3 === void 0 ? void 0 : (_inputs_criteria_primary = _inputs_criteria3.primary) === null || _inputs_criteria_primary === void 0 ? void 0 : (_inputs_criteria_primary_dateRange = _inputs_criteria_primary.dateRange) === null || _inputs_criteria_primary_dateRange === void 0 ? void 0 : _inputs_criteria_primary_dateRange.checkInDate,
          checkout: inputs === null || inputs === void 0 ? void 0 : (_inputs_criteria4 = inputs.criteria) === null || _inputs_criteria4 === void 0 ? void 0 : (_inputs_criteria_primary1 = _inputs_criteria4.primary) === null || _inputs_criteria_primary1 === void 0 ? void 0 : (_inputs_criteria_primary_dateRange1 = _inputs_criteria_primary1.dateRange) === null || _inputs_criteria_primary_dateRange1 === void 0 ? void 0 : _inputs_criteria_primary_dateRange1.checkOutDate,
          rooms: inputs === null || inputs === void 0 ? void 0 : (_inputs_criteria5 = inputs.criteria) === null || _inputs_criteria5 === void 0 ? void 0 : (_inputs_criteria_primary_rooms = _inputs_criteria5.primary.rooms) === null || _inputs_criteria_primary_rooms === void 0 ? void 0 : _inputs_criteria_primary_rooms.map(function (room) {
            var _room_children;
            return {
              adults: room.adults,
              children: (_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.map(function (child) {
                return child.age;
              })
            };
          }),
          searchCriteria: (_inputs_criteria6 = inputs.criteria) === null || _inputs_criteria6 === void 0 ? void 0 : _inputs_criteria6.secondary
        }
      },
      configurationId: "ec4d4ea2-151b-4fae-98c2-cbde1e0dc8e5"
    },
    onHoverChanged: onHoverChanged
  }))) : null;
};
PropertyListingRecentlyViewedPropertiesCarouselWrapper.displayName = "PropertyListingRecentlyViewedPropertiesCarouselWrapper";
PropertyListingRecentlyViewedPropertiesCarouselWrapper.fragment = fragment30;
// src/components/property-listing/context/one-key-banner-toggle-context.tsx
import { createContext } from "react";
var OneKeyBannerToggleContext = createContext({});
// src/components/property-listing/context/grid-view-context.tsx
import React44, { createContext as createContext2, useContext, useMemo as useMemo3, useState as useState2 } from "react";
var GridViewContext = createContext2({
  isGridView: false
});
var useGridViewContext = function () {
  return useContext(GridViewContext);
};
var GridViewContextProvider = function (param) {
  var children = param.children,
    initialIsGridView = param.isGridView;
  var _useState2 = _sliced_to_array(useState2(initialIsGridView !== null && initialIsGridView !== void 0 ? initialIsGridView : false), 2),
    isGridView = _useState2[0],
    setIsGridView = _useState2[1];
  var toggleGridView = function () {
    setIsGridView(function (prevState) {
      return !prevState;
    });
  };
  var contextValue = useMemo3(function () {
    return {
      isGridView: isGridView,
      toggleGridView: toggleGridView
    };
  }, [isGridView]);
  return /* @__PURE__ */React44.createElement(GridViewContext.Provider, {
    value: contextValue
  }, children);
};
// src/components/property-listing/__private/__fragments/lodging-static-multi-item-cross-sell.tsx
import React45 from "react";
import { gql as gql34 } from "@apollo/client";
import { MessageResult } from "@shared-ui/lodging-fragments";
import { StaticMultiItemCrossSell } from "@shared-ui/multi-item-static-cross-sell";
var fragment31 = gql34(_templateObject34(), MessageResult.fragment);
function stripGraphQlMetadata2(obj) {
  return JSON.parse(JSON.stringify(obj, function (k, v) {
    return k.startsWith("__") || k.endsWith("__") ? void 0 : v;
  }));
}
var LodgingStaticMultiItemCrossSell = function (param) {
  var data = param.data,
    className = param.className;
  var fallbackListing = data.fallbackListing,
    crossSellProductType = data.crossSellProductType,
    multiItemSearchContext = data.multiItemSearchContext;
  if (!crossSellProductType) {
    return null;
  }
  var sanitizedSearchContext = stripGraphQlMetadata2(multiItemSearchContext);
  var NoResultFallback = (fallbackListing === null || fallbackListing === void 0 ? void 0 : fallbackListing.__typename) === "MessageResult" ? function () {
    return /* @__PURE__ */React45.createElement(MessageResult, {
      data: fallbackListing
    });
  } : void 0;
  return /* @__PURE__ */React45.createElement("div", {
    "data-stid": "lodging-static-multi-item-cross-sell",
    className: className
  }, /* @__PURE__ */React45.createElement(StaticMultiItemCrossSell, {
    inputs: {
      searchContext: sanitizedSearchContext,
      crossSellProductType: crossSellProductType,
      userLocation: null
    },
    noResultsFallback: NoResultFallback
  }));
};
LodgingStaticMultiItemCrossSell.fragment = fragment31;
LodgingStaticMultiItemCrossSell.displayName = "LodgingStaticMultiItemCrossSell";
// src/components/property-listing/__private/__fragments/property-search-listing-placeholder.tsx
import React46, { useContext as useContext2 } from "react";
import { gql as gql35 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex15 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing17 } from "@egds/react-core/spacing";
import { LineOfBusinessDomain as LineOfBusinessDomain3, OneKeyBanner, PageLocation } from "@shared-ui/retail-loyalty-one-key-banner";
import { InstallmentPlan } from "@shared-ui/retail-multi-item-installment-plan";
// src/components/property-listing/helpers/package-type-converter-for-one-key-banner.ts
import { PackageType as OneKeyPackageType } from "@shared-ui/retail-loyalty-one-key-banner";
var _obj1;
var packageTypeToOneKeyPackageTypeMap = (_obj1 = {}, _define_property(_obj1, "FLIGHT_CAR" /* FLIGHT_CAR */, OneKeyPackageType.FLIGHT_CAR), _define_property(_obj1, "FLIGHT_HOTEL" /* FLIGHT_HOTEL */, OneKeyPackageType.FLIGHT_HOTEL), _define_property(_obj1, "FLIGHT_HOTEL_CAR" /* FLIGHT_HOTEL_CAR */, OneKeyPackageType.FLIGHT_HOTEL_CAR), _define_property(_obj1, "HOTEL_CAR" /* HOTEL_CAR */, OneKeyPackageType.HOTEL_CAR), _define_property(_obj1, "HOTEL_ACTIVITY" /* HOTEL_ACTIVITY */, OneKeyPackageType.HOTEL_ACTIVITY), _obj1);
// src/components/property-listing/helpers/use-query-params.ts
import { useMemo as useMemo4 } from "react";
import { useLocation } from "react-router-dom";
import { parse } from "query-string";
function useQueryParams() {
  var location = useLocation();
  return useMemo4(function () {
    return parse(location.search);
  }, [location.search]);
}
function normalizeQueryParams(queryParams) {
  return Object.fromEntries(Object.entries(queryParams).map(function (param) {
    var _param = _sliced_to_array(param, 2),
      key = _param[0],
      value = _param[1];
    return [key.toLowerCase(), value];
  }));
}
// src/components/property-listing/helpers/use-update-url-one-key-banner-toggle.ts
import { useCallback as useCallback2 } from "react";
import { useHistory as useHistory2, useLocation as useLocation2 } from "react-router-dom";
import { stringify } from "query-string";
var useUpdateURLForOneKeyBannerToggle = function (toggleContextValue) {
  var history = useHistory2();
  var location = useLocation2();
  var params = useQueryParams();
  var analyticsSearch = toggleContextValue === null || toggleContextValue === void 0 ? void 0 : toggleContextValue.analyticsSearch;
  var updateSearch = toggleContextValue === null || toggleContextValue === void 0 ? void 0 : toggleContextValue.updateSearch;
  return useCallback2(function (isChecked) {
    if (typeof (analyticsSearch === null || analyticsSearch === void 0 ? void 0 : analyticsSearch.withNewSearchId) === "function" && updateSearch) {
      analyticsSearch.withNewSearchId(updateSearch)({
        history: history,
        location: location,
        newParams: {
          useRewards: String(isChecked)
        },
        replace: true
      });
    } else {
      params.useRewards = String(isChecked);
      history.replace("".concat(history.location.pathname, "?").concat(stringify(params)));
    }
  }, [history, params]);
};
// src/components/property-listing/helpers/use-use-rewards.ts
function useUseRewards() {
  return useQueryParams().useRewards;
}
// src/components/property-listing/__private/__fragments/property-search-listing-placeholder.tsx
var fragment32 = gql35(_templateObject35());
var PropertySearchListingPlaceholder = function (param) {
  var data = param.data,
    packageType = param.packageType,
    criteria = param.criteria;
  var toggleContextValue = useContext2(OneKeyBannerToggleContext);
  var loadingComponent = data.loadingComponent;
  var useRewards = useUseRewards() === "true";
  var switchHandler = useUpdateURLForOneKeyBannerToggle(toggleContextValue);
  var queryParams = useQueryParams();
  var _normalizeQueryParams = normalizeQueryParams(queryParams),
    mdpdtl = _normalizeQueryParams.mdpdtl,
    gclid = _normalizeQueryParams.gclid,
    mdpcid = _normalizeQueryParams.mdpcid;
  var marketingInfo = _object_spread({}, mdpdtl && {
    metaDistributionPartnersDetails: mdpdtl
  }, gclid && {
    googleClickIdentifier: gclid
  }, mdpcid && {
    metaDistributionPartnersChannelIdentifier: mdpcid
  });
  var generateSearchContextInput = function () {
    var _criteria_primary_dateRange, _criteria_primary, _criteria_primary_dateRange1, _criteria_primary1;
    var checkInDate = criteria === null || criteria === void 0 ? void 0 : (_criteria_primary = criteria.primary) === null || _criteria_primary === void 0 ? void 0 : (_criteria_primary_dateRange = _criteria_primary.dateRange) === null || _criteria_primary_dateRange === void 0 ? void 0 : _criteria_primary_dateRange.checkInDate;
    var checkOutDate = criteria === null || criteria === void 0 ? void 0 : (_criteria_primary1 = criteria.primary) === null || _criteria_primary1 === void 0 ? void 0 : (_criteria_primary_dateRange1 = _criteria_primary1.dateRange) === null || _criteria_primary_dateRange1 === void 0 ? void 0 : _criteria_primary_dateRange1.checkOutDate;
    if (!checkInDate || !checkOutDate) {
      return null;
    }
    return {
      dateRange: {
        start: checkInDate,
        end: checkOutDate
      }
    };
  };
  var searchContextInfo = generateSearchContextInput();
  switch (loadingComponent) {
    case "InstallmentPlan":
    case "InstallmentPlanAffirm":
      return /* @__PURE__ */React46.createElement(EGDSLayoutFlex15, {
        justifyContent: "center",
        "data-stid": "lodging-installment-plan"
      }, /* @__PURE__ */React46.createElement(InstallmentPlan, {
        inputs: {
          multiItemSessionId: null,
          amount: null
        },
        margin: {
          blockstart: "two"
        },
        placeholderMargin: {
          blockstart: "three"
        },
        minWidth: "4x"
      }));
    case "InstallmentPlanKlarna":
      return /* @__PURE__ */React46.createElement(EGDSLayoutFlex15, {
        justifyContent: "center",
        "data-stid": "lodging-installment-plan"
      }, /* @__PURE__ */React46.createElement(InstallmentPlan, {
        inputs: {
          multiItemSessionId: null,
          amount: null
        },
        margin: {
          blockstart: "two"
        },
        placeholderMargin: {
          blockstart: "three",
          blockend: "half"
        },
        minWidth: "4x__half"
      }));
    case "LoyaltyBanner":
      return /* @__PURE__ */React46.createElement("div", {
        "data-stid": "loyalty-banner-plan"
      }, /* @__PURE__ */React46.createElement(OneKeyBanner, {
        inputs: {
          useLoyaltyCurrency: useRewards,
          pageLocation: PageLocation.SEARCH_RESULTS,
          packageType: packageType ? packageTypeToOneKeyPackageTypeMap[packageType] : null,
          packageLOB: null,
          lineOfBusiness: LineOfBusinessDomain3.LODGING,
          searchContext: null
        },
        switchHandler: switchHandler,
        skipSsr: true
      }));
    case "OneKeyMessageBanner":
      return /* @__PURE__ */React46.createElement("div", {
        "data-stid": "one-key-message-banner-plan"
      }, /* @__PURE__ */React46.createElement(EGDSSpacing17, {
        margin: {
          blockstart: "three"
        }
      }, /* @__PURE__ */React46.createElement(OneKeyBanner, {
        inputs: {
          useLoyaltyCurrency: useRewards,
          pageLocation: PageLocation.SEARCH_RESULTS,
          packageType: packageType ? packageTypeToOneKeyPackageTypeMap[packageType] : null,
          packageLOB: null,
          marketing: marketingInfo,
          lineOfBusiness: LineOfBusinessDomain3.LODGING,
          searchContext: searchContextInfo
        },
        switchHandler: switchHandler,
        showBorder: true,
        skipSsr: true
      })));
    default:
      return null;
  }
};
PropertySearchListingPlaceholder.fragment = fragment32;
PropertySearchListingPlaceholder.displayName = "PropertySearchListingPlaceholder";
// src/components/property-listing/__private/listing.tsx
var fragment33 = gql36(_templateObject36(), LodgingCard3.fragment, LodgingHeading.fragment, LodgingIntentCard.fragment, LodgingStaticMultiItemCrossSell.fragment, MessageResult2.fragment, SponsoredContentPlacement.fragment, PropertyListingSoldOut.fragment, PropertyListingOverfiltered.fragment, PropertyListingStandardMessagingCard.fragment, PropertyListingExpandoCard.fragment, SparkleBanner.fragment, PropertySearchListingPlaceholder.fragment, EGDSStandardMessagingCard2.fragment, PropertyListingFlexibleDateSearchCard.fragment, PropertyListingRecentlyViewedPropertiesCarouselWrapper.fragment, ShoppingListingContainer.fragment, PropertyListingDivider.fragment, NestedListingContainer.fragment);
var LodgingCardContent = function (param) {
  var lodgingCardData = param.lodgingCardData,
    view = param.view,
    shouldLazyLoadImg = param.shouldLazyLoadImg,
    handleClickCallBack = param.handleClickCallBack,
    onHoverChanged = param.onHoverChanged,
    appendAdditionalQueryParamCb = param.appendAdditionalQueryParamCb,
    index = param.index,
    isSRPListing = param.isSRPListing,
    isFirstModIndex = param.isFirstModIndex,
    shouldChangeCardDisplayOnHover = param.shouldChangeCardDisplayOnHover,
    fetchPriority = param.fetchPriority;
  return /* @__PURE__ */React47.createElement(LodgingCard3, {
    data: lodgingCardData,
    view: view,
    lazyLoadImg: shouldLazyLoadImg,
    onClickCallback: handleClickCallBack,
    onHoverChanged: onHoverChanged,
    appendAdditionalQueryParamCb: appendAdditionalQueryParamCb,
    index: index,
    fireCardImpression: false,
    isSRPListingCard: isSRPListing,
    fireImpressionByViewability: true,
    enableInlineLink: true,
    border: isSRPListing,
    isFirstModIndex: isFirstModIndex,
    shouldChangeCardDisplayOnHover: shouldChangeCardDisplayOnHover,
    fetchPriority: fetchPriority
  });
};
var listingSpacing = {
  blockstart: "three"
};
var carouselListingSpacingOptionsForFirstPosition = {
  padding: {
    blockend: "two"
  },
  margin: {
    blockstart: "six"
  }
};
var carouselListingSpacingOptionsDefault = {
  margin: listingSpacing
};
var _obj2;
var viewportBasedThemeCardWrapperPropsMap = (_obj2 = {}, _define_property(_obj2, ViewSizes3.SMALL, {
  isSquareCard: true
}), _define_property(_obj2, ViewSizes3.MEDIUM, {
  isSquareCard: false
}), _obj2);
var themeCardWrapperSpacingOptions = {
  padding: {
    small: {
      inline: "three",
      block: "six"
    },
    medium: {
      inline: "six",
      block: "six"
    }
  }
};
var Listing = function (props) {
  var data = props.data,
    index = props.index,
    criteria = props.criteria,
    isSRPListing = props.isSRPListing,
    openDatePicker = props.openDatePicker,
    onClickCallback = props.onClickCallback,
    onHoverChanged = props.onHoverChanged,
    changeFlexibility = props.changeFlexibility,
    appendAdditionalQueryParamCb = props.appendAdditionalQueryParamCb,
    isFirstModIndex = props.isFirstModIndex,
    shouldChangeCardDisplayOnHover = props.shouldChangeCardDisplayOnHover,
    inputs = props.inputs,
    packageType = props.packageType,
    hideCompressionMessage = props.hideCompressionMessage,
    onBannerDismiss = props.onBannerDismiss,
    fetchPriority = props.fetchPriority,
    onFilterPillRemoval = props.onFilterPillRemoval,
    onRemoveAllFilters = props.onRemoveAllFilters,
    _props_firstCardIndex = props.firstCardIndex,
    firstCardIndex = _props_firstCardIndex === void 0 ? 0 : _props_firstCardIndex,
    onImageCardClickCallback = props.onImageCardClickCallback;
  var __typename = data.__typename;
  var shouldLazyLoadImg = index >= firstCardIndex + 3;
  var _useState3 = _sliced_to_array(useState3(!hideCompressionMessage), 2),
    isBannerVisible = _useState3[0],
    setBannerVisibility = _useState3[1];
  var isGridView = useGridViewContext().isGridView;
  var viewportBasedThemeCardWrapperProps = useViewportMap2(viewportBasedThemeCardWrapperPropsMap);
  var handleClickCallBack = function () {
    onClickCallback === null || onClickCallback === void 0 ? void 0 : onClickCallback(data);
  };
  var handleBannerDismiss = function () {
    setBannerVisibility(false);
    onBannerDismiss === null || onBannerDismiss === void 0 ? void 0 : onBannerDismiss();
  };
  var addCallBack = function (messageCardData) {
    return (messageCardData === null || messageCardData === void 0 ? void 0 : messageCardData.egdsElementId) === "propertySelectDateCard" && {
      onClick: openDatePicker
    };
  };
  var lodgingCardOptions = {
    lazyLoadImg: shouldLazyLoadImg,
    onClickCallback: handleClickCallBack,
    onHoverChanged: onHoverChanged,
    isSRPListingCard: isSRPListing,
    shouldChangeCardDisplayOnHover: shouldChangeCardDisplayOnHover,
    enableInlineLink: true
  };
  var carouselListingSpacingOptions = index === 0 ? carouselListingSpacingOptionsForFirstPosition : carouselListingSpacingOptionsDefault;
  switch (__typename) {
    case "LodgingCard":
      return isGridView ? /* @__PURE__ */React47.createElement(LodgingCardContent, {
        view: LodgingCardView2.GRID,
        lodgingCardData: data,
        shouldLazyLoadImg: shouldLazyLoadImg,
        handleClickCallBack: handleClickCallBack,
        onHoverChanged: onHoverChanged,
        appendAdditionalQueryParamCb: appendAdditionalQueryParamCb,
        index: index,
        isSRPListing: isSRPListing,
        isFirstModIndex: isFirstModIndex,
        shouldChangeCardDisplayOnHover: shouldChangeCardDisplayOnHover,
        fetchPriority: fetchPriority
      }) : /* @__PURE__ */React47.createElement(EGDSSpacing18, {
        key: index,
        margin: listingSpacing
      }, /* @__PURE__ */React47.createElement("div", null, /* @__PURE__ */React47.createElement(Viewport5, null, /* @__PURE__ */React47.createElement(ViewSmall5, null, /* @__PURE__ */React47.createElement(LodgingCardContent, {
        view: LodgingCardView2.COMPACT_HORIZONTAL,
        lodgingCardData: data,
        shouldLazyLoadImg: shouldLazyLoadImg,
        handleClickCallBack: handleClickCallBack,
        onHoverChanged: onHoverChanged,
        appendAdditionalQueryParamCb: appendAdditionalQueryParamCb,
        index: index,
        isSRPListing: isSRPListing,
        isFirstModIndex: isFirstModIndex,
        shouldChangeCardDisplayOnHover: shouldChangeCardDisplayOnHover,
        fetchPriority: fetchPriority
      })), /* @__PURE__ */React47.createElement(ViewMedium4, null, /* @__PURE__ */React47.createElement(LodgingCardContent, {
        lodgingCardData: data,
        shouldLazyLoadImg: shouldLazyLoadImg,
        handleClickCallBack: handleClickCallBack,
        onHoverChanged: onHoverChanged,
        appendAdditionalQueryParamCb: appendAdditionalQueryParamCb,
        index: index,
        isSRPListing: isSRPListing,
        isFirstModIndex: isFirstModIndex,
        shouldChangeCardDisplayOnHover: shouldChangeCardDisplayOnHover,
        fetchPriority: fetchPriority
      })))));
    case "ShoppingListingContainer":
      return /* @__PURE__ */React47.createElement(EGDSSpacing18, _object_spread({
        key: index
      }, carouselListingSpacingOptions), /* @__PURE__ */React47.createElement("div", null, /* @__PURE__ */React47.createElement(ThemeCardWrapper, _object_spread({
        theme: "secondary",
        spacingOptions: themeCardWrapperSpacingOptions
      }, viewportBasedThemeCardWrapperProps), /* @__PURE__ */React47.createElement(ShoppingListingContainer, {
        data: data,
        lodgingCardOptions: lodgingCardOptions,
        onImageCardClickCallback: onImageCardClickCallback
      }))));
    case "LodgingIntentCard":
      return /* @__PURE__ */React47.createElement(EGDSSpacing18, {
        key: index,
        margin: {
          blockstart: "four"
        }
      }, /* @__PURE__ */React47.createElement(LodgingIntentCard, {
        data: data
      }));
    case "LodgingHeading":
      return /* @__PURE__ */React47.createElement(EGDSSpacing18, {
        key: index,
        padding: {
          blockstart: "three"
        },
        margin: listingSpacing
      }, /* @__PURE__ */React47.createElement(LodgingHeading, {
        tag: "h2",
        size: 5,
        data: data
      }));
    case "MessageResult":
      return /* @__PURE__ */React47.createElement(EGDSSpacing18, {
        key: index,
        margin: listingSpacing
      }, data.type === "BRANDED_THEME_ACCENT" /* BRANDED_THEME_ACCENT */ || data.type === "BRANDED_THEME_DARK" /* BRANDED_THEME_DARK */ ? /* @__PURE__ */React47.createElement(SparkleBanner, {
        data: data
      }) : /* @__PURE__ */React47.createElement(MessageResult2, {
        data: data
      }));
    case "SponsoredContentPlacement":
      return /* @__PURE__ */React47.createElement(EGDSSpacing18, {
        key: index,
        margin: listingSpacing
      }, /* @__PURE__ */React47.createElement("div", null, /* @__PURE__ */React47.createElement(SponsoredContentPlacement, {
        data: data,
        criteria: criteria,
        onClickCallback: handleClickCallBack,
        onHoverChanged: onHoverChanged
      })));
    case "StaticLodgingMultiItemCrossSell":
      return /* @__PURE__ */React47.createElement(EGDSSpacing18, {
        key: index,
        margin: listingSpacing
      }, /* @__PURE__ */React47.createElement(LodgingStaticMultiItemCrossSell, {
        data: data
      }));
    case "PropertySearchListingsSoldOutCard":
      return /* @__PURE__ */React47.createElement(EGDSSpacing18, {
        key: index,
        margin: listingSpacing
      }, /* @__PURE__ */React47.createElement("div", null, /* @__PURE__ */React47.createElement(PropertyListingSoldOut, {
        data: data,
        onClick: openDatePicker
      })));
    case "FlexibleDateSearchCard":
      return /* @__PURE__ */React47.createElement(EGDSSpacing18, {
        key: index,
        margin: listingSpacing
      }, /* @__PURE__ */React47.createElement("div", null, /* @__PURE__ */React47.createElement(PropertyListingFlexibleDateSearchCard, {
        data: data,
        onChangeDatesClick: openDatePicker,
        onFlexibleDateButtonClick: changeFlexibility
      })));
    case "PropertySearchListingsOverfilteredCard":
      return /* @__PURE__ */React47.createElement(EGDSSpacing18, {
        key: index,
        margin: listingSpacing
      }, /* @__PURE__ */React47.createElement("div", null, /* @__PURE__ */React47.createElement(PropertyListingOverfiltered, {
        data: data,
        onFilterPillRemoval: onFilterPillRemoval,
        onRemoveAllFilters: onRemoveAllFilters
      })));
    case "EGDSStandardMessagingCard":
      return /* @__PURE__ */React47.createElement(EGDSSpacing18, {
        key: index,
        margin: listingSpacing
      }, /* @__PURE__ */React47.createElement("div", null, data.egdsElementId !== null && ["attachBanner", "compressionBanner", "cancellationBanner"].includes(data.egdsElementId) ? (data.egdsElementId === "attachBanner" || isBannerVisible) && /* @__PURE__ */React47.createElement(EGDSStandardMessagingCard2, {
        data: data,
        showBorder: true,
        onDismiss: handleBannerDismiss,
        markNoInlineStart: data.egdsElementId === "attachBanner"
      }) : /* @__PURE__ */React47.createElement(PropertyListingStandardMessagingCard, _object_spread({
        data: data,
        showBorder: true
      }, addCallBack(data)))));
    case "PropertyListingsIconTextExpando":
      return /* @__PURE__ */React47.createElement(EGDSSpacing18, {
        key: index,
        margin: listingSpacing
      }, /* @__PURE__ */React47.createElement("div", null, /* @__PURE__ */React47.createElement(PropertyListingExpandoCard, {
        data: data
      })));
    case "PropertySearchListingPlaceholder":
      return /* @__PURE__ */React47.createElement(EGDSSpacing18, {
        key: index
      }, /* @__PURE__ */React47.createElement("div", null, /* @__PURE__ */React47.createElement(PropertySearchListingPlaceholder, {
        data: data,
        packageType: packageType,
        criteria: criteria
      })));
    case "RecentlyViewedPropertiesCarouselWrapper":
      return /* @__PURE__ */React47.createElement(EGDSSpacing18, {
        key: index,
        margin: listingSpacing
      }, /* @__PURE__ */React47.createElement("div", null, /* @__PURE__ */React47.createElement(PropertyListingRecentlyViewedPropertiesCarouselWrapper, {
        data: data,
        inputs: inputs,
        onHoverChanged: onHoverChanged
      })));
    case "LodgingListingDivider":
      return /* @__PURE__ */React47.createElement(PropertyListingDivider, {
        key: index,
        data: data,
        listingSpacing: listingSpacing
      });
    case "NestedListingContainer":
      {
        var _data_layout;
        var theme = ((_data_layout = data.layout) === null || _data_layout === void 0 ? void 0 : _data_layout.__typename) !== "ShoppingListingExpandoCardContainer" ? "secondary" : void 0;
        return /* @__PURE__ */React47.createElement(EGDSSpacing18, _object_spread({
          key: index
        }, carouselListingSpacingOptions), /* @__PURE__ */React47.createElement("div", null, /* @__PURE__ */React47.createElement(ThemeCardWrapper, _object_spread_props(_object_spread({
          theme: theme
        }, viewportBasedThemeCardWrapperProps), {
          spacingOptions: themeCardWrapperSpacingOptions
        }), /* @__PURE__ */React47.createElement(NestedListingContainer, {
          key: index,
          data: data,
          lodgingCardOptions: lodgingCardOptions
        }))));
      }
    default:
      return null;
  }
};
Listing.fragment = fragment33;
Listing.displayName = "Listing";
// src/components/property-listing/helpers/fetch-more.ts
import { mergeAndConcat } from "merge-anything";
function createMergeDynamicMapData(isArrowPagination, isSecondaryFetch) {
  return function mergeDynamicMapData(prev, param) {
    var fetchMoreResult = param.fetchMoreResult;
    if (!fetchMoreResult) {
      return prev;
    }
    if (isArrowPagination && isSecondaryFetch) {
      var _prev_propertySearch_dynamicMap, _fetchMoreResult_propertySearch_dynamicMap;
      return _object_spread_props(_object_spread({}, fetchMoreResult), {
        propertySearch: _object_spread_props(_object_spread({}, fetchMoreResult.propertySearch), {
          dynamicMap: mergeAndConcat((_prev_propertySearch_dynamicMap = prev.propertySearch.dynamicMap) !== null && _prev_propertySearch_dynamicMap !== void 0 ? _prev_propertySearch_dynamicMap : {}, (_fetchMoreResult_propertySearch_dynamicMap = fetchMoreResult.propertySearch.dynamicMap) !== null && _fetchMoreResult_propertySearch_dynamicMap !== void 0 ? _fetchMoreResult_propertySearch_dynamicMap : {})
        })
      });
    }
    return fetchMoreResult;
  };
}
// src/components/property-listing/placeholders.tsx
import React48 from "react";
import { EGDSCard as EGDSCard9, EGDSCardContentSection as EGDSCardContentSection4 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure3, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType4 } from "@egds/react-core/images";
import { EGDSLayoutGrid as EGDSLayoutGrid5, EGDSLayoutGridItem as EGDSLayoutGridItem5 } from "@egds/react-core/layout-grid";
import { EGDSBlockSkeleton, EGDSLineSkeleton as EGDSLineSkeleton2 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing19 } from "@egds/react-core/spacing";
var SearchListingPlaceholder = function () {
  return /* @__PURE__ */React48.createElement(EGDSSpacing19, {
    margin: {
      block: "four"
    }
  }, /* @__PURE__ */React48.createElement(EGDSCard9, null, /* @__PURE__ */React48.createElement(EGDSLayoutGrid5, {
    columns: 3
  }, /* @__PURE__ */React48.createElement(EGDSLayoutGridItem5, {
    colSpan: 1
  }, /* @__PURE__ */React48.createElement(CardGalleryPlaceholder, {
    aspectRatio: EGDSFigureAspectRatioType4.R21_9
  })), /* @__PURE__ */React48.createElement(EGDSLayoutGridItem5, {
    colSpan: 2
  }, /* @__PURE__ */React48.createElement(EGDSSpacing19, {
    padding: {
      blockend: "twelve"
    }
  }, /* @__PURE__ */React48.createElement("div", null, /* @__PURE__ */React48.createElement(CardContentPlaceholder, null)))))));
};
SearchListingPlaceholder.displayName = "SearchListingPlaceholder";
var CardGalleryPlaceholder = function (param) {
  var aspectRatio = param.aspectRatio;
  return /* @__PURE__ */React48.createElement(EGDSFigure3, {
    ratio: aspectRatio
  }, /* @__PURE__ */React48.createElement(EGDSBlockSkeleton, null));
};
CardGalleryPlaceholder.displayName = "CardGalleryPlaceholder";
var CardContentPlaceholder = function (param) {
  var border = param.border;
  return /* @__PURE__ */React48.createElement(EGDSCardContentSection4, {
    border: border
  }, /* @__PURE__ */React48.createElement(PaddedSkeletonText, null), /* @__PURE__ */React48.createElement(PaddedSkeletonText, {
    margin: {
      blockend: "twelve"
    },
    type: "secondary"
  }));
};
CardContentPlaceholder.displayName = "CardContentPlaceholder";
var PaddedSkeletonText = function (param) {
  var _param_margin = param.margin,
    margin = _param_margin === void 0 ? {
      blockend: "two"
    } : _param_margin,
    type = param.type;
  return /* @__PURE__ */React48.createElement(EGDSSpacing19, {
    margin: margin
  }, /* @__PURE__ */React48.createElement(EGDSLineSkeleton2, {
    animation: true,
    type: type
  }));
};
PaddedSkeletonText.displayName = "PaddedSkeletonText";
// src/components/property-listing/search-error-message.tsx
import React49 from "react";
import { EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon5 } from "@egds/react-core/icons";
import { EGDSSpacing as EGDSSpacing20 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading12, EGDSText as EGDSText11 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization } from "@shared-ui/localization-context";
var SearchErrorMessageWrapper = function (param) {
  var refetch = param.refetch,
    variables = param.variables;
  var formatText = useLocalization().formatText;
  var errorMessage = formatText("hotels.searchResults.error.text");
  var errorCta = formatText("hotels.searchResults.error.cta");
  var trackEvent = useClickTracker8();
  var onErrorRetryClick = function () {
    if (refetch && variables) {
      trackEvent(":errorOnSearch", "Try Again on error", true);
      refetch(variables);
    }
  };
  return /* @__PURE__ */React49.createElement(EGDSSpacing20, {
    padding: {
      blockstart: "three",
      blockend: "twelve"
    }
  }, /* @__PURE__ */React49.createElement(EGDSText11, {
    align: "center"
  }, /* @__PURE__ */React49.createElement(EGDSIcon5, {
    name: "error"
  }), /* @__PURE__ */React49.createElement(EGDSSpacing20, {
    padding: {
      blockstart: "four",
      blockend: "two"
    }
  }, /* @__PURE__ */React49.createElement(EGDSHeading12, {
    tag: "h2"
  }, errorMessage)), /* @__PURE__ */React49.createElement(EGDSTertiaryButton, {
    onClick: onErrorRetryClick
  }, errorCta)));
};
// src/components/property-listing/use-secondary-property-listing-fetch.tsx
import { useEffect as useEffect2 } from "react";
var SECONDARY_FETCH_CRITERIA_ID = "shouldFetchSecondaryBatch";
function useSecondaryPropertyListingFetch(shouldMakeSecondaryFetch, nextSubSet, handlePagination) {
  useEffect2(function () {
    if (!shouldMakeSecondaryFetch || !nextSubSet) {
      return;
    }
    var startingIndex = nextSubSet.startingIndex;
    handlePagination(startingIndex, true);
  }, [nextSubSet, shouldMakeSecondaryFetch, handlePagination]);
}
// src/components/property-listing/property-listing.tsx
var INITIAL_LOAD_THRESHOLD = 20;
var LAZY_LOAD_OFFSET = 2e3;
var StateProvider = buildStateProvider(new ValidatedInputsState(), TripsToastStateChunk, LodgingCompareStateChunk);
var __PropertyListingFragment = gql37(_templateObject37(), AdaptExAnalyticsEventFragment2, Listing.fragment, PropertyListingsToast.fragment, LodgingHeader.fragment);
var PropertyListing = function (props) {
  var handlePaginationWithTracking = function handlePaginationWithTracking() {
    var nextPaginationStartingIndex = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var _data_pagination;
    var trigger = data === null || data === void 0 ? void 0 : (_data_pagination = data.pagination) === null || _data_pagination === void 0 ? void 0 : _data_pagination.trigger;
    if ((trigger === null || trigger === void 0 ? void 0 : trigger.__typename) === "UIPrimaryButton") {
      var _trigger_analytics, _trigger_analytics1;
      var _trigger_analytics_referrerId, _trigger_analytics_linkName;
      clickTracker((_trigger_analytics_referrerId = (_trigger_analytics = trigger.analytics) === null || _trigger_analytics === void 0 ? void 0 : _trigger_analytics.referrerId) !== null && _trigger_analytics_referrerId !== void 0 ? _trigger_analytics_referrerId : "", (_trigger_analytics_linkName = (_trigger_analytics1 = trigger.analytics) === null || _trigger_analytics1 === void 0 ? void 0 : _trigger_analytics1.linkName) !== null && _trigger_analytics_linkName !== void 0 ? _trigger_analytics_linkName : "");
    }
    if (showPagination) {
      onPaginationNext === null || onPaginationNext === void 0 ? void 0 : onPaginationNext();
    } else {
      handlePagination(nextPaginationStartingIndex);
    }
  };
  var _pagination_trigger, _pagination_subSets, _paginationData_subSets_nextSubSet, _paginationData_subSets, _data_pagination_subSets_nextSubSet, _data_pagination_subSets, _data_pagination, _pagination_subSets1, _inputs_shoppingContext_multiItem, _inputs_shoppingContext, _data_summary;
  var data = props.data,
    error = props.error,
    fetchMore = props.fetchMore,
    inputs = props.inputs,
    isLoadingPwa = props.isLoadingPwa,
    listingAnnouncementMessages = props.listingAnnouncementMessages,
    onClickCallback = props.onClickCallback,
    onHoverChanged = props.onHoverChanged,
    appendAdditionalQueryParamCb = props.appendAdditionalQueryParamCb,
    onPaginationCallback = props.onPaginationCallback,
    onDestinationCallback = props.onDestinationCallback,
    openDatePicker = props.openDatePicker,
    propertyListingToast = props.propertyListingToast,
    propertySearchListingAdaptexAnalyticsEvents = props.propertySearchListingAdaptexAnalyticsEvents,
    shouldScrollToTopOnSearch = props.shouldScrollToTopOnSearch,
    shouldChangeCardDisplayOnHover = props.shouldChangeCardDisplayOnHover,
    loading = props.loading,
    propertySearchListingsPwa = props.propertySearchListingsPwa,
    scrollToTopRef = props.scrollToTopRef,
    changeFlexibility = props.changeFlexibility,
    variables = props.variables,
    refetch = props.refetch,
    hideCompressionMessage = props.hideCompressionMessage,
    onBannerDismiss = props.onBannerDismiss,
    showListingToast = props.showListingToast,
    onPaginationNext = props.onPaginationNext,
    onPaginationPrev = props.onPaginationPrev,
    showPagination = props.showPagination,
    showLoadingSpinner = props.showLoadingSpinner,
    onFilterPillRemoval = props.onFilterPillRemoval,
    onRemoveAllFilters = props.onRemoveAllFilters,
    onImageCardClickCallback = props.onImageCardClickCallback;
  var isPwaListingsData = Boolean(propertySearchListingsPwa);
  var showLoadingList = isLoadingPwa && (!propertySearchListingsPwa || propertySearchListingsPwa.length === 0);
  var _useState4 = _sliced_to_array(useState4(false), 2),
    paginationLoading = _useState4[0],
    setPaginationLoading = _useState4[1];
  var _useState41 = _sliced_to_array(useState4(false), 2),
    isSecondaryFetchLoading = _useState41[0],
    setIsSecondaryFetchLoading = _useState41[1];
  var _useState42 = _sliced_to_array(useState4(), 2),
    paginationData = _useState42[0],
    setPaginationData = _useState42[1];
  var _useState43 = _sliced_to_array(useState4(), 2),
    secondaryCriteriaBooleans = _useState43[0],
    setSecondaryCriteriaBooleans = _useState43[1];
  var _useState44 = _sliced_to_array(useState4(), 2),
    propertySearchListings = _useState44[0],
    setPropertySearchListings = _useState44[1];
  var _useState45 = _sliced_to_array(useState4(), 2),
    paginationTriggerType = _useState45[0],
    setPaginationTriggerType = _useState45[1];
  var clickTracker = useClickTracker9();
  var isInitialLoad = !data && loading;
  var lodgingSearchCriteriaString = JSON.stringify(inputs === null || inputs === void 0 ? void 0 : inputs.criteria);
  var productShoppingCriteriaString = JSON.stringify(inputs === null || inputs === void 0 ? void 0 : inputs.productShoppingCriteriaInput);
  var pagination = paginationData !== null && paginationData !== void 0 ? paginationData : data === null || data === void 0 ? void 0 : data.pagination;
  var _React50_useState = _sliced_to_array(React50.useState(showListingToast), 2),
    showToast = _React50_useState[0],
    setShowToast = _React50_useState[1];
  var isGridView = useGridViewContext().isGridView;
  var hideListingToast = React50.useCallback(function () {
    if (showToast) {
      setShowToast(false);
    }
  }, [showToast, setShowToast]);
  var memoizedPropertyListingsToast = React50.useMemo(function () {
    var toastData = propertyListingToast || (data === null || data === void 0 ? void 0 : data.propertyListingsToast);
    if (toastData && showToast) {
      return /* @__PURE__ */React50.createElement(PropertyListingsToast, {
        hideListingToast: hideListingToast,
        data: toastData
      });
    }
  }, [data === null || data === void 0 ? void 0 : data.propertyListingsToast, showToast, hideListingToast, propertyListingToast]);
  useEffect3(function () {
    if (!showToast && !isLoadingPwa) {
      setShowToast(true);
    }
  }, [isLoadingPwa]);
  useEffect3(function () {
    var _data_pagination, _pagination_trigger, _data_pagination1, _data_criteria_primary_destination, _data_criteria_primary, _data_criteria, _data_criteria_secondary, _data_criteria1;
    if (isInitialLoad) {
      setPropertySearchListings(void 0);
      setPaginationData(void 0);
    }
    if (!showPagination && (data === null || data === void 0 ? void 0 : (_data_pagination = data.pagination) === null || _data_pagination === void 0 ? void 0 : _data_pagination.__typename)) {
      setPaginationData(data === null || data === void 0 ? void 0 : data.pagination);
    }
    if (!paginationTriggerType && (pagination === null || pagination === void 0 ? void 0 : (_pagination_trigger = pagination.trigger) === null || _pagination_trigger === void 0 ? void 0 : _pagination_trigger.__typename)) {
      var _pagination_trigger1;
      setPaginationTriggerType(pagination === null || pagination === void 0 ? void 0 : (_pagination_trigger1 = pagination.trigger) === null || _pagination_trigger1 === void 0 ? void 0 : _pagination_trigger1.__typename);
    }
    if (data === null || data === void 0 ? void 0 : (_data_pagination1 = data.pagination) === null || _data_pagination1 === void 0 ? void 0 : _data_pagination1.subSets) {
      onPaginationCallback === null || onPaginationCallback === void 0 ? void 0 : onPaginationCallback(data.pagination.subSets);
    }
    if (data === null || data === void 0 ? void 0 : (_data_criteria = data.criteria) === null || _data_criteria === void 0 ? void 0 : (_data_criteria_primary = _data_criteria.primary) === null || _data_criteria_primary === void 0 ? void 0 : (_data_criteria_primary_destination = _data_criteria_primary.destination) === null || _data_criteria_primary_destination === void 0 ? void 0 : _data_criteria_primary_destination.regionName) {
      onDestinationCallback === null || onDestinationCallback === void 0 ? void 0 : onDestinationCallback(data.criteria.primary.destination.regionName);
    }
    setSecondaryCriteriaBooleans(data === null || data === void 0 ? void 0 : (_data_criteria1 = data.criteria) === null || _data_criteria1 === void 0 ? void 0 : (_data_criteria_secondary = _data_criteria1.secondary) === null || _data_criteria_secondary === void 0 ? void 0 : _data_criteria_secondary.booleans);
  }, [lodgingSearchCriteriaString, productShoppingCriteriaString, pagination === null || pagination === void 0 ? void 0 : (_pagination_trigger = pagination.trigger) === null || _pagination_trigger === void 0 ? void 0 : _pagination_trigger.__typename, setPaginationTriggerType, data === null || data === void 0 ? void 0 : data.pagination]);
  var _ref, _ref1;
  var listings = (_ref1 = (_ref = propertySearchListingsPwa !== null && propertySearchListingsPwa !== void 0 ? propertySearchListingsPwa : propertySearchListings) !== null && _ref !== void 0 ? _ref : data === null || data === void 0 ? void 0 : data.propertySearchListings) !== null && _ref1 !== void 0 ? _ref1 : [];
  var searchResultsProperties = React50.useMemo(function () {
    var _listings_filter;
    return (_listings_filter = listings === null || listings === void 0 ? void 0 : listings.filter(function (listing) {
      return listing.__typename === "LodgingCard";
    })) !== null && _listings_filter !== void 0 ? _listings_filter : [];
  }, [listings]);
  var gridViewList = React50.useMemo(function () {
    if (isGridView) {
      var propertiesOnly = _to_consumable_array(searchResultsProperties);
      var _listings_filter;
      var list = (_listings_filter = listings === null || listings === void 0 ? void 0 : listings.filter(function (listing) {
        return listing.__typename !== "LodgingCard";
      })) !== null && _listings_filter !== void 0 ? _listings_filter : [];
      var groupSize = 3;
      var group = [];
      propertiesOnly.forEach(function (property, indexOfProperty) {
        group.push(property);
        if (group.length === groupSize || indexOfProperty === propertiesOnly.length - 1) {
          list.push(group);
          group = [];
        }
      });
      return list;
    }
    return [];
  }, [listings, searchResultsProperties, isGridView]);
  var firstCardIndex = React50.useMemo(function () {
    return listings.findIndex(function (listing) {
      return listing.__typename === "LodgingCard";
    });
  }, [listings]);
  var hasNextSubset = !!(pagination === null || pagination === void 0 ? void 0 : (_pagination_subSets = pagination.subSets) === null || _pagination_subSets === void 0 ? void 0 : _pagination_subSets.nextSubSet);
  var hasNextSubSetStartingIndex = (paginationData === null || paginationData === void 0 ? void 0 : (_paginationData_subSets = paginationData.subSets) === null || _paginationData_subSets === void 0 ? void 0 : (_paginationData_subSets_nextSubSet = _paginationData_subSets.nextSubSet) === null || _paginationData_subSets_nextSubSet === void 0 ? void 0 : _paginationData_subSets_nextSubSet.startingIndex) || showPagination && (data === null || data === void 0 ? void 0 : (_data_pagination = data.pagination) === null || _data_pagination === void 0 ? void 0 : (_data_pagination_subSets = _data_pagination.subSets) === null || _data_pagination_subSets === void 0 ? void 0 : (_data_pagination_subSets_nextSubSet = _data_pagination_subSets.nextSubSet) === null || _data_pagination_subSets_nextSubSet === void 0 ? void 0 : _data_pagination_subSets_nextSubSet.startingIndex);
  var isShowMorePagination = paginationTriggerType === "UIPrimaryButton";
  var isArrowPagination = paginationTriggerType === "LodgingPaginationNavigationButtons";
  var onHoverCallback = isShowMorePagination ? void 0 : onHoverChanged;
  var shouldDisplayShowMoreButton = (!isPwaListingsData || showPagination) && isShowMorePagination;
  var showMoreTriggerData = paginationTriggerType === "UIPrimaryButton" ? pagination === null || pagination === void 0 ? void 0 : pagination.trigger : void 0;
  var shouldDisplayPaginationArrows = (!isPwaListingsData || showPagination) && isArrowPagination;
  var handlePagination = useCallback3( /*#__PURE__*/_async_to_generator(function () {
    var nextPaginationStartingIndex, isSecondaryFetch, fetchMoreVariables, _ref, newPaginationData, _newPaginationData_propertySearch_pagination, _newPaginationData_propertySearch_criteria_secondary, _newPaginationData_propertySearch_criteria, nextPropertySearchListings;
    var _arguments = arguments;
    return _ts_generator(this, function (_state) {
      switch (_state.label) {
        case 0:
          nextPaginationStartingIndex = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 0, isSecondaryFetch = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
          if (isSecondaryFetch) {
            setIsSecondaryFetchLoading(true);
          }
          setPaginationLoading(true);
          if (!fetchMore || !(inputs === null || inputs === void 0 ? void 0 : inputs.criteria) && !(inputs === null || inputs === void 0 ? void 0 : inputs.productShoppingCriteriaInput)) {
            return [2];
          }
          fetchMoreVariables = (inputs === null || inputs === void 0 ? void 0 : inputs.criteria) ? {
            criteria: _object_spread_props(_object_spread({}, inputs.criteria), {
              secondary: _object_spread_props(_object_spread({}, inputs.criteria.secondary), {
                counts: [{
                  id: "resultsStartingIndex",
                  value: nextPaginationStartingIndex
                }]
              })
            })
          } : {
            productShoppingCriteriaInput: _object_spread_props(_object_spread({}, inputs.productShoppingCriteriaInput), {
              secondaryCriteria: _object_spread_props(_object_spread({}, inputs.productShoppingCriteriaInput.secondaryCriteria), {
                counts: [{
                  id: "resultsStartingIndex",
                  value: nextPaginationStartingIndex
                }]
              })
            })
          };
          return [4, fetchMore({
            variables: fetchMoreVariables,
            updateQuery: createMergeDynamicMapData(isArrowPagination, isSecondaryFetch)
          })];
        case 1:
          _ref = _state.sent(), newPaginationData = _ref.data;
          if (newPaginationData) {
            ;
            nextPropertySearchListings = isShowMorePagination || isSecondaryFetch ? listings.concat(newPaginationData.propertySearch.propertySearchListings) : newPaginationData.propertySearch.propertySearchListings;
            setPropertySearchListings(nextPropertySearchListings);
            if ((_newPaginationData_propertySearch_pagination = newPaginationData.propertySearch.pagination) === null || _newPaginationData_propertySearch_pagination === void 0 ? void 0 : _newPaginationData_propertySearch_pagination.subSets) {
              setPaginationData(newPaginationData.propertySearch.pagination);
              onPaginationCallback === null || onPaginationCallback === void 0 ? void 0 : onPaginationCallback(newPaginationData.propertySearch.pagination.subSets);
            } else {
              setPaginationData(null);
            }
            setSecondaryCriteriaBooleans((_newPaginationData_propertySearch_criteria = newPaginationData.propertySearch.criteria) === null || _newPaginationData_propertySearch_criteria === void 0 ? void 0 : (_newPaginationData_propertySearch_criteria_secondary = _newPaginationData_propertySearch_criteria.secondary) === null || _newPaginationData_propertySearch_criteria_secondary === void 0 ? void 0 : _newPaginationData_propertySearch_criteria_secondary.booleans);
          }
          setPaginationLoading(false);
          if (isSecondaryFetch) {
            setIsSecondaryFetchLoading(false);
          }
          return [2];
      }
    });
  }), [fetchMore, inputs === null || inputs === void 0 ? void 0 : inputs.criteria, isShowMorePagination, listings, onPaginationCallback, isArrowPagination]);
  var shouldMakeSecondaryFetch = !paginationLoading && !isSecondaryFetchLoading && hasNextSubset && !!paginationTriggerType && !!(secondaryCriteriaBooleans === null || secondaryCriteriaBooleans === void 0 ? void 0 : secondaryCriteriaBooleans.find(function (param) {
    var id = param.id,
      value = param.value;
    return id === SECONDARY_FETCH_CRITERIA_ID && value;
  }));
  useSecondaryPropertyListingFetch(shouldMakeSecondaryFetch, pagination === null || pagination === void 0 ? void 0 : (_pagination_subSets1 = pagination.subSets) === null || _pagination_subSets1 === void 0 ? void 0 : _pagination_subSets1.nextSubSet, handlePagination);
  var _ref2;
  var propertyListingAdaptexAnalyticsSuccessEvents = (_ref2 = (data === null || data === void 0 ? void 0 : data.propertyListingAdaptexAnalyticsSuccessEvents) || propertySearchListingAdaptexAnalyticsEvents) !== null && _ref2 !== void 0 ? _ref2 : [];
  var loadingListRef = React50.useRef(null);
  var skeletonRef = scrollToTopRef ? scrollToTopRef : loadingListRef;
  useEffect3(function () {
    if ((skeletonRef === null || skeletonRef === void 0 ? void 0 : skeletonRef.current) && shouldScrollToTopOnSearch && (loading || paginationLoading || isPwaListingsData)) {
      skeletonRef.current.scrollIntoView({
        behavior: "auto",
        block: "start",
        inline: "nearest"
      });
    }
  }, [isPwaListingsData, loading, paginationLoading, searchResultsProperties, shouldScrollToTopOnSearch]);
  if (!isShowMorePagination && paginationLoading && !isSecondaryFetchLoading || isInitialLoad || showLoadingList) {
    var _listingAnnouncementMessages_loadMessage;
    liveAnnounce((_listingAnnouncementMessages_loadMessage = listingAnnouncementMessages === null || listingAnnouncementMessages === void 0 ? void 0 : listingAnnouncementMessages.loadMessage) !== null && _listingAnnouncementMessages_loadMessage !== void 0 ? _listingAnnouncementMessages_loadMessage : "", Level.POLITE);
    var loadingList = _to_consumable_array(Array(6));
    return /* @__PURE__ */React50.createElement(StateProvider, null, /* @__PURE__ */React50.createElement("div", {
      ref: loadingListRef
    }, loadingList.map(function (_, index) {
      return /* @__PURE__ */React50.createElement(SearchListingPlaceholder, {
        key: "placeholder-".concat(index)
      });
    })), shouldDisplayPaginationArrows && /* @__PURE__ */React50.createElement(PropertyListingPagination, {
      handlePagination: handlePagination,
      isLoading: true,
      pagination: pagination,
      onPaginationNext: onPaginationNext,
      onPaginationPrev: onPaginationPrev,
      showPagination: showPagination
    }));
  }
  if (error) {
    var _listingAnnouncementMessages_errorMessage;
    liveAnnounce((_listingAnnouncementMessages_errorMessage = listingAnnouncementMessages === null || listingAnnouncementMessages === void 0 ? void 0 : listingAnnouncementMessages.errorMessage) !== null && _listingAnnouncementMessages_errorMessage !== void 0 ? _listingAnnouncementMessages_errorMessage : "", Level.POLITE);
    return /* @__PURE__ */React50.createElement(SearchErrorMessageWrapper, {
      refetch: refetch,
      variables: variables
    });
  }
  var _listingAnnouncementMessages_updateMessage;
  liveAnnounce((_listingAnnouncementMessages_updateMessage = listingAnnouncementMessages === null || listingAnnouncementMessages === void 0 ? void 0 : listingAnnouncementMessages.updateMessage) !== null && _listingAnnouncementMessages_updateMessage !== void 0 ? _listingAnnouncementMessages_updateMessage : "", Level.POLITE);
  var isModDrr = function (listing) {
    if ((listing === null || listing === void 0 ? void 0 : listing.__typename) === "LodgingCard") {
      var _listing_priceSection_priceSummary_options_, _listing_priceSection_priceSummary_options, _listing_priceSection_priceSummary, _listing_priceSection, _listing_priceSection1;
      var isDrr = (_listing_priceSection = listing.priceSection) === null || _listing_priceSection === void 0 ? void 0 : (_listing_priceSection_priceSummary = _listing_priceSection.priceSummary) === null || _listing_priceSection_priceSummary === void 0 ? void 0 : (_listing_priceSection_priceSummary_options = _listing_priceSection_priceSummary.options) === null || _listing_priceSection_priceSummary_options === void 0 ? void 0 : (_listing_priceSection_priceSummary_options_ = _listing_priceSection_priceSummary_options[0]) === null || _listing_priceSection_priceSummary_options_ === void 0 ? void 0 : _listing_priceSection_priceSummary_options_.strikeOut;
      var isModButton = (_listing_priceSection1 = listing.priceSection) === null || _listing_priceSection1 === void 0 ? void 0 : _listing_priceSection1.button;
      return isDrr && isModButton;
    }
    return false;
  };
  var firstModIndex = listings.findIndex(isModDrr);
  var packageType = inputs === null || inputs === void 0 ? void 0 : (_inputs_shoppingContext = inputs.shoppingContext) === null || _inputs_shoppingContext === void 0 ? void 0 : (_inputs_shoppingContext_multiItem = _inputs_shoppingContext.multiItem) === null || _inputs_shoppingContext_multiItem === void 0 ? void 0 : _inputs_shoppingContext_multiItem.packageType;
  var shouldFetchPriority = function (index) {
    return index === firstCardIndex ? "high" : void 0;
  };
  var headerData = data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : _data_summary.header;
  var _showMoreTriggerData_accessibility;
  return /* @__PURE__ */React50.createElement(StateProvider, null, /* @__PURE__ */React50.createElement(AdaptExEventsProvider, {
    value: {
      adaptExSuccessEvents: propertyListingAdaptexAnalyticsSuccessEvents
    }
  }, memoizedPropertyListingsToast, headerData && /* @__PURE__ */React50.createElement(EGDSSpacing21, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React50.createElement("div", null, /* @__PURE__ */React50.createElement(LodgingHeader, {
    data: headerData,
    size: 5,
    tag: "h2"
  }))), /* @__PURE__ */React50.createElement("div", {
    "data-stid": "property-listing-results"
  }, isGridView ? /* @__PURE__ */React50.createElement(EGDSLayoutGrid6, {
    "data-stid": "property-listing-grid-view",
    columns: {
      small: [Repeat(2, "1fr")],
      large: [Repeat(3, "1fr")]
    },
    space: "two"
  }, gridViewList.map(function (group, outerIndex) {
    return group.length ? group.map(function (listing, index) {
      return /* @__PURE__ */React50.createElement(EGDSLayoutGridItem6, {
        key: "property-listing-product-".concat(index)
      }, /* @__PURE__ */React50.createElement("div", null, /* @__PURE__ */React50.createElement(Listing, {
        criteria: inputs === null || inputs === void 0 ? void 0 : inputs.criteria,
        data: listing,
        index: index,
        isSRPListing: true,
        onClickCallback: onClickCallback,
        onHoverChanged: onHoverCallback,
        appendAdditionalQueryParamCb: appendAdditionalQueryParamCb,
        openDatePicker: openDatePicker,
        changeFlexibility: changeFlexibility,
        isFirstModIndex: firstModIndex === outerIndex,
        inputs: inputs,
        packageType: packageType,
        shouldChangeCardDisplayOnHover: shouldChangeCardDisplayOnHover,
        hideCompressionMessage: hideCompressionMessage,
        onBannerDismiss: onBannerDismiss,
        fetchPriority: shouldFetchPriority(index),
        firstCardIndex: firstCardIndex,
        onImageCardClickCallback: onImageCardClickCallback
      })));
    }) : /* @__PURE__ */React50.createElement(EGDSLayoutGridItem6, {
      colSpan: {
        small: 2,
        large: 3
      },
      key: "property-listing-non-product-".concat(outerIndex)
    }, /* @__PURE__ */React50.createElement("div", null, /* @__PURE__ */React50.createElement(Listing, {
      criteria: inputs === null || inputs === void 0 ? void 0 : inputs.criteria,
      data: group,
      index: outerIndex,
      isSRPListing: true,
      onClickCallback: onClickCallback,
      onHoverChanged: onHoverCallback,
      appendAdditionalQueryParamCb: appendAdditionalQueryParamCb,
      openDatePicker: openDatePicker,
      changeFlexibility: changeFlexibility,
      isFirstModIndex: firstModIndex === outerIndex,
      inputs: inputs,
      packageType: packageType,
      shouldChangeCardDisplayOnHover: shouldChangeCardDisplayOnHover,
      hideCompressionMessage: hideCompressionMessage,
      onBannerDismiss: onBannerDismiss,
      fetchPriority: shouldFetchPriority(outerIndex),
      firstCardIndex: firstCardIndex,
      onImageCardClickCallback: onImageCardClickCallback
    })));
  })) : listings.slice(0, INITIAL_LOAD_THRESHOLD).map(function (listing, index) {
    return /* @__PURE__ */React50.createElement(Listing, {
      criteria: inputs === null || inputs === void 0 ? void 0 : inputs.criteria,
      data: listing,
      index: index,
      isSRPListing: true,
      key: "property-listing-".concat(index),
      onClickCallback: onClickCallback,
      onHoverChanged: onHoverCallback,
      appendAdditionalQueryParamCb: appendAdditionalQueryParamCb,
      openDatePicker: openDatePicker,
      changeFlexibility: changeFlexibility,
      isFirstModIndex: firstModIndex === index,
      inputs: inputs,
      packageType: packageType,
      shouldChangeCardDisplayOnHover: shouldChangeCardDisplayOnHover,
      hideCompressionMessage: hideCompressionMessage,
      onBannerDismiss: onBannerDismiss,
      fetchPriority: shouldFetchPriority(index),
      firstCardIndex: firstCardIndex,
      onFilterPillRemoval: onFilterPillRemoval,
      onRemoveAllFilters: onRemoveAllFilters,
      onImageCardClickCallback: onImageCardClickCallback
    });
  }), /* @__PURE__ */React50.createElement(LazyLoad, {
    offset: LAZY_LOAD_OFFSET
  }, /* @__PURE__ */React50.createElement(React50.Fragment, null, listings.slice(INITIAL_LOAD_THRESHOLD, listings.length).map(function (listing, index) {
    var listingIndex = index + INITIAL_LOAD_THRESHOLD;
    return /* @__PURE__ */React50.createElement(Listing, {
      criteria: inputs === null || inputs === void 0 ? void 0 : inputs.criteria,
      data: listing,
      index: listingIndex,
      isSRPListing: true,
      key: "property-listing-".concat(listingIndex),
      onClickCallback: onClickCallback,
      onHoverChanged: onHoverCallback,
      appendAdditionalQueryParamCb: appendAdditionalQueryParamCb,
      openDatePicker: openDatePicker,
      changeFlexibility: changeFlexibility,
      isFirstModIndex: firstModIndex === listingIndex,
      inputs: inputs,
      shouldChangeCardDisplayOnHover: shouldChangeCardDisplayOnHover,
      hideCompressionMessage: hideCompressionMessage,
      onBannerDismiss: onBannerDismiss,
      fetchPriority: shouldFetchPriority(listingIndex),
      onFilterPillRemoval: onFilterPillRemoval,
      onRemoveAllFilters: onRemoveAllFilters,
      onImageCardClickCallback: onImageCardClickCallback
    });
  })))), /* @__PURE__ */React50.createElement(EGDSSpacing21, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React50.createElement("div", null, shouldDisplayShowMoreButton && hasNextSubset && hasNextSubSetStartingIndex && /* @__PURE__ */React50.createElement(React50.Fragment, null, (paginationLoading || showLoadingSpinner) && /* @__PURE__ */React50.createElement(EGDSLayoutFlex16, {
    justifyContent: "center"
  }, /* @__PURE__ */React50.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */React50.createElement(EGDSLoader, null))), /* @__PURE__ */React50.createElement(EGDSLayoutFlex16, {
    justifyContent: "center",
    tag: "section"
  }, /* @__PURE__ */React50.createElement(EGDSSecondaryButton5, {
    "aria-label": (_showMoreTriggerData_accessibility = showMoreTriggerData === null || showMoreTriggerData === void 0 ? void 0 : showMoreTriggerData.accessibility) !== null && _showMoreTriggerData_accessibility !== void 0 ? _showMoreTriggerData_accessibility : "",
    disabled: paginationLoading || isLoadingPwa,
    onClick: function () {
      var _pagination_subSets_nextSubSet, _pagination_subSets;
      return handlePaginationWithTracking(pagination === null || pagination === void 0 ? void 0 : (_pagination_subSets = pagination.subSets) === null || _pagination_subSets === void 0 ? void 0 : (_pagination_subSets_nextSubSet = _pagination_subSets.nextSubSet) === null || _pagination_subSets_nextSubSet === void 0 ? void 0 : _pagination_subSets_nextSubSet.startingIndex);
    }
  }, showMoreTriggerData === null || showMoreTriggerData === void 0 ? void 0 : showMoreTriggerData.primary))), shouldDisplayPaginationArrows && /* @__PURE__ */React50.createElement(PropertyListingPagination, {
    onPaginationNext: onPaginationNext,
    onPaginationPrev: onPaginationPrev,
    handlePagination: handlePagination,
    showPagination: showPagination,
    isLoading: paginationLoading || isLoadingPwa || !!isInitialLoad,
    pagination: pagination
  })))), /* @__PURE__ */React50.createElement(LodgingCompare, {
    skipSsr: true,
    searchResultsProperties: searchResultsProperties,
    criteria: inputs === null || inputs === void 0 ? void 0 : inputs.criteria,
    shoppingContext: inputs === null || inputs === void 0 ? void 0 : inputs.shoppingContext
  }));
};
PropertyListing.displayName = "PropertyListing";
PropertyListing.fragment = __PropertyListingFragment;
// src/components/results-heading/results-heading.tsx
import React51 from "react";
import { gql as gql38 } from "@apollo/client";
var __ResultsHeadingFragment = gql38(_templateObject38());
var ResultsHeading = function (param) {
  var data = param.data,
    error = param.error,
    _param_isHiddenFromScreenReader = param.isHiddenFromScreenReader,
    isHiddenFromScreenReader = _param_isHiddenFromScreenReader === void 0 ? false : _param_isHiddenFromScreenReader;
  var resultsHeading = data === null || data === void 0 ? void 0 : data.summary.resultsHeading;
  if (!resultsHeading || error) {
    return null;
  }
  return /* @__PURE__ */React51.createElement(React51.Fragment, null, isHiddenFromScreenReader ? /* @__PURE__ */React51.createElement("div", {
    "data-stid": "lodging-property-listing-results-heading",
    className: "is-visually-hidden",
    "aria-hidden": true
  }, resultsHeading) : /* @__PURE__ */React51.createElement("header", null, /* @__PURE__ */React51.createElement("h1", {
    "data-stid": "lodging-property-listing-results-heading",
    className: "is-visually-hidden"
  }, resultsHeading)));
};
ResultsHeading.displayName = "ResultsHeading";
ResultsHeading.fragment = __ResultsHeadingFragment;
// src/components/results-sub-header/results-sub-header.tsx
import React55 from "react";
import { gql as gql42 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex17, EGDSLayoutFlexItem as EGDSLayoutFlexItem12 } from "@egds/react-core/layout-flex";
import { EGDSLineSkeleton as EGDSLineSkeleton3 } from "@egds/react-core/skeleton";
import { EGDSText as EGDSText14 } from "@egds/react-core/text";
import { LodgingMoreInfoTrigger as LodgingMoreInfoTrigger2, ShoppingLink as ShoppingLink5 } from "@shared-ui/lodging-fragments";
import { ShoppingActionProvider as ShoppingActionProvider3 } from "@shared-ui/retail-shopping-tools-action-providers";
import { ViewLarge as ViewLarge2, Viewport as Viewport6, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
// src/components/product-results-summary-content/product-results-summary-content.tsx
import React53 from "react";
import { gql as gql40 } from "@apollo/client";
// src/components/product-results-summary-content/product-results-summary-text-content.tsx
import React52 from "react";
import { gql as gql39 } from "@apollo/client";
import { EGDSSheetContent as EGDSSheetContent4 } from "@egds/react-core/sheet";
import { EGDSText as EGDSText12 } from "@egds/react-core/text";
var fragment34 = gql39(_templateObject39());
var ProductResultsSummaryTextContent = function (param) {
  var data = param.data;
  var _data_textList;
  return /* @__PURE__ */React52.createElement(EGDSSheetContent4, null, (_data_textList = data.textList) === null || _data_textList === void 0 ? void 0 : _data_textList.map(function (text, index) {
    return /* @__PURE__ */React52.createElement(EGDSText12, {
      key: index,
      spacing: index !== 0 ? "three" : void 0
    }, text);
  }));
};
ProductResultsSummaryTextContent.fragment = fragment34;
ProductResultsSummaryTextContent.displayName = "ProductResultsSummaryTextContent";
// src/components/product-results-summary-content/product-results-summary-content.tsx
var fragment35 = gql40(_templateObject40(), ProductResultsSummaryTextContent.fragment, PriceDisplayChangeOnboardingContent.fragment);
var ProductResultsSummaryContent = function (param) {
  var data = param.data;
  var content = data.content;
  switch (content.__typename) {
    case "ProductResultsSummaryTextContent":
      return /* @__PURE__ */React53.createElement(ProductResultsSummaryTextContent, {
        data: content
      });
    default:
      return null;
  }
};
ProductResultsSummaryContent.fragment = fragment35;
ProductResultsSummaryContent.displayName = "ProductResultsSummaryContent";
// src/components/results-sub-header/loyalty-rewards-toggle.tsx
import React54 from "react";
import { gql as gql41 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing22 } from "@egds/react-core/spacing";
import { EGDSSwitch } from "@egds/react-core/switch";
import { EGDSText as EGDSText13 } from "@egds/react-core/text";
import { Level as Level2, liveAnnounce as liveAnnounce2 } from "@egds/react-core/utils";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";
var __Fragment = gql41(_templateObject41());
var LoyaltyRewardsToggle = function (param) {
  var data = param.data,
    onRewardsToggleChange = param.onRewardsToggleChange,
    switchPositionOfToggleOnEPS = param.switchPositionOfToggleOnEPS;
  var _data_pointsToggle;
  var track = useClickTracker10();
  var formatText = useLocalization2().formatText;
  var handleChange = React54.useCallback(function () {
    if (checked && uncheckedAnalytics) {
      track(uncheckedAnalytics.referrerId, uncheckedAnalytics.linkName);
    } else if (checkedAnalytics) {
      track(checkedAnalytics.referrerId, checkedAnalytics.linkName);
    }
    liveAnnounce2(formatText(checked ? "common.pointsRemoved" : "common.pointsApplied"), Level2.POLITE);
    onRewardsToggleChange === null || onRewardsToggleChange === void 0 ? void 0 : onRewardsToggleChange(!checked);
  }, [data === null || data === void 0 ? void 0 : (_data_pointsToggle = data.pointsToggle) === null || _data_pointsToggle === void 0 ? void 0 : _data_pointsToggle.checked]);
  if (!(data === null || data === void 0 ? void 0 : data.pointsToggle)) {
    return null;
  }
  var _data_pointsToggle1 = data.pointsToggle,
    checked = _data_pointsToggle1.checked,
    checkedAccessibilityLabel = _data_pointsToggle1.checkedAccessibilityLabel,
    checkedAnalytics = _data_pointsToggle1.checkedAnalytics,
    checkedDescription = _data_pointsToggle1.checkedDescription,
    checkedLabel = _data_pointsToggle1.checkedLabel,
    uncheckedAccessibilityLabel = _data_pointsToggle1.uncheckedAccessibilityLabel,
    uncheckedAnalytics = _data_pointsToggle1.uncheckedAnalytics,
    uncheckedDescription = _data_pointsToggle1.uncheckedDescription,
    uncheckedLabel = _data_pointsToggle1.uncheckedLabel;
  var switchPosition = switchPositionOfToggleOnEPS ? "trailing" : "leading";
  return /* @__PURE__ */React54.createElement(EGDSSpacing22, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React54.createElement(EGDSText13, {
    size: 300
  }, /* @__PURE__ */React54.createElement(EGDSSwitch, {
    id: "swpToggle-shared-ui",
    checked: checked,
    onChange: handleChange,
    description: (checked ? checkedDescription : uncheckedDescription) || "",
    a11yLabel: (checked ? checkedAccessibilityLabel : uncheckedAccessibilityLabel) || "",
    switchPosition: switchPosition
  }, checked ? checkedLabel : uncheckedLabel)));
};
LoyaltyRewardsToggle.displayName = "LoyaltyRewardsToggle";
LoyaltyRewardsToggle.fragment = __Fragment;
// src/components/results-sub-header/results-sub-header.tsx
var __ResultsSubHeaderFragment = gql42(_templateObject42(), PlainHeaderMessage.fragment, LodgingMoreInfoTrigger2.fragment, LoyaltyRewardsToggle.fragment, ShoppingLink5.fragment, ProductResultsSummaryContent.fragment);
var LineSkeletonType = /* @__PURE__ */function (LineSkeletonType2) {
  LineSkeletonType2[LineSkeletonType2["Primary"] = 0] = "Primary";
  LineSkeletonType2[LineSkeletonType2["Secondary"] = 1] = "Secondary";
  return LineSkeletonType2;
}(LineSkeletonType || {});
var alignMap2 = {
  center: "center",
  left: "start"
};
var ResultsSubHeaderMessageListing = function (param) {
  var resultMessages = param.resultMessages,
    loading = param.loading,
    localizedText = param.localizedText,
    fontSize = param.fontSize,
    fontWeight = param.fontWeight,
    skeletonLayout = param.skeletonLayout,
    overlayContent = param.overlayContent,
    title = param.title,
    subtitle = param.subtitle,
    alignment = param.alignment,
    isMultiItem = param.isMultiItem;
  var subHeaderPlaceHolder = /* @__PURE__ */React55.createElement("div", {
    "data-stid": "results-header-messages-placeholder"
  }, /* @__PURE__ */React55.createElement(EGDSText14, {
    inline: false,
    align: "left",
    theme: "standard"
  }, localizedText));
  var skeletonLayoutComponents = skeletonLayout === null || skeletonLayout === void 0 ? void 0 : skeletonLayout.map(function (lineSkeletonType, index) {
    if (lineSkeletonType === 0 /* Primary */) {
      return /* @__PURE__ */React55.createElement(EGDSLayoutFlexItem12, {
        key: index
      }, /* @__PURE__ */React55.createElement(EGDSLineSkeleton3, {
        animation: true,
        type: "primary"
      }));
    }
    return /* @__PURE__ */React55.createElement(EGDSLayoutFlexItem12, {
      key: index
    }, /* @__PURE__ */React55.createElement(EGDSLineSkeleton3, {
      animation: true,
      type: "secondary"
    }));
  });
  var subHeaderSkeleton = skeletonLayoutComponents && /* @__PURE__ */React55.createElement("div", {
    "data-stid": "results-header-messages-placeholder"
  }, /* @__PURE__ */React55.createElement(Viewport6, null, /* @__PURE__ */React55.createElement(ViewSmall6, null, /* @__PURE__ */React55.createElement(EGDSLayoutFlex17, {
    space: "one",
    direction: "column",
    alignItems: alignment ? alignMap2[alignment] : "center"
  }, skeletonLayoutComponents)), /* @__PURE__ */React55.createElement(ViewLarge2, null, /* @__PURE__ */React55.createElement(EGDSLayoutFlex17, {
    space: "one",
    direction: "column",
    alignItems: alignment ? alignMap2[alignment] : void 0
  }, skeletonLayoutComponents))));
  if (loading) {
    return localizedText ? subHeaderPlaceHolder : subHeaderSkeleton || null;
  }
  if (!resultMessages || (resultMessages === null || resultMessages === void 0 ? void 0 : resultMessages.length) === 0) {
    return null;
  }
  return /* @__PURE__ */React55.createElement("div", {
    "data-stid": "results-header-messages-listings"
  }, /* @__PURE__ */React55.createElement(PropertyListingHeaderMessages, {
    messages: resultMessages,
    fontSize: fontSize,
    fontWeight: fontWeight,
    overlayContent: overlayContent,
    title: title,
    subtitle: subtitle,
    alignment: alignment,
    isMultiItem: isMultiItem
  }));
};
var ResultsSubHeader = function (param) {
  var data = param.data,
    loading = param.loading,
    localizedText = param.localizedText,
    fontSize = param.fontSize,
    fontWeight = param.fontWeight,
    error = param.error,
    onRewardsToggleChange = param.onRewardsToggleChange,
    switchPositionOfToggleOnEPS = param.switchPositionOfToggleOnEPS,
    skeletonLayout = param.skeletonLayout,
    alignment = param.alignment;
  var _data_summary_contents, _data_summary, _data_summary1, _data_summary2, _data_summary3, _data_summary_contents_flatMap_find, _data_summary_contents1, _data_summary4;
  if (error) {
    return null;
  }
  var overlayContent = data === null || data === void 0 ? void 0 : (_data_summary = data.summary) === null || _data_summary === void 0 ? void 0 : (_data_summary_contents = _data_summary.contents) === null || _data_summary_contents === void 0 ? void 0 : _data_summary_contents.map(function (content, index) {
    return /* @__PURE__ */React55.createElement(ProductResultsSummaryContent, {
      data: content,
      key: index
    });
  });
  var _data_summary_contents_flatMap_find_title;
  return /* @__PURE__ */React55.createElement(ShoppingActionProvider3, {
    id: "results-sub-header",
    shoppingJoinListContainer: data === null || data === void 0 ? void 0 : (_data_summary1 = data.summary) === null || _data_summary1 === void 0 ? void 0 : _data_summary1.shoppingJoinListContainer
  }, /* @__PURE__ */React55.createElement(LoyaltyRewardsToggle, {
    data: data === null || data === void 0 ? void 0 : (_data_summary2 = data.summary) === null || _data_summary2 === void 0 ? void 0 : _data_summary2.loyaltyInfo,
    onRewardsToggleChange: onRewardsToggleChange,
    switchPositionOfToggleOnEPS: switchPositionOfToggleOnEPS
  }), /* @__PURE__ */React55.createElement(ResultsSubHeaderMessageListing, {
    resultMessages: data === null || data === void 0 ? void 0 : (_data_summary3 = data.summary) === null || _data_summary3 === void 0 ? void 0 : _data_summary3.resultMessages,
    fontSize: fontSize,
    fontWeight: fontWeight,
    loading: loading,
    localizedText: localizedText,
    skeletonLayout: skeletonLayout,
    overlayContent: overlayContent,
    title: (_data_summary_contents_flatMap_find_title = data === null || data === void 0 ? void 0 : (_data_summary4 = data.summary) === null || _data_summary4 === void 0 ? void 0 : (_data_summary_contents1 = _data_summary4.contents) === null || _data_summary_contents1 === void 0 ? void 0 : (_data_summary_contents_flatMap_find = _data_summary_contents1.flatMap(function (contentsValue) {
      return contentsValue.content;
    }).find(function (contentContainer) {
      return contentContainer.__typename === "ProductResultsSummaryTextContent";
    })) === null || _data_summary_contents_flatMap_find === void 0 ? void 0 : _data_summary_contents_flatMap_find.title) !== null && _data_summary_contents_flatMap_find_title !== void 0 ? _data_summary_contents_flatMap_find_title : void 0,
    alignment: alignment
  }));
};
ResultsSubHeader.displayName = "ResultsSubHeader";
ResultsSubHeader.fragment = __ResultsSubHeaderFragment;
// src/components/shopping-search-listing-header/shopping-search-listing-header.tsx
import React56 from "react";
import { gql as gql43 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing23 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { ThemeCardWrapper as ThemeCardWrapper2 } from "@shared-ui/lodging-fragments";
var __ShoppingSearchListingHeaderFragment = gql43(_templateObject43(), ShoppingListingContainer.fragment);
var ShoppingSearchListingHeader = function (param) {
  var data = param.data,
    onImageCardClickCallback = param.onImageCardClickCallback;
  var _context_device;
  var context = useBexApi5().context;
  var _data_shoppingSearchListingHeader;
  var shoppingSearchListingHeader = (_data_shoppingSearchListingHeader = data === null || data === void 0 ? void 0 : data.shoppingSearchListingHeader) !== null && _data_shoppingSearchListingHeader !== void 0 ? _data_shoppingSearchListingHeader : [];
  if ((shoppingSearchListingHeader === null || shoppingSearchListingHeader === void 0 ? void 0 : shoppingSearchListingHeader.length) === 0) {
    return null;
  }
  var isMweb = (context === null || context === void 0 ? void 0 : (_context_device = context.device) === null || _context_device === void 0 ? void 0 : _context_device.type) === "MOBILE_PHONE" /* MOBILE_PHONE */;
  return /* @__PURE__ */React56.createElement("div", {
    "data-stid": "shopping-search-listing-header"
  }, shoppingSearchListingHeader.map(function (item, index) {
    switch (item.__typename) {
      case "ShoppingListingContainer":
        return /* @__PURE__ */React56.createElement(EGDSSpacing23, {
          key: index,
          margin: {
            blockstart: index === 0 ? void 0 : "three"
          }
        }, /* @__PURE__ */React56.createElement("div", null, /* @__PURE__ */React56.createElement(ThemeCardWrapper2, {
          theme: "secondary",
          isSquareCard: isMweb,
          spacingOptions: {
            padding: {
              small: {
                inline: "three",
                block: "three"
              },
              medium: {
                inline: "six",
                block: "six"
              }
            }
          },
          key: index
        }, /* @__PURE__ */React56.createElement(ShoppingListingContainer, {
          key: index,
          data: item,
          onImageCardClickCallback: onImageCardClickCallback,
          containerIndex: index
        }))));
      default:
        return null;
    }
  }));
};
ShoppingSearchListingHeader.displayName = "ShoppingSearchListingHeader";
ShoppingSearchListingHeader.fragment = __ShoppingSearchListingHeaderFragment;
// src/components/property-listing.tsx
var __PropertyListingQuery = gql44(_templateObject44(), PropertyListing.fragment, ResultsSubHeader.fragment, PriceDisplayChangeOnboarding.fragment, MapTriggerWrapper.fragment, DynamicMapWrapper.fragment, ResultsMessagingModule.fragment, PackageProductCard.fragment, ShoppingSearchListingHeader.fragment);
var defaultInputs = {
  criteria: null,
  destination: {},
  shoppingContext: null
};
var InputsContext = React57.createContext(defaultInputs);
var InputsProvider = function (param) {
  var children = param.children,
    inputs = param.inputs;
  return /* @__PURE__ */React57.createElement(InputsContext.Provider, {
    value: inputs
  }, children);
};
function PropertyListingComponent(WrappedComponent) {
  var Component = function (props) {
    var _propertySearch_criteria_primary, _propertySearch_criteria, _data_propertySearch, _data_propertySearch_propertySearchListings, _data_propertySearch1;
    var inputs = props.inputs,
      skipSsr = props.skipSsr,
      children = props.children,
      batchKey = props.batchKey,
      propertySearchListingsPwa = props.propertySearchListingsPwa,
      locationFieldUpdateSignalType = props.locationFieldUpdateSignalType;
    var context = useBexApi6().context;
    var isPwaListingsData = Boolean(propertySearchListingsPwa);
    var variables = _object_spread_props(_object_spread({}, inputs), {
      context: context
    });
    var queryOptions = {
      context: {
        batchKey: batchKey
      },
      notifyOnNetworkStatusChange: true,
      skip: isPwaListingsData,
      ssr: !skipSsr,
      variables: variables
    };
    var _useQuery = useQuery(__PropertyListingQuery, queryOptions),
      data = _useQuery.data,
      previousData = _useQuery.previousData,
      error = _useQuery.error,
      loading = _useQuery.loading,
      fetchMore = _useQuery.fetchMore,
      refetch = _useQuery.refetch;
    var propertySearch = data === null || data === void 0 ? void 0 : data.propertySearch;
    var destination = propertySearch === null || propertySearch === void 0 ? void 0 : (_propertySearch_criteria = propertySearch.criteria) === null || _propertySearch_criteria === void 0 ? void 0 : (_propertySearch_criteria_primary = _propertySearch_criteria.primary) === null || _propertySearch_criteria_primary === void 0 ? void 0 : _propertySearch_criteria_primary.destination;
    var destinationRef = React57.useRef(destination === null || destination === void 0 ? void 0 : destination.regionName);
    var publishSignal = useSignalPublisher().publishSignal;
    React57.useEffect(function () {
      if (locationFieldUpdateSignalType) {
        var locationValue = destination === null || destination === void 0 ? void 0 : destination.regionName;
        if (locationValue && locationValue !== destinationRef.current) {
          destinationRef.current = locationValue;
          publishSignal({
            type: locationFieldUpdateSignalType,
            payload: {
              locationValue: locationValue
            }
          });
        }
      }
    }, [destination === null || destination === void 0 ? void 0 : destination.regionName, locationFieldUpdateSignalType, publishSignal]);
    return /* @__PURE__ */React57.createElement(InputsProvider, {
      inputs: inputs
    }, /* @__PURE__ */React57.createElement(WrappedComponent, _object_spread({
      data: propertySearch,
      error: error || (data === null || data === void 0 ? void 0 : (_data_propertySearch = data.propertySearch) === null || _data_propertySearch === void 0 ? void 0 : _data_propertySearch.errorResponse),
      fetchMore: fetchMore,
      previousData: previousData,
      loading: loading,
      variables: variables,
      refetch: refetch,
      shouldUsePreviousData: (data === null || data === void 0 ? void 0 : (_data_propertySearch1 = data.propertySearch) === null || _data_propertySearch1 === void 0 ? void 0 : (_data_propertySearch_propertySearchListings = _data_propertySearch1.propertySearchListings) === null || _data_propertySearch_propertySearchListings === void 0 ? void 0 : _data_propertySearch_propertySearchListings.length) === 0
    }, props), children));
  };
  Component.displayName = "PropertyListing".concat(WrappedComponent.displayName);
  return Component;
}
var ResultsSubHeader2 = PropertyListingComponent(ResultsSubHeader);
var ResultsHeading2 = PropertyListingComponent(ResultsHeading);
var MapTrigger2 = PropertyListingComponent(MapTriggerWrapper);
var ResultsMessagingModule2 = PropertyListingComponent(ResultsMessagingModule);
var PropertyListing2 = PropertyListingComponent(PropertyListing);
var DynamicMapWrapper2 = PropertyListingComponent(DynamicMapWrapper);
var PackageProductCardWrapper = PropertyListingComponent(PackageProductCard);
var ShoppingSearchListingHeader2 = PropertyListingComponent(ShoppingSearchListingHeader);
export { DynamicMapWrapper2 as DynamicMapWrapper, GridViewContextProvider, LineSkeletonType, MapTrigger2 as MapTrigger, OneKeyBannerToggleContext, PackageProductCard, PackageProductCardWrapper, PriceDisplayChangeOnboarding, PropertyListing2 as PropertyListing, PropertyListingExpandoCard, PropertyListingFlexibleDateSearchCard, PropertyListingHeaderMessages, PropertyListingOverfiltered, PropertyListingSoldOut, PropertyListingStandardMessagingCard, ResultsHeading2 as ResultsHeading, ResultsMessagingModule2 as ResultsMessagingModule, ResultsMessagingModuleHeading, ResultsSubHeader2 as ResultsSubHeader, ShoppingSearchListingHeader2 as ShoppingSearchListingHeader, __PropertyListingQuery, useGridViewContext }; /* istanbul ignore next -- @preserve */